/* tslint:disable */
/* eslint-disable */
/**
 * WineMS.Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface AddressDto
 */
export interface AddressDto {
    /**
     * 
     * @type {number}
     * @memberof AddressDto
     */
    addressIdNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    streetAndNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    city?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    postalCode?: string | null;
}
/**
 * 
 * @export
 * @interface ApplicationUserBaseDto
 */
export interface ApplicationUserBaseDto {
    /**
     * 
     * @type {number}
     * @memberof ApplicationUserBaseDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserBaseDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ApplicationUserBaseDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserBaseDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApplicationUserBaseDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserBaseDto
     */
    userName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserBaseDto
     */
    email?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationUserBaseDto
     */
    emailConfirmed?: boolean;
}
/**
 * 
 * @export
 * @interface ApplicationUserDetailsDto
 */
export interface ApplicationUserDetailsDto {
    /**
     * 
     * @type {number}
     * @memberof ApplicationUserDetailsDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserDetailsDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ApplicationUserDetailsDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserDetailsDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApplicationUserDetailsDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserDetailsDto
     */
    userName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserDetailsDto
     */
    email?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationUserDetailsDto
     */
    emailConfirmed?: boolean;
    /**
     * 
     * @type {Array<ApplicationUserRole>}
     * @memberof ApplicationUserDetailsDto
     */
    roles?: Array<ApplicationUserRole> | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserDetailsDto
     */
    auth0Id?: string | null;
}
/**
 * 
 * @export
 * @interface ApplicationUserDto
 */
export interface ApplicationUserDto {
    /**
     * 
     * @type {number}
     * @memberof ApplicationUserDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ApplicationUserDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApplicationUserDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserDto
     */
    userName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserDto
     */
    email?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationUserDto
     */
    emailConfirmed?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserDto
     */
    auth0Id?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationUserDto
     */
    isDeleted?: boolean;
    /**
     * 
     * @type {Array<ApplicationUserRole>}
     * @memberof ApplicationUserDto
     */
    roles?: Array<ApplicationUserRole> | null;
}
/**
 * 
 * @export
 * @interface ApplicationUserMcpDto
 */
export interface ApplicationUserMcpDto {
    /**
     * 
     * @type {number}
     * @memberof ApplicationUserMcpDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserMcpDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserMcpDto
     */
    email?: string | null;
}
/**
 * 
 * @export
 * @interface ApplicationUserMcpDtoPaginatedMcpDto
 */
export interface ApplicationUserMcpDtoPaginatedMcpDto {
    /**
     * 
     * @type {number}
     * @memberof ApplicationUserMcpDtoPaginatedMcpDto
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof ApplicationUserMcpDtoPaginatedMcpDto
     */
    pageSize?: number;
    /**
     * 
     * @type {number}
     * @memberof ApplicationUserMcpDtoPaginatedMcpDto
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<ApplicationUserMcpDto>}
     * @memberof ApplicationUserMcpDtoPaginatedMcpDto
     */
    items?: Array<ApplicationUserMcpDto> | null;
}
/**
 * 
 * @export
 * @interface ApplicationUserMinimalDto
 */
export interface ApplicationUserMinimalDto {
    /**
     * 
     * @type {number}
     * @memberof ApplicationUserMinimalDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserMinimalDto
     */
    userName?: string | null;
}
/**
 * 
 * @export
 * @interface ApplicationUserRegisterDto
 */
export interface ApplicationUserRegisterDto {
    /**
     * 
     * @type {number}
     * @memberof ApplicationUserRegisterDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserRegisterDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ApplicationUserRegisterDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserRegisterDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApplicationUserRegisterDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserRegisterDto
     */
    userName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserRegisterDto
     */
    email?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationUserRegisterDto
     */
    emailConfirmed?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserRegisterDto
     */
    password?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationUserRegisterDto
     */
    withInvitation?: boolean;
    /**
     * 
     * @type {Array<ApplicationUserRole>}
     * @memberof ApplicationUserRegisterDto
     */
    roles?: Array<ApplicationUserRole> | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserRegisterDto
     */
    auth0Id?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum ApplicationUserRole {
    Admin = 'Admin',
    UserManager = 'UserManager',
    CanReadWarehouse = 'CanReadWarehouse',
    CanUpdateContractors = 'CanUpdateContractors',
    ManageUsers = 'ManageUsers',
    ReadWarehouses = 'ReadWarehouses',
    ManageWarehouses = 'ManageWarehouses',
    ReadStock = 'ReadStock',
    ManageStock = 'ManageStock',
    ReadProducts = 'ReadProducts',
    ManageProducts = 'ManageProducts',
    ReadProduction = 'ReadProduction',
    ManageProduction = 'ManageProduction',
    ReadAnalytics = 'ReadAnalytics',
    ManageAnalytics = 'ManageAnalytics',
    ReadContractors = 'ReadContractors',
    ManageContractors = 'ManageContractors',
    ReadMeetings = 'ReadMeetings',
    ManageMeetings = 'ManageMeetings',
    ManageSettings = 'ManageSettings',
    ReadOperations = 'ReadOperations',
    ManageOperations = 'ManageOperations',
    ReadInventory = 'ReadInventory',
    ManageInventory = 'ManageInventory',
    NexoSync = 'NexoSync'
}

/**
 * 
 * @export
 * @interface ApplicationUserUpdateHistoryCreateDto
 */
export interface ApplicationUserUpdateHistoryCreateDto {
    /**
     * 
     * @type {number}
     * @memberof ApplicationUserUpdateHistoryCreateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserUpdateHistoryCreateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ApplicationUserUpdateHistoryCreateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserUpdateHistoryCreateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApplicationUserUpdateHistoryCreateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserUpdateHistoryCreateDto
     */
    oldValue?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserUpdateHistoryCreateDto
     */
    newValue?: string | null;
    /**
     * 
     * @type {OperationType}
     * @memberof ApplicationUserUpdateHistoryCreateDto
     */
    operationType?: OperationType;
    /**
     * 
     * @type {ApplicationUserDto}
     * @memberof ApplicationUserUpdateHistoryCreateDto
     */
    createdBy?: ApplicationUserDto;
    /**
     * 
     * @type {number}
     * @memberof ApplicationUserUpdateHistoryCreateDto
     */
    applicationUserId?: number;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserUpdateHistoryCreateDto
     */
    translatedChangedValueName?: string | null;
}
/**
 * 
 * @export
 * @interface ApplicationUserUpdateHistoryDetailsDto
 */
export interface ApplicationUserUpdateHistoryDetailsDto {
    /**
     * 
     * @type {number}
     * @memberof ApplicationUserUpdateHistoryDetailsDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserUpdateHistoryDetailsDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ApplicationUserUpdateHistoryDetailsDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserUpdateHistoryDetailsDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApplicationUserUpdateHistoryDetailsDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserUpdateHistoryDetailsDto
     */
    oldValue?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserUpdateHistoryDetailsDto
     */
    newValue?: string | null;
    /**
     * 
     * @type {OperationType}
     * @memberof ApplicationUserUpdateHistoryDetailsDto
     */
    operationType?: OperationType;
    /**
     * 
     * @type {ApplicationUserDto}
     * @memberof ApplicationUserUpdateHistoryDetailsDto
     */
    createdBy?: ApplicationUserDto;
    /**
     * 
     * @type {number}
     * @memberof ApplicationUserUpdateHistoryDetailsDto
     */
    applicationUserId?: number;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserUpdateHistoryDetailsDto
     */
    translatedChangedValueName?: string | null;
}
/**
 * 
 * @export
 * @interface ApplicationUserUpdateHistoryDto
 */
export interface ApplicationUserUpdateHistoryDto {
    /**
     * 
     * @type {number}
     * @memberof ApplicationUserUpdateHistoryDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserUpdateHistoryDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ApplicationUserUpdateHistoryDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserUpdateHistoryDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApplicationUserUpdateHistoryDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserUpdateHistoryDto
     */
    oldValue?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserUpdateHistoryDto
     */
    newValue?: string | null;
    /**
     * 
     * @type {OperationType}
     * @memberof ApplicationUserUpdateHistoryDto
     */
    operationType?: OperationType;
    /**
     * 
     * @type {ApplicationUserDto}
     * @memberof ApplicationUserUpdateHistoryDto
     */
    createdBy?: ApplicationUserDto;
    /**
     * 
     * @type {number}
     * @memberof ApplicationUserUpdateHistoryDto
     */
    applicationUserId?: number;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserUpdateHistoryDto
     */
    translatedChangedValueName?: string | null;
}
/**
 * 
 * @export
 * @interface ApplicationUserUpdateHistoryUpdateDto
 */
export interface ApplicationUserUpdateHistoryUpdateDto {
    /**
     * 
     * @type {number}
     * @memberof ApplicationUserUpdateHistoryUpdateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserUpdateHistoryUpdateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ApplicationUserUpdateHistoryUpdateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserUpdateHistoryUpdateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApplicationUserUpdateHistoryUpdateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserUpdateHistoryUpdateDto
     */
    oldValue?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserUpdateHistoryUpdateDto
     */
    newValue?: string | null;
    /**
     * 
     * @type {OperationType}
     * @memberof ApplicationUserUpdateHistoryUpdateDto
     */
    operationType?: OperationType;
    /**
     * 
     * @type {ApplicationUserDto}
     * @memberof ApplicationUserUpdateHistoryUpdateDto
     */
    createdBy?: ApplicationUserDto;
    /**
     * 
     * @type {number}
     * @memberof ApplicationUserUpdateHistoryUpdateDto
     */
    applicationUserId?: number;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserUpdateHistoryUpdateDto
     */
    translatedChangedValueName?: string | null;
}
/**
 * 
 * @export
 * @interface BatchNumberCreateDto
 */
export interface BatchNumberCreateDto {
    /**
     * 
     * @type {number}
     * @memberof BatchNumberCreateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof BatchNumberCreateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof BatchNumberCreateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof BatchNumberCreateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof BatchNumberCreateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof BatchNumberCreateDto
     */
    number?: string | null;
    /**
     * 
     * @type {number}
     * @memberof BatchNumberCreateDto
     */
    unitId?: number;
    /**
     * 
     * @type {number}
     * @memberof BatchNumberCreateDto
     */
    quantity?: number;
}
/**
 * 
 * @export
 * @interface BatchNumberDto
 */
export interface BatchNumberDto {
    /**
     * 
     * @type {number}
     * @memberof BatchNumberDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof BatchNumberDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof BatchNumberDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof BatchNumberDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof BatchNumberDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof BatchNumberDto
     */
    number?: string | null;
    /**
     * 
     * @type {number}
     * @memberof BatchNumberDto
     */
    unitId?: number;
    /**
     * 
     * @type {UnitOfMeasureDto}
     * @memberof BatchNumberDto
     */
    unit?: UnitOfMeasureDto;
    /**
     * 
     * @type {number}
     * @memberof BatchNumberDto
     */
    quantity?: number;
}
/**
 * 
 * @export
 * @interface CompanyDataCreateDto
 */
export interface CompanyDataCreateDto {
    /**
     * 
     * @type {number}
     * @memberof CompanyDataCreateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataCreateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof CompanyDataCreateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataCreateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CompanyDataCreateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataCreateDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataCreateDto
     */
    address?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataCreateDto
     */
    addressLine2?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataCreateDto
     */
    postalCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataCreateDto
     */
    city?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataCreateDto
     */
    taxIdentificationNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataCreateDto
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataCreateDto
     */
    phoneNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataCreateDto
     */
    bankAccountNumber?: string | null;
}
/**
 * 
 * @export
 * @interface CompanyDataDetailsDto
 */
export interface CompanyDataDetailsDto {
    /**
     * 
     * @type {number}
     * @memberof CompanyDataDetailsDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataDetailsDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof CompanyDataDetailsDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataDetailsDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CompanyDataDetailsDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataDetailsDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataDetailsDto
     */
    address?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataDetailsDto
     */
    addressLine2?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataDetailsDto
     */
    postalCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataDetailsDto
     */
    city?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataDetailsDto
     */
    taxIdentificationNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataDetailsDto
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataDetailsDto
     */
    phoneNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataDetailsDto
     */
    bankAccountNumber?: string | null;
}
/**
 * 
 * @export
 * @interface CompanyDataDto
 */
export interface CompanyDataDto {
    /**
     * 
     * @type {number}
     * @memberof CompanyDataDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof CompanyDataDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CompanyDataDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataDto
     */
    address?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataDto
     */
    addressLine2?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataDto
     */
    postalCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataDto
     */
    city?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataDto
     */
    taxIdentificationNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataDto
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataDto
     */
    phoneNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataDto
     */
    bankAccountNumber?: string | null;
}
/**
 * 
 * @export
 * @interface CompanyDataMcpDto
 */
export interface CompanyDataMcpDto {
    /**
     * 
     * @type {number}
     * @memberof CompanyDataMcpDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataMcpDto
     */
    companyName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataMcpDto
     */
    nip?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataMcpDto
     */
    address?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataMcpDto
     */
    addressLine2?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataMcpDto
     */
    city?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataMcpDto
     */
    postalCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataMcpDto
     */
    emailAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataMcpDto
     */
    phoneNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataMcpDto
     */
    bankAccountNumber?: string | null;
}
/**
 * 
 * @export
 * @interface CompanyDataMcpDtoPaginatedMcpDto
 */
export interface CompanyDataMcpDtoPaginatedMcpDto {
    /**
     * 
     * @type {number}
     * @memberof CompanyDataMcpDtoPaginatedMcpDto
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof CompanyDataMcpDtoPaginatedMcpDto
     */
    pageSize?: number;
    /**
     * 
     * @type {number}
     * @memberof CompanyDataMcpDtoPaginatedMcpDto
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<CompanyDataMcpDto>}
     * @memberof CompanyDataMcpDtoPaginatedMcpDto
     */
    items?: Array<CompanyDataMcpDto> | null;
}
/**
 * 
 * @export
 * @interface CompanyDataMinimalDto
 */
export interface CompanyDataMinimalDto {
    /**
     * 
     * @type {number}
     * @memberof CompanyDataMinimalDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataMinimalDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof CompanyDataMinimalDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataMinimalDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CompanyDataMinimalDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataMinimalDto
     */
    name?: string | null;
}
/**
 * 
 * @export
 * @interface CompanyDataUpdateDto
 */
export interface CompanyDataUpdateDto {
    /**
     * 
     * @type {number}
     * @memberof CompanyDataUpdateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataUpdateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof CompanyDataUpdateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataUpdateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CompanyDataUpdateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataUpdateDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataUpdateDto
     */
    address?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataUpdateDto
     */
    addressLine2?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataUpdateDto
     */
    postalCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataUpdateDto
     */
    city?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataUpdateDto
     */
    taxIdentificationNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataUpdateDto
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataUpdateDto
     */
    phoneNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataUpdateDto
     */
    bankAccountNumber?: string | null;
}
/**
 * 
 * @export
 * @interface CompanyDataUpdateHistoryCreateDto
 */
export interface CompanyDataUpdateHistoryCreateDto {
    /**
     * 
     * @type {number}
     * @memberof CompanyDataUpdateHistoryCreateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataUpdateHistoryCreateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof CompanyDataUpdateHistoryCreateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataUpdateHistoryCreateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CompanyDataUpdateHistoryCreateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataUpdateHistoryCreateDto
     */
    oldValue?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataUpdateHistoryCreateDto
     */
    newValue?: string | null;
    /**
     * 
     * @type {OperationType}
     * @memberof CompanyDataUpdateHistoryCreateDto
     */
    operationType?: OperationType;
    /**
     * 
     * @type {ApplicationUserDto}
     * @memberof CompanyDataUpdateHistoryCreateDto
     */
    createdBy?: ApplicationUserDto;
    /**
     * 
     * @type {number}
     * @memberof CompanyDataUpdateHistoryCreateDto
     */
    companyDataId?: number;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataUpdateHistoryCreateDto
     */
    translatedChangedValueName?: string | null;
}
/**
 * 
 * @export
 * @interface CompanyDataUpdateHistoryDetailsDto
 */
export interface CompanyDataUpdateHistoryDetailsDto {
    /**
     * 
     * @type {number}
     * @memberof CompanyDataUpdateHistoryDetailsDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataUpdateHistoryDetailsDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof CompanyDataUpdateHistoryDetailsDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataUpdateHistoryDetailsDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CompanyDataUpdateHistoryDetailsDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataUpdateHistoryDetailsDto
     */
    oldValue?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataUpdateHistoryDetailsDto
     */
    newValue?: string | null;
    /**
     * 
     * @type {OperationType}
     * @memberof CompanyDataUpdateHistoryDetailsDto
     */
    operationType?: OperationType;
    /**
     * 
     * @type {ApplicationUserDto}
     * @memberof CompanyDataUpdateHistoryDetailsDto
     */
    createdBy?: ApplicationUserDto;
    /**
     * 
     * @type {number}
     * @memberof CompanyDataUpdateHistoryDetailsDto
     */
    companyDataId?: number;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataUpdateHistoryDetailsDto
     */
    translatedChangedValueName?: string | null;
}
/**
 * 
 * @export
 * @interface CompanyDataUpdateHistoryDto
 */
export interface CompanyDataUpdateHistoryDto {
    /**
     * 
     * @type {number}
     * @memberof CompanyDataUpdateHistoryDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataUpdateHistoryDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof CompanyDataUpdateHistoryDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataUpdateHistoryDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CompanyDataUpdateHistoryDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataUpdateHistoryDto
     */
    oldValue?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataUpdateHistoryDto
     */
    newValue?: string | null;
    /**
     * 
     * @type {OperationType}
     * @memberof CompanyDataUpdateHistoryDto
     */
    operationType?: OperationType;
    /**
     * 
     * @type {ApplicationUserDto}
     * @memberof CompanyDataUpdateHistoryDto
     */
    createdBy?: ApplicationUserDto;
    /**
     * 
     * @type {number}
     * @memberof CompanyDataUpdateHistoryDto
     */
    companyDataId?: number;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataUpdateHistoryDto
     */
    translatedChangedValueName?: string | null;
}
/**
 * 
 * @export
 * @interface CompanyDataUpdateHistoryUpdateDto
 */
export interface CompanyDataUpdateHistoryUpdateDto {
    /**
     * 
     * @type {number}
     * @memberof CompanyDataUpdateHistoryUpdateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataUpdateHistoryUpdateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof CompanyDataUpdateHistoryUpdateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataUpdateHistoryUpdateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CompanyDataUpdateHistoryUpdateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataUpdateHistoryUpdateDto
     */
    oldValue?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataUpdateHistoryUpdateDto
     */
    newValue?: string | null;
    /**
     * 
     * @type {OperationType}
     * @memberof CompanyDataUpdateHistoryUpdateDto
     */
    operationType?: OperationType;
    /**
     * 
     * @type {ApplicationUserDto}
     * @memberof CompanyDataUpdateHistoryUpdateDto
     */
    createdBy?: ApplicationUserDto;
    /**
     * 
     * @type {number}
     * @memberof CompanyDataUpdateHistoryUpdateDto
     */
    companyDataId?: number;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataUpdateHistoryUpdateDto
     */
    translatedChangedValueName?: string | null;
}
/**
 * 
 * @export
 * @interface ContractorCreateDto
 */
export interface ContractorCreateDto {
    /**
     * 
     * @type {number}
     * @memberof ContractorCreateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ContractorCreateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ContractorCreateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ContractorCreateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ContractorCreateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ContractorCreateDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractorCreateDto
     */
    nip?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractorCreateDto
     */
    phoneNumber?: string | null;
    /**
     * 
     * @type {Array<PhoneNumberDto>}
     * @memberof ContractorCreateDto
     */
    phoneNumbers?: Array<PhoneNumberDto> | null;
    /**
     * 
     * @type {string}
     * @memberof ContractorCreateDto
     */
    emailAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractorCreateDto
     */
    note?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ContractorCreateDto
     */
    isDeleted?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ContractorCreateDto
     */
    pipedriveOrganizationId?: number | null;
    /**
     * 
     * @type {AddressDto}
     * @memberof ContractorCreateDto
     */
    mainAddress?: AddressDto;
    /**
     * 
     * @type {Array<AddressDto>}
     * @memberof ContractorCreateDto
     */
    addresses?: Array<AddressDto> | null;
    /**
     * 
     * @type {number}
     * @memberof ContractorCreateDto
     */
    merchantId?: number | null;
    /**
     * 
     * @type {ApplicationUserDto}
     * @memberof ContractorCreateDto
     */
    merchant?: ApplicationUserDto;
}
/**
 * 
 * @export
 * @interface ContractorDetailsDto
 */
export interface ContractorDetailsDto {
    /**
     * 
     * @type {number}
     * @memberof ContractorDetailsDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ContractorDetailsDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ContractorDetailsDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ContractorDetailsDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ContractorDetailsDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ContractorDetailsDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractorDetailsDto
     */
    nip?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractorDetailsDto
     */
    phoneNumber?: string | null;
    /**
     * 
     * @type {Array<PhoneNumberDto>}
     * @memberof ContractorDetailsDto
     */
    phoneNumbers?: Array<PhoneNumberDto> | null;
    /**
     * 
     * @type {string}
     * @memberof ContractorDetailsDto
     */
    emailAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractorDetailsDto
     */
    note?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ContractorDetailsDto
     */
    isDeleted?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ContractorDetailsDto
     */
    pipedriveOrganizationId?: number | null;
    /**
     * 
     * @type {AddressDto}
     * @memberof ContractorDetailsDto
     */
    mainAddress?: AddressDto;
    /**
     * 
     * @type {Array<AddressDto>}
     * @memberof ContractorDetailsDto
     */
    addresses?: Array<AddressDto> | null;
    /**
     * 
     * @type {number}
     * @memberof ContractorDetailsDto
     */
    merchantId?: number | null;
    /**
     * 
     * @type {ApplicationUserDto}
     * @memberof ContractorDetailsDto
     */
    merchant?: ApplicationUserDto;
    /**
     * 
     * @type {Array<StockOperationMinimalDto>}
     * @memberof ContractorDetailsDto
     */
    stockOperations?: Array<StockOperationMinimalDto> | null;
}
/**
 * 
 * @export
 * @interface ContractorDto
 */
export interface ContractorDto {
    /**
     * 
     * @type {number}
     * @memberof ContractorDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ContractorDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ContractorDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ContractorDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ContractorDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ContractorDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractorDto
     */
    nip?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractorDto
     */
    phoneNumber?: string | null;
    /**
     * 
     * @type {Array<PhoneNumberDto>}
     * @memberof ContractorDto
     */
    phoneNumbers?: Array<PhoneNumberDto> | null;
    /**
     * 
     * @type {string}
     * @memberof ContractorDto
     */
    emailAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractorDto
     */
    note?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ContractorDto
     */
    isDeleted?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ContractorDto
     */
    pipedriveOrganizationId?: number | null;
    /**
     * 
     * @type {AddressDto}
     * @memberof ContractorDto
     */
    mainAddress?: AddressDto;
    /**
     * 
     * @type {Array<AddressDto>}
     * @memberof ContractorDto
     */
    addresses?: Array<AddressDto> | null;
    /**
     * 
     * @type {number}
     * @memberof ContractorDto
     */
    merchantId?: number | null;
    /**
     * 
     * @type {ApplicationUserDto}
     * @memberof ContractorDto
     */
    merchant?: ApplicationUserDto;
}
/**
 * 
 * @export
 * @interface ContractorMcpDto
 */
export interface ContractorMcpDto {
    /**
     * 
     * @type {number}
     * @memberof ContractorMcpDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ContractorMcpDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractorMcpDto
     */
    nip?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractorMcpDto
     */
    phoneNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractorMcpDto
     */
    emailAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractorMcpDto
     */
    note?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ContractorMcpDto
     */
    isDeleted?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ContractorMcpDto
     */
    merchantId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ContractorMcpDto
     */
    merchantName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractorMcpDto
     */
    mainAddressStreet?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractorMcpDto
     */
    mainAddressCity?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractorMcpDto
     */
    mainAddressPostalCode?: string | null;
}
/**
 * 
 * @export
 * @interface ContractorMcpDtoPaginatedMcpDto
 */
export interface ContractorMcpDtoPaginatedMcpDto {
    /**
     * 
     * @type {number}
     * @memberof ContractorMcpDtoPaginatedMcpDto
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof ContractorMcpDtoPaginatedMcpDto
     */
    pageSize?: number;
    /**
     * 
     * @type {number}
     * @memberof ContractorMcpDtoPaginatedMcpDto
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<ContractorMcpDto>}
     * @memberof ContractorMcpDtoPaginatedMcpDto
     */
    items?: Array<ContractorMcpDto> | null;
}
/**
 * 
 * @export
 * @interface ContractorUpdateDto
 */
export interface ContractorUpdateDto {
    /**
     * 
     * @type {number}
     * @memberof ContractorUpdateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ContractorUpdateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ContractorUpdateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ContractorUpdateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ContractorUpdateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ContractorUpdateDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractorUpdateDto
     */
    nip?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractorUpdateDto
     */
    phoneNumber?: string | null;
    /**
     * 
     * @type {Array<PhoneNumberDto>}
     * @memberof ContractorUpdateDto
     */
    phoneNumbers?: Array<PhoneNumberDto> | null;
    /**
     * 
     * @type {string}
     * @memberof ContractorUpdateDto
     */
    emailAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractorUpdateDto
     */
    note?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ContractorUpdateDto
     */
    isDeleted?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ContractorUpdateDto
     */
    pipedriveOrganizationId?: number | null;
    /**
     * 
     * @type {AddressDto}
     * @memberof ContractorUpdateDto
     */
    mainAddress?: AddressDto;
    /**
     * 
     * @type {Array<AddressDto>}
     * @memberof ContractorUpdateDto
     */
    addresses?: Array<AddressDto> | null;
    /**
     * 
     * @type {number}
     * @memberof ContractorUpdateDto
     */
    merchantId?: number | null;
    /**
     * 
     * @type {ApplicationUserDto}
     * @memberof ContractorUpdateDto
     */
    merchant?: ApplicationUserDto;
}
/**
 * 
 * @export
 * @interface ContractorUpdateHistoryCreateDto
 */
export interface ContractorUpdateHistoryCreateDto {
    /**
     * 
     * @type {number}
     * @memberof ContractorUpdateHistoryCreateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ContractorUpdateHistoryCreateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ContractorUpdateHistoryCreateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ContractorUpdateHistoryCreateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ContractorUpdateHistoryCreateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ContractorUpdateHistoryCreateDto
     */
    oldValue?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractorUpdateHistoryCreateDto
     */
    newValue?: string | null;
    /**
     * 
     * @type {OperationType}
     * @memberof ContractorUpdateHistoryCreateDto
     */
    operationType?: OperationType;
    /**
     * 
     * @type {ApplicationUserDto}
     * @memberof ContractorUpdateHistoryCreateDto
     */
    createdBy?: ApplicationUserDto;
    /**
     * 
     * @type {number}
     * @memberof ContractorUpdateHistoryCreateDto
     */
    contractorId?: number;
    /**
     * 
     * @type {string}
     * @memberof ContractorUpdateHistoryCreateDto
     */
    translatedChangedValueName?: string | null;
}
/**
 * 
 * @export
 * @interface ContractorUpdateHistoryDetailsDto
 */
export interface ContractorUpdateHistoryDetailsDto {
    /**
     * 
     * @type {number}
     * @memberof ContractorUpdateHistoryDetailsDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ContractorUpdateHistoryDetailsDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ContractorUpdateHistoryDetailsDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ContractorUpdateHistoryDetailsDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ContractorUpdateHistoryDetailsDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ContractorUpdateHistoryDetailsDto
     */
    oldValue?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractorUpdateHistoryDetailsDto
     */
    newValue?: string | null;
    /**
     * 
     * @type {OperationType}
     * @memberof ContractorUpdateHistoryDetailsDto
     */
    operationType?: OperationType;
    /**
     * 
     * @type {ApplicationUserDto}
     * @memberof ContractorUpdateHistoryDetailsDto
     */
    createdBy?: ApplicationUserDto;
    /**
     * 
     * @type {number}
     * @memberof ContractorUpdateHistoryDetailsDto
     */
    contractorId?: number;
    /**
     * 
     * @type {string}
     * @memberof ContractorUpdateHistoryDetailsDto
     */
    translatedChangedValueName?: string | null;
}
/**
 * 
 * @export
 * @interface ContractorUpdateHistoryDto
 */
export interface ContractorUpdateHistoryDto {
    /**
     * 
     * @type {number}
     * @memberof ContractorUpdateHistoryDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ContractorUpdateHistoryDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ContractorUpdateHistoryDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ContractorUpdateHistoryDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ContractorUpdateHistoryDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ContractorUpdateHistoryDto
     */
    oldValue?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractorUpdateHistoryDto
     */
    newValue?: string | null;
    /**
     * 
     * @type {OperationType}
     * @memberof ContractorUpdateHistoryDto
     */
    operationType?: OperationType;
    /**
     * 
     * @type {ApplicationUserDto}
     * @memberof ContractorUpdateHistoryDto
     */
    createdBy?: ApplicationUserDto;
    /**
     * 
     * @type {number}
     * @memberof ContractorUpdateHistoryDto
     */
    contractorId?: number;
    /**
     * 
     * @type {string}
     * @memberof ContractorUpdateHistoryDto
     */
    translatedChangedValueName?: string | null;
}
/**
 * 
 * @export
 * @interface ContractorUpdateHistoryUpdateDto
 */
export interface ContractorUpdateHistoryUpdateDto {
    /**
     * 
     * @type {number}
     * @memberof ContractorUpdateHistoryUpdateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ContractorUpdateHistoryUpdateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ContractorUpdateHistoryUpdateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ContractorUpdateHistoryUpdateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ContractorUpdateHistoryUpdateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ContractorUpdateHistoryUpdateDto
     */
    oldValue?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractorUpdateHistoryUpdateDto
     */
    newValue?: string | null;
    /**
     * 
     * @type {OperationType}
     * @memberof ContractorUpdateHistoryUpdateDto
     */
    operationType?: OperationType;
    /**
     * 
     * @type {ApplicationUserDto}
     * @memberof ContractorUpdateHistoryUpdateDto
     */
    createdBy?: ApplicationUserDto;
    /**
     * 
     * @type {number}
     * @memberof ContractorUpdateHistoryUpdateDto
     */
    contractorId?: number;
    /**
     * 
     * @type {string}
     * @memberof ContractorUpdateHistoryUpdateDto
     */
    translatedChangedValueName?: string | null;
}
/**
 * 
 * @export
 * @interface CropCreateDto
 */
export interface CropCreateDto {
    /**
     * 
     * @type {number}
     * @memberof CropCreateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CropCreateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof CropCreateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof CropCreateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CropCreateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CropCreateDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CropCreateDto
     */
    description?: string | null;
    /**
     * 
     * @type {Array<CropStrainDto>}
     * @memberof CropCreateDto
     */
    cropStrains?: Array<CropStrainDto> | null;
}
/**
 * 
 * @export
 * @interface CropDetailsDto
 */
export interface CropDetailsDto {
    /**
     * 
     * @type {number}
     * @memberof CropDetailsDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CropDetailsDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof CropDetailsDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof CropDetailsDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CropDetailsDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CropDetailsDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CropDetailsDto
     */
    description?: string | null;
    /**
     * 
     * @type {Array<CropStrainPlantCountDto>}
     * @memberof CropDetailsDto
     */
    cropStrains?: Array<CropStrainPlantCountDto> | null;
    /**
     * 
     * @type {Array<StockOperationDto>}
     * @memberof CropDetailsDto
     */
    stockOperations?: Array<StockOperationDto> | null;
}
/**
 * 
 * @export
 * @interface CropDto
 */
export interface CropDto {
    /**
     * 
     * @type {number}
     * @memberof CropDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CropDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof CropDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof CropDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CropDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CropDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CropDto
     */
    description?: string | null;
}
/**
 * 
 * @export
 * @interface CropMcpDto
 */
export interface CropMcpDto {
    /**
     * 
     * @type {number}
     * @memberof CropMcpDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CropMcpDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CropMcpDto
     */
    description?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CropMcpDto
     */
    isDeleted?: boolean;
}
/**
 * 
 * @export
 * @interface CropMcpDtoPaginatedMcpDto
 */
export interface CropMcpDtoPaginatedMcpDto {
    /**
     * 
     * @type {number}
     * @memberof CropMcpDtoPaginatedMcpDto
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof CropMcpDtoPaginatedMcpDto
     */
    pageSize?: number;
    /**
     * 
     * @type {number}
     * @memberof CropMcpDtoPaginatedMcpDto
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<CropMcpDto>}
     * @memberof CropMcpDtoPaginatedMcpDto
     */
    items?: Array<CropMcpDto> | null;
}
/**
 * 
 * @export
 * @interface CropStrainDto
 */
export interface CropStrainDto {
    /**
     * 
     * @type {number}
     * @memberof CropStrainDto
     */
    cropId?: number;
    /**
     * 
     * @type {CropDto}
     * @memberof CropStrainDto
     */
    crop?: CropDto;
    /**
     * 
     * @type {number}
     * @memberof CropStrainDto
     */
    strainId?: number;
    /**
     * 
     * @type {StrainDto}
     * @memberof CropStrainDto
     */
    strain?: StrainDto;
    /**
     * 
     * @type {number}
     * @memberof CropStrainDto
     */
    plantCount?: number;
}
/**
 * 
 * @export
 * @interface CropStrainMinimalDto
 */
export interface CropStrainMinimalDto {
    /**
     * 
     * @type {number}
     * @memberof CropStrainMinimalDto
     */
    cropId?: number;
    /**
     * 
     * @type {number}
     * @memberof CropStrainMinimalDto
     */
    strainId?: number;
    /**
     * 
     * @type {number}
     * @memberof CropStrainMinimalDto
     */
    plantCount?: number;
}
/**
 * 
 * @export
 * @interface CropStrainPlantCountDto
 */
export interface CropStrainPlantCountDto {
    /**
     * 
     * @type {number}
     * @memberof CropStrainPlantCountDto
     */
    cropId?: number;
    /**
     * 
     * @type {number}
     * @memberof CropStrainPlantCountDto
     */
    strainId?: number;
    /**
     * 
     * @type {StrainDto}
     * @memberof CropStrainPlantCountDto
     */
    strain?: StrainDto;
    /**
     * 
     * @type {number}
     * @memberof CropStrainPlantCountDto
     */
    plantCount?: number;
}
/**
 * 
 * @export
 * @interface CropUpdateDto
 */
export interface CropUpdateDto {
    /**
     * 
     * @type {number}
     * @memberof CropUpdateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CropUpdateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof CropUpdateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof CropUpdateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CropUpdateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CropUpdateDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CropUpdateDto
     */
    description?: string | null;
    /**
     * 
     * @type {Array<CropStrainMinimalDto>}
     * @memberof CropUpdateDto
     */
    cropStrains?: Array<CropStrainMinimalDto> | null;
}
/**
 * 
 * @export
 * @interface InventoryOperationCreateDto
 */
export interface InventoryOperationCreateDto {
    /**
     * 
     * @type {number}
     * @memberof InventoryOperationCreateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof InventoryOperationCreateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof InventoryOperationCreateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof InventoryOperationCreateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof InventoryOperationCreateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {number}
     * @memberof InventoryOperationCreateDto
     */
    warehouseId?: number;
    /**
     * 
     * @type {WarehouseDto}
     * @memberof InventoryOperationCreateDto
     */
    warehouse?: WarehouseDto;
    /**
     * 
     * @type {string}
     * @memberof InventoryOperationCreateDto
     */
    date?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryOperationCreateDto
     */
    publicationDate?: string | null;
    /**
     * 
     * @type {Array<InventoryOperationDetailDto>}
     * @memberof InventoryOperationCreateDto
     */
    inventoryOperationDetails?: Array<InventoryOperationDetailDto> | null;
    /**
     * 
     * @type {number}
     * @memberof InventoryOperationCreateDto
     */
    stockOperationId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof InventoryOperationCreateDto
     */
    documentNumber?: string | null;
}
/**
 * 
 * @export
 * @interface InventoryOperationDetailDto
 */
export interface InventoryOperationDetailDto {
    /**
     * 
     * @type {string}
     * @memberof InventoryOperationDetailDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof InventoryOperationDetailDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof InventoryOperationDetailDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof InventoryOperationDetailDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {number}
     * @memberof InventoryOperationDetailDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof InventoryOperationDetailDto
     */
    inventoryOperationId?: number;
    /**
     * 
     * @type {number}
     * @memberof InventoryOperationDetailDto
     */
    productId?: number;
    /**
     * 
     * @type {string}
     * @memberof InventoryOperationDetailDto
     */
    batchNumber?: string | null;
    /**
     * 
     * @type {number}
     * @memberof InventoryOperationDetailDto
     */
    unitId?: number;
    /**
     * 
     * @type {number}
     * @memberof InventoryOperationDetailDto
     */
    quantity?: number;
}
/**
 * 
 * @export
 * @interface InventoryOperationDetailsDto
 */
export interface InventoryOperationDetailsDto {
    /**
     * 
     * @type {number}
     * @memberof InventoryOperationDetailsDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof InventoryOperationDetailsDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof InventoryOperationDetailsDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof InventoryOperationDetailsDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof InventoryOperationDetailsDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {number}
     * @memberof InventoryOperationDetailsDto
     */
    warehouseId?: number;
    /**
     * 
     * @type {WarehouseDto}
     * @memberof InventoryOperationDetailsDto
     */
    warehouse?: WarehouseDto;
    /**
     * 
     * @type {string}
     * @memberof InventoryOperationDetailsDto
     */
    date?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryOperationDetailsDto
     */
    publicationDate?: string | null;
    /**
     * 
     * @type {Array<InventoryOperationDetailDto>}
     * @memberof InventoryOperationDetailsDto
     */
    inventoryOperationDetails?: Array<InventoryOperationDetailDto> | null;
    /**
     * 
     * @type {number}
     * @memberof InventoryOperationDetailsDto
     */
    stockOperationId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof InventoryOperationDetailsDto
     */
    documentNumber?: string | null;
}
/**
 * 
 * @export
 * @interface InventoryOperationDto
 */
export interface InventoryOperationDto {
    /**
     * 
     * @type {number}
     * @memberof InventoryOperationDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof InventoryOperationDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof InventoryOperationDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof InventoryOperationDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof InventoryOperationDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {number}
     * @memberof InventoryOperationDto
     */
    warehouseId?: number;
    /**
     * 
     * @type {WarehouseDto}
     * @memberof InventoryOperationDto
     */
    warehouse?: WarehouseDto;
    /**
     * 
     * @type {string}
     * @memberof InventoryOperationDto
     */
    date?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryOperationDto
     */
    publicationDate?: string | null;
    /**
     * 
     * @type {Array<InventoryOperationDetailDto>}
     * @memberof InventoryOperationDto
     */
    inventoryOperationDetails?: Array<InventoryOperationDetailDto> | null;
    /**
     * 
     * @type {number}
     * @memberof InventoryOperationDto
     */
    stockOperationId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof InventoryOperationDto
     */
    documentNumber?: string | null;
}
/**
 * 
 * @export
 * @interface InventoryOperationMcpDto
 */
export interface InventoryOperationMcpDto {
    /**
     * 
     * @type {number}
     * @memberof InventoryOperationMcpDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof InventoryOperationMcpDto
     */
    productId?: number;
    /**
     * 
     * @type {string}
     * @memberof InventoryOperationMcpDto
     */
    productName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof InventoryOperationMcpDto
     */
    warehouseId?: number;
    /**
     * 
     * @type {string}
     * @memberof InventoryOperationMcpDto
     */
    warehouseName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof InventoryOperationMcpDto
     */
    unitId?: number;
    /**
     * 
     * @type {string}
     * @memberof InventoryOperationMcpDto
     */
    unitName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof InventoryOperationMcpDto
     */
    quantity?: number;
    /**
     * 
     * @type {string}
     * @memberof InventoryOperationMcpDto
     */
    date?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InventoryOperationMcpDto
     */
    documentNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InventoryOperationMcpDto
     */
    batchNumber?: string | null;
}
/**
 * 
 * @export
 * @interface InventoryOperationMcpDtoPaginatedMcpDto
 */
export interface InventoryOperationMcpDtoPaginatedMcpDto {
    /**
     * 
     * @type {number}
     * @memberof InventoryOperationMcpDtoPaginatedMcpDto
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof InventoryOperationMcpDtoPaginatedMcpDto
     */
    pageSize?: number;
    /**
     * 
     * @type {number}
     * @memberof InventoryOperationMcpDtoPaginatedMcpDto
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<InventoryOperationMcpDto>}
     * @memberof InventoryOperationMcpDtoPaginatedMcpDto
     */
    items?: Array<InventoryOperationMcpDto> | null;
}
/**
 * 
 * @export
 * @interface InventoryOperationUpdateDto
 */
export interface InventoryOperationUpdateDto {
    /**
     * 
     * @type {number}
     * @memberof InventoryOperationUpdateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof InventoryOperationUpdateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof InventoryOperationUpdateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof InventoryOperationUpdateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof InventoryOperationUpdateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {number}
     * @memberof InventoryOperationUpdateDto
     */
    warehouseId?: number;
    /**
     * 
     * @type {WarehouseDto}
     * @memberof InventoryOperationUpdateDto
     */
    warehouse?: WarehouseDto;
    /**
     * 
     * @type {string}
     * @memberof InventoryOperationUpdateDto
     */
    date?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryOperationUpdateDto
     */
    publicationDate?: string | null;
    /**
     * 
     * @type {Array<InventoryOperationDetailDto>}
     * @memberof InventoryOperationUpdateDto
     */
    inventoryOperationDetails?: Array<InventoryOperationDetailDto> | null;
    /**
     * 
     * @type {number}
     * @memberof InventoryOperationUpdateDto
     */
    stockOperationId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof InventoryOperationUpdateDto
     */
    documentNumber?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof InventoryOperationUpdateDto
     */
    isDeleted?: boolean;
}
/**
 * 
 * @export
 * @interface InvoicePreviewDto
 */
export interface InvoicePreviewDto {
    /**
     * 
     * @type {string}
     * @memberof InvoicePreviewDto
     */
    number?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvoicePreviewDto
     */
    date?: string;
    /**
     * 
     * @type {string}
     * @memberof InvoicePreviewDto
     */
    requestId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvoicePreviewDto
     */
    contractorName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvoicePreviewDto
     */
    contractorNip?: string | null;
    /**
     * 
     * @type {number}
     * @memberof InvoicePreviewDto
     */
    netValue?: number;
    /**
     * 
     * @type {number}
     * @memberof InvoicePreviewDto
     */
    vatValue?: number;
    /**
     * 
     * @type {number}
     * @memberof InvoicePreviewDto
     */
    grossValue?: number;
    /**
     * 
     * @type {Array<InvoiceRowPreviewDto>}
     * @memberof InvoicePreviewDto
     */
    rows?: Array<InvoiceRowPreviewDto> | null;
}
/**
 * 
 * @export
 * @interface InvoiceRowPreviewDto
 */
export interface InvoiceRowPreviewDto {
    /**
     * 
     * @type {string}
     * @memberof InvoiceRowPreviewDto
     */
    symbol?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvoiceRowPreviewDto
     */
    name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof InvoiceRowPreviewDto
     */
    quantity?: number;
    /**
     * 
     * @type {string}
     * @memberof InvoiceRowPreviewDto
     */
    unit?: string | null;
    /**
     * 
     * @type {number}
     * @memberof InvoiceRowPreviewDto
     */
    netPrice?: number;
    /**
     * 
     * @type {number}
     * @memberof InvoiceRowPreviewDto
     */
    vatRate?: number;
    /**
     * 
     * @type {number}
     * @memberof InvoiceRowPreviewDto
     */
    netValue?: number;
    /**
     * 
     * @type {number}
     * @memberof InvoiceRowPreviewDto
     */
    grossValue?: number;
}
/**
 * 
 * @export
 * @interface JsonNode
 */
export interface JsonNode {
    /**
     * 
     * @type {JsonNodeOptions}
     * @memberof JsonNode
     */
    options?: JsonNodeOptions;
    /**
     * 
     * @type {JsonNode}
     * @memberof JsonNode
     */
    parent?: JsonNode;
    /**
     * 
     * @type {JsonNode}
     * @memberof JsonNode
     */
    root?: JsonNode;
}
/**
 * 
 * @export
 * @interface JsonNodeOptions
 */
export interface JsonNodeOptions {
    /**
     * 
     * @type {boolean}
     * @memberof JsonNodeOptions
     */
    propertyNameCaseInsensitive?: boolean;
}
/**
 * 
 * @export
 * @interface McpJsonRpcRequest
 */
export interface McpJsonRpcRequest {
    /**
     * 
     * @type {string}
     * @memberof McpJsonRpcRequest
     */
    jsonrpc?: string | null;
    /**
     * 
     * @type {JsonNode}
     * @memberof McpJsonRpcRequest
     */
    id?: JsonNode;
    /**
     * 
     * @type {string}
     * @memberof McpJsonRpcRequest
     */
    method?: string | null;
    /**
     * 
     * @type {{ [key: string]: JsonNode; }}
     * @memberof McpJsonRpcRequest
     */
    params?: { [key: string]: JsonNode; } | null;
}
/**
 * 
 * @export
 * @interface MeetingChangeStatusDto
 */
export interface MeetingChangeStatusDto {
    /**
     * 
     * @type {MeetingStatus}
     * @memberof MeetingChangeStatusDto
     */
    newStatus?: MeetingStatus;
    /**
     * 
     * @type {string}
     * @memberof MeetingChangeStatusDto
     */
    message?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingChangeStatusDto
     */
    newStartTime?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MeetingChangeStatusDto
     */
    meetingId?: number;
}
/**
 * 
 * @export
 * @interface MeetingDetailsDto
 */
export interface MeetingDetailsDto {
    /**
     * 
     * @type {number}
     * @memberof MeetingDetailsDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof MeetingDetailsDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof MeetingDetailsDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof MeetingDetailsDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MeetingDetailsDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MeetingDetailsDto
     */
    pipedriveActivityId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingDetailsDto
     */
    startTime?: string | null;
    /**
     * 
     * @type {MeetingStatus}
     * @memberof MeetingDetailsDto
     */
    status?: MeetingStatus;
    /**
     * 
     * @type {MeetingForm}
     * @memberof MeetingDetailsDto
     */
    form?: MeetingForm;
    /**
     * 
     * @type {string}
     * @memberof MeetingDetailsDto
     */
    message?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MeetingDetailsDto
     */
    contractorId?: number;
    /**
     * 
     * @type {number}
     * @memberof MeetingDetailsDto
     */
    parentId?: number | null;
    /**
     * 
     * @type {MeetingSimpleDto}
     * @memberof MeetingDetailsDto
     */
    parent?: MeetingSimpleDto;
    /**
     * 
     * @type {ApplicationUserDto}
     * @memberof MeetingDetailsDto
     */
    createdBy?: ApplicationUserDto;
    /**
     * 
     * @type {ContractorDto}
     * @memberof MeetingDetailsDto
     */
    contractor?: ContractorDto;
}
/**
 * 
 * @export
 * @interface MeetingDto
 */
export interface MeetingDto {
    /**
     * 
     * @type {number}
     * @memberof MeetingDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof MeetingDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof MeetingDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof MeetingDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MeetingDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MeetingDto
     */
    pipedriveActivityId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingDto
     */
    startTime?: string | null;
    /**
     * 
     * @type {MeetingStatus}
     * @memberof MeetingDto
     */
    status?: MeetingStatus;
    /**
     * 
     * @type {MeetingForm}
     * @memberof MeetingDto
     */
    form?: MeetingForm;
    /**
     * 
     * @type {string}
     * @memberof MeetingDto
     */
    message?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MeetingDto
     */
    contractorId?: number;
    /**
     * 
     * @type {number}
     * @memberof MeetingDto
     */
    parentId?: number | null;
    /**
     * 
     * @type {MeetingSimpleDto}
     * @memberof MeetingDto
     */
    parent?: MeetingSimpleDto;
    /**
     * 
     * @type {ApplicationUserDto}
     * @memberof MeetingDto
     */
    createdBy?: ApplicationUserDto;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum MeetingForm {
    InPerson = 'InPerson',
    Phone = 'Phone',
    Online = 'Online',
    Other = 'Other'
}

/**
 * 
 * @export
 * @interface MeetingSimpleDto
 */
export interface MeetingSimpleDto {
    /**
     * 
     * @type {number}
     * @memberof MeetingSimpleDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof MeetingSimpleDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof MeetingSimpleDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof MeetingSimpleDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MeetingSimpleDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingSimpleDto
     */
    startTime?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum MeetingStatus {
    Scheduled = 'Scheduled',
    Canceled = 'Canceled',
    Rescheduled = 'Rescheduled',
    Done = 'Done'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum OperationType {
    Create = 'Create',
    Delete = 'Delete',
    Edit = 'Edit',
    Assign = 'Assign'
}

/**
 * 
 * @export
 * @interface PhoneNumberDto
 */
export interface PhoneNumberDto {
    /**
     * 
     * @type {string}
     * @memberof PhoneNumberDto
     */
    number?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PhoneNumberDto
     */
    contactPerson?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PhoneNumberDto
     */
    description?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PhoneNumberDto
     */
    pipedrivePersonId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PhoneNumberDto
     */
    emailAddress?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PhoneNumberDto
     */
    isPrimary?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof PhoneNumberDto
     */
    jobTitle?: string | null;
}
/**
 * 
 * @export
 * @interface PhysicochemicalTestCreateDto
 */
export interface PhysicochemicalTestCreateDto {
    /**
     * 
     * @type {number}
     * @memberof PhysicochemicalTestCreateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof PhysicochemicalTestCreateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof PhysicochemicalTestCreateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof PhysicochemicalTestCreateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PhysicochemicalTestCreateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PhysicochemicalTestCreateDto
     */
    productionProcessId?: number;
    /**
     * 
     * @type {string}
     * @memberof PhysicochemicalTestCreateDto
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PhysicochemicalTestCreateDto
     */
    testDate?: string | null;
    /**
     * 
     * @type {PhysicochemicalTestStage}
     * @memberof PhysicochemicalTestCreateDto
     */
    testStage?: PhysicochemicalTestStage;
    /**
     * 
     * @type {number}
     * @memberof PhysicochemicalTestCreateDto
     */
    percentOfAlcohol?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PhysicochemicalTestCreateDto
     */
    sugarGramPerLiter?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PhysicochemicalTestCreateDto
     */
    acidityPh?: number | null;
}
/**
 * 
 * @export
 * @interface PhysicochemicalTestDetailsDto
 */
export interface PhysicochemicalTestDetailsDto {
    /**
     * 
     * @type {number}
     * @memberof PhysicochemicalTestDetailsDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof PhysicochemicalTestDetailsDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof PhysicochemicalTestDetailsDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof PhysicochemicalTestDetailsDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PhysicochemicalTestDetailsDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PhysicochemicalTestDetailsDto
     */
    productionProcessId?: number;
    /**
     * 
     * @type {string}
     * @memberof PhysicochemicalTestDetailsDto
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PhysicochemicalTestDetailsDto
     */
    testDate?: string | null;
    /**
     * 
     * @type {PhysicochemicalTestStage}
     * @memberof PhysicochemicalTestDetailsDto
     */
    testStage?: PhysicochemicalTestStage;
    /**
     * 
     * @type {number}
     * @memberof PhysicochemicalTestDetailsDto
     */
    percentOfAlcohol?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PhysicochemicalTestDetailsDto
     */
    sugarGramPerLiter?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PhysicochemicalTestDetailsDto
     */
    acidityPh?: number | null;
    /**
     * 
     * @type {StockOperationDto}
     * @memberof PhysicochemicalTestDetailsDto
     */
    stockOperation?: StockOperationDto;
}
/**
 * 
 * @export
 * @interface PhysicochemicalTestDto
 */
export interface PhysicochemicalTestDto {
    /**
     * 
     * @type {number}
     * @memberof PhysicochemicalTestDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof PhysicochemicalTestDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof PhysicochemicalTestDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof PhysicochemicalTestDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PhysicochemicalTestDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PhysicochemicalTestDto
     */
    productionProcessId?: number;
    /**
     * 
     * @type {string}
     * @memberof PhysicochemicalTestDto
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PhysicochemicalTestDto
     */
    testDate?: string | null;
    /**
     * 
     * @type {PhysicochemicalTestStage}
     * @memberof PhysicochemicalTestDto
     */
    testStage?: PhysicochemicalTestStage;
    /**
     * 
     * @type {number}
     * @memberof PhysicochemicalTestDto
     */
    percentOfAlcohol?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PhysicochemicalTestDto
     */
    sugarGramPerLiter?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PhysicochemicalTestDto
     */
    acidityPh?: number | null;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum PhysicochemicalTestStage {
    Harvest = 'Harvest',
    Embossing = 'Embossing',
    Transfer = 'Transfer'
}

/**
 * 
 * @export
 * @interface PhysicochemicalTestUpdateDto
 */
export interface PhysicochemicalTestUpdateDto {
    /**
     * 
     * @type {number}
     * @memberof PhysicochemicalTestUpdateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof PhysicochemicalTestUpdateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof PhysicochemicalTestUpdateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof PhysicochemicalTestUpdateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PhysicochemicalTestUpdateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PhysicochemicalTestUpdateDto
     */
    productionProcessId?: number;
    /**
     * 
     * @type {string}
     * @memberof PhysicochemicalTestUpdateDto
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PhysicochemicalTestUpdateDto
     */
    testDate?: string | null;
    /**
     * 
     * @type {PhysicochemicalTestStage}
     * @memberof PhysicochemicalTestUpdateDto
     */
    testStage?: PhysicochemicalTestStage;
    /**
     * 
     * @type {number}
     * @memberof PhysicochemicalTestUpdateDto
     */
    percentOfAlcohol?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PhysicochemicalTestUpdateDto
     */
    sugarGramPerLiter?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PhysicochemicalTestUpdateDto
     */
    acidityPh?: number | null;
}
/**
 * 
 * @export
 * @interface PipedriveDealIntegrationProductDto
 */
export interface PipedriveDealIntegrationProductDto {
    /**
     * 
     * @type {number}
     * @memberof PipedriveDealIntegrationProductDto
     */
    dealProductId?: number;
    /**
     * 
     * @type {number}
     * @memberof PipedriveDealIntegrationProductDto
     */
    pipedriveProductId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PipedriveDealIntegrationProductDto
     */
    productName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PipedriveDealIntegrationProductDto
     */
    productCode?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PipedriveDealIntegrationProductDto
     */
    quantity?: number;
    /**
     * 
     * @type {number}
     * @memberof PipedriveDealIntegrationProductDto
     */
    itemPrice?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PipedriveDealIntegrationProductDto
     */
    discountPercentage?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PipedriveDealIntegrationProductDto
     */
    comments?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PipedriveDealIntegrationProductDto
     */
    isMapped?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PipedriveDealIntegrationProductDto
     */
    wineMsProductId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PipedriveDealIntegrationProductDto
     */
    wineMsUnitId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PipedriveDealIntegrationProductDto
     */
    availableQuantity?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PipedriveDealIntegrationProductDto
     */
    reservedQuantity?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof PipedriveDealIntegrationProductDto
     */
    hasSufficientStock?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PipedriveDealIntegrationProductDto
     */
    warning?: string | null;
}
/**
 * 
 * @export
 * @interface PipedriveDealIntegrationSummaryDto
 */
export interface PipedriveDealIntegrationSummaryDto {
    /**
     * 
     * @type {number}
     * @memberof PipedriveDealIntegrationSummaryDto
     */
    pipedriveDealId?: number;
    /**
     * 
     * @type {string}
     * @memberof PipedriveDealIntegrationSummaryDto
     */
    title?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PipedriveDealIntegrationSummaryDto
     */
    pipelineId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PipedriveDealIntegrationSummaryDto
     */
    stageId?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof PipedriveDealIntegrationSummaryDto
     */
    isConfigured?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PipedriveDealIntegrationSummaryDto
     */
    inConfiguredPipeline?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PipedriveDealIntegrationSummaryDto
     */
    isEditableStage?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PipedriveDealIntegrationSummaryDto
     */
    action?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PipedriveDealIntegrationSummaryDto
     */
    state?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PipedriveDealIntegrationSummaryDto
     */
    warning?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PipedriveDealIntegrationSummaryDto
     */
    contractorId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PipedriveDealIntegrationSummaryDto
     */
    contractorName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PipedriveDealIntegrationSummaryDto
     */
    stockOperationId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PipedriveDealIntegrationSummaryDto
     */
    documentNumber?: string | null;
    /**
     * 
     * @type {StockOperationStatus}
     * @memberof PipedriveDealIntegrationSummaryDto
     */
    orderStatus?: StockOperationStatus;
    /**
     * 
     * @type {string}
     * @memberof PipedriveDealIntegrationSummaryDto
     */
    orderUrl?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PipedriveDealIntegrationSummaryDto
     */
    productCount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PipedriveDealIntegrationSummaryDto
     */
    hasUnmappedProducts?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PipedriveDealIntegrationSummaryDto
     */
    hasStockIssues?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PipedriveDealIntegrationSummaryDto
     */
    hasMissingBatchNumbers?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PipedriveDealIntegrationSummaryDto
     */
    canSync?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PipedriveDealIntegrationSummaryDto
     */
    canSendToWarehouse?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PipedriveDealIntegrationSummaryDto
     */
    canConfirm?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PipedriveDealIntegrationSummaryDto
     */
    confirmAction?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PipedriveDealIntegrationSummaryDto
     */
    confirmButtonLabel?: string | null;
    /**
     * 
     * @type {Array<PipedriveDealIntegrationProductDto>}
     * @memberof PipedriveDealIntegrationSummaryDto
     */
    products?: Array<PipedriveDealIntegrationProductDto> | null;
}
/**
 * 
 * @export
 * @interface ProductCreateDto
 */
export interface ProductCreateDto {
    /**
     * 
     * @type {number}
     * @memberof ProductCreateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductCreateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductCreateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductCreateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProductCreateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ProductCreateDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductCreateDto
     */
    description?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ProductCreateDto
     */
    isDeleted?: boolean;
    /**
     * 
     * @type {UnitOfMeasureDto}
     * @memberof ProductCreateDto
     */
    baseUnit?: UnitOfMeasureDto;
    /**
     * 
     * @type {Array<SimpleBaseUnitDto>}
     * @memberof ProductCreateDto
     */
    auxiliaryUnits?: Array<SimpleBaseUnitDto> | null;
    /**
     * 
     * @type {ProductType}
     * @memberof ProductCreateDto
     */
    type?: ProductType;
    /**
     * 
     * @type {number}
     * @memberof ProductCreateDto
     */
    strainId?: number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ProductCreateDto
     */
    additionalStrainIds?: Array<number> | null;
    /**
     * 
     * @type {WineColor}
     * @memberof ProductCreateDto
     */
    color?: WineColor;
    /**
     * 
     * @type {WineSweetness}
     * @memberof ProductCreateDto
     */
    sweetness?: WineSweetness;
    /**
     * 
     * @type {string}
     * @memberof ProductCreateDto
     */
    tasteNote?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductCreateDto
     */
    productionYear?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductCreateDto
     */
    ean?: string | null;
    /**
     * 
     * @type {StrainDto}
     * @memberof ProductCreateDto
     */
    strain?: StrainDto;
    /**
     * 
     * @type {Array<StrainDto>}
     * @memberof ProductCreateDto
     */
    additionalStrains?: Array<StrainDto> | null;
    /**
     * 
     * @type {number}
     * @memberof ProductCreateDto
     */
    price?: number | null;
    /**
     * 
     * @type {Array<ProductPriceDto>}
     * @memberof ProductCreateDto
     */
    prices?: Array<ProductPriceDto> | null;
    /**
     * 
     * @type {number}
     * @memberof ProductCreateDto
     */
    baseUnitId?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof ProductCreateDto
     */
    auxiliaryUnitsIds?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface ProductDetailsDto
 */
export interface ProductDetailsDto {
    /**
     * 
     * @type {number}
     * @memberof ProductDetailsDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductDetailsDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductDetailsDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductDetailsDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProductDetailsDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ProductDetailsDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductDetailsDto
     */
    description?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ProductDetailsDto
     */
    isDeleted?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ProductDetailsDto
     */
    baseUnitId?: number;
    /**
     * 
     * @type {UnitOfMeasureDto}
     * @memberof ProductDetailsDto
     */
    baseUnit?: UnitOfMeasureDto;
    /**
     * 
     * @type {Array<number>}
     * @memberof ProductDetailsDto
     */
    auxiliaryUnitsIds?: Array<number> | null;
    /**
     * 
     * @type {Array<SimpleBaseUnitDto>}
     * @memberof ProductDetailsDto
     */
    auxiliaryUnits?: Array<SimpleBaseUnitDto> | null;
    /**
     * 
     * @type {ProductType}
     * @memberof ProductDetailsDto
     */
    type?: ProductType;
    /**
     * 
     * @type {number}
     * @memberof ProductDetailsDto
     */
    strainId?: number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ProductDetailsDto
     */
    additionalStrainIds?: Array<number> | null;
    /**
     * 
     * @type {WineColor}
     * @memberof ProductDetailsDto
     */
    color?: WineColor;
    /**
     * 
     * @type {WineSweetness}
     * @memberof ProductDetailsDto
     */
    sweetness?: WineSweetness;
    /**
     * 
     * @type {string}
     * @memberof ProductDetailsDto
     */
    tasteNote?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductDetailsDto
     */
    productionYear?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductDetailsDto
     */
    ean?: string | null;
    /**
     * 
     * @type {StrainDto}
     * @memberof ProductDetailsDto
     */
    strain?: StrainDto;
    /**
     * 
     * @type {Array<StrainDto>}
     * @memberof ProductDetailsDto
     */
    additionalStrains?: Array<StrainDto> | null;
    /**
     * 
     * @type {number}
     * @memberof ProductDetailsDto
     */
    price?: number | null;
    /**
     * 
     * @type {Array<ProductPriceDto>}
     * @memberof ProductDetailsDto
     */
    prices?: Array<ProductPriceDto> | null;
}
/**
 * 
 * @export
 * @interface ProductDto
 */
export interface ProductDto {
    /**
     * 
     * @type {number}
     * @memberof ProductDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProductDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ProductDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductDto
     */
    description?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ProductDto
     */
    isDeleted?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ProductDto
     */
    baseUnitId?: number;
    /**
     * 
     * @type {UnitOfMeasureDto}
     * @memberof ProductDto
     */
    baseUnit?: UnitOfMeasureDto;
    /**
     * 
     * @type {Array<number>}
     * @memberof ProductDto
     */
    auxiliaryUnitsIds?: Array<number> | null;
    /**
     * 
     * @type {Array<SimpleBaseUnitDto>}
     * @memberof ProductDto
     */
    auxiliaryUnits?: Array<SimpleBaseUnitDto> | null;
    /**
     * 
     * @type {ProductType}
     * @memberof ProductDto
     */
    type?: ProductType;
    /**
     * 
     * @type {number}
     * @memberof ProductDto
     */
    strainId?: number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ProductDto
     */
    additionalStrainIds?: Array<number> | null;
    /**
     * 
     * @type {WineColor}
     * @memberof ProductDto
     */
    color?: WineColor;
    /**
     * 
     * @type {WineSweetness}
     * @memberof ProductDto
     */
    sweetness?: WineSweetness;
    /**
     * 
     * @type {string}
     * @memberof ProductDto
     */
    tasteNote?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductDto
     */
    productionYear?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductDto
     */
    ean?: string | null;
    /**
     * 
     * @type {StrainDto}
     * @memberof ProductDto
     */
    strain?: StrainDto;
    /**
     * 
     * @type {Array<StrainDto>}
     * @memberof ProductDto
     */
    additionalStrains?: Array<StrainDto> | null;
    /**
     * 
     * @type {number}
     * @memberof ProductDto
     */
    price?: number | null;
    /**
     * 
     * @type {Array<ProductPriceDto>}
     * @memberof ProductDto
     */
    prices?: Array<ProductPriceDto> | null;
}
/**
 * 
 * @export
 * @interface ProductMcpDto
 */
export interface ProductMcpDto {
    /**
     * 
     * @type {number}
     * @memberof ProductMcpDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductMcpDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductMcpDto
     */
    description?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ProductMcpDto
     */
    isDeleted?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ProductMcpDto
     */
    baseUnitId?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductMcpDto
     */
    baseUnitName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductMcpDto
     */
    type?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProductMcpDto
     */
    strainId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ProductMcpDto
     */
    strainName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductMcpDto
     */
    color?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductMcpDto
     */
    sweetness?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductMcpDto
     */
    tasteNote?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductMcpDto
     */
    productionYear?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductMcpDto
     */
    ean?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProductMcpDto
     */
    price?: number | null;
}
/**
 * 
 * @export
 * @interface ProductMcpDtoPaginatedMcpDto
 */
export interface ProductMcpDtoPaginatedMcpDto {
    /**
     * 
     * @type {number}
     * @memberof ProductMcpDtoPaginatedMcpDto
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductMcpDtoPaginatedMcpDto
     */
    pageSize?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductMcpDtoPaginatedMcpDto
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<ProductMcpDto>}
     * @memberof ProductMcpDtoPaginatedMcpDto
     */
    items?: Array<ProductMcpDto> | null;
}
/**
 * 
 * @export
 * @interface ProductMinimalDto
 */
export interface ProductMinimalDto {
    /**
     * 
     * @type {number}
     * @memberof ProductMinimalDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductMinimalDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductMinimalDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductMinimalDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProductMinimalDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ProductMinimalDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductMinimalDto
     */
    description?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ProductMinimalDto
     */
    isDeleted?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProductMinimalDto
     */
    ean?: string | null;
}
/**
 * 
 * @export
 * @interface ProductPriceCreateDto
 */
export interface ProductPriceCreateDto {
    /**
     * 
     * @type {number}
     * @memberof ProductPriceCreateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductPriceCreateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductPriceCreateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductPriceCreateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProductPriceCreateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ProductPriceCreateDto
     */
    productId?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductPriceCreateDto
     */
    unitId?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductPriceCreateDto
     */
    price?: number;
}
/**
 * 
 * @export
 * @interface ProductPriceDetailsDto
 */
export interface ProductPriceDetailsDto {
    /**
     * 
     * @type {number}
     * @memberof ProductPriceDetailsDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductPriceDetailsDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductPriceDetailsDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductPriceDetailsDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProductPriceDetailsDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ProductPriceDetailsDto
     */
    productId?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductPriceDetailsDto
     */
    unitId?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductPriceDetailsDto
     */
    price?: number;
}
/**
 * 
 * @export
 * @interface ProductPriceDto
 */
export interface ProductPriceDto {
    /**
     * 
     * @type {number}
     * @memberof ProductPriceDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductPriceDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductPriceDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductPriceDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProductPriceDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ProductPriceDto
     */
    productId?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductPriceDto
     */
    unitId?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductPriceDto
     */
    price?: number;
}
/**
 * 
 * @export
 * @interface ProductPriceUpdateDto
 */
export interface ProductPriceUpdateDto {
    /**
     * 
     * @type {number}
     * @memberof ProductPriceUpdateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductPriceUpdateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductPriceUpdateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductPriceUpdateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProductPriceUpdateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ProductPriceUpdateDto
     */
    productId?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductPriceUpdateDto
     */
    unitId?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductPriceUpdateDto
     */
    price?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum ProductType {
    Wine = 'Wine',
    LabeledWine = 'LabeledWine',
    Fruit = 'Fruit',
    Juice = 'Juice',
    Sediment = 'Sediment',
    Pomace = 'Pomace',
    Bottle = 'Bottle',
    Other = 'Other',
    BottledWine = 'BottledWine'
}

/**
 * 
 * @export
 * @interface ProductUpdateDto
 */
export interface ProductUpdateDto {
    /**
     * 
     * @type {number}
     * @memberof ProductUpdateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductUpdateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductUpdateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductUpdateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProductUpdateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ProductUpdateDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductUpdateDto
     */
    description?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ProductUpdateDto
     */
    isDeleted?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ProductUpdateDto
     */
    baseUnitId?: number;
    /**
     * 
     * @type {UnitOfMeasureDto}
     * @memberof ProductUpdateDto
     */
    baseUnit?: UnitOfMeasureDto;
    /**
     * 
     * @type {Array<number>}
     * @memberof ProductUpdateDto
     */
    auxiliaryUnitsIds?: Array<number> | null;
    /**
     * 
     * @type {Array<SimpleBaseUnitDto>}
     * @memberof ProductUpdateDto
     */
    auxiliaryUnits?: Array<SimpleBaseUnitDto> | null;
    /**
     * 
     * @type {ProductType}
     * @memberof ProductUpdateDto
     */
    type?: ProductType;
    /**
     * 
     * @type {number}
     * @memberof ProductUpdateDto
     */
    strainId?: number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ProductUpdateDto
     */
    additionalStrainIds?: Array<number> | null;
    /**
     * 
     * @type {WineColor}
     * @memberof ProductUpdateDto
     */
    color?: WineColor;
    /**
     * 
     * @type {WineSweetness}
     * @memberof ProductUpdateDto
     */
    sweetness?: WineSweetness;
    /**
     * 
     * @type {string}
     * @memberof ProductUpdateDto
     */
    tasteNote?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductUpdateDto
     */
    productionYear?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductUpdateDto
     */
    ean?: string | null;
    /**
     * 
     * @type {StrainDto}
     * @memberof ProductUpdateDto
     */
    strain?: StrainDto;
    /**
     * 
     * @type {Array<StrainDto>}
     * @memberof ProductUpdateDto
     */
    additionalStrains?: Array<StrainDto> | null;
    /**
     * 
     * @type {number}
     * @memberof ProductUpdateDto
     */
    price?: number | null;
    /**
     * 
     * @type {Array<ProductPriceDto>}
     * @memberof ProductUpdateDto
     */
    prices?: Array<ProductPriceDto> | null;
}
/**
 * 
 * @export
 * @interface ProductUpdateHistoryCreateDto
 */
export interface ProductUpdateHistoryCreateDto {
    /**
     * 
     * @type {number}
     * @memberof ProductUpdateHistoryCreateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductUpdateHistoryCreateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductUpdateHistoryCreateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductUpdateHistoryCreateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProductUpdateHistoryCreateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ProductUpdateHistoryCreateDto
     */
    oldValue?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductUpdateHistoryCreateDto
     */
    newValue?: string | null;
    /**
     * 
     * @type {OperationType}
     * @memberof ProductUpdateHistoryCreateDto
     */
    operationType?: OperationType;
    /**
     * 
     * @type {ApplicationUserDto}
     * @memberof ProductUpdateHistoryCreateDto
     */
    createdBy?: ApplicationUserDto;
    /**
     * 
     * @type {number}
     * @memberof ProductUpdateHistoryCreateDto
     */
    productId?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductUpdateHistoryCreateDto
     */
    translatedChangedValueName?: string | null;
}
/**
 * 
 * @export
 * @interface ProductUpdateHistoryDetailsDto
 */
export interface ProductUpdateHistoryDetailsDto {
    /**
     * 
     * @type {number}
     * @memberof ProductUpdateHistoryDetailsDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductUpdateHistoryDetailsDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductUpdateHistoryDetailsDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductUpdateHistoryDetailsDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProductUpdateHistoryDetailsDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ProductUpdateHistoryDetailsDto
     */
    oldValue?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductUpdateHistoryDetailsDto
     */
    newValue?: string | null;
    /**
     * 
     * @type {OperationType}
     * @memberof ProductUpdateHistoryDetailsDto
     */
    operationType?: OperationType;
    /**
     * 
     * @type {ApplicationUserDto}
     * @memberof ProductUpdateHistoryDetailsDto
     */
    createdBy?: ApplicationUserDto;
    /**
     * 
     * @type {number}
     * @memberof ProductUpdateHistoryDetailsDto
     */
    productId?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductUpdateHistoryDetailsDto
     */
    translatedChangedValueName?: string | null;
}
/**
 * 
 * @export
 * @interface ProductUpdateHistoryDto
 */
export interface ProductUpdateHistoryDto {
    /**
     * 
     * @type {number}
     * @memberof ProductUpdateHistoryDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductUpdateHistoryDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductUpdateHistoryDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductUpdateHistoryDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProductUpdateHistoryDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ProductUpdateHistoryDto
     */
    oldValue?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductUpdateHistoryDto
     */
    newValue?: string | null;
    /**
     * 
     * @type {OperationType}
     * @memberof ProductUpdateHistoryDto
     */
    operationType?: OperationType;
    /**
     * 
     * @type {ApplicationUserDto}
     * @memberof ProductUpdateHistoryDto
     */
    createdBy?: ApplicationUserDto;
    /**
     * 
     * @type {number}
     * @memberof ProductUpdateHistoryDto
     */
    productId?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductUpdateHistoryDto
     */
    translatedChangedValueName?: string | null;
}
/**
 * 
 * @export
 * @interface ProductUpdateHistoryUpdateDto
 */
export interface ProductUpdateHistoryUpdateDto {
    /**
     * 
     * @type {number}
     * @memberof ProductUpdateHistoryUpdateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductUpdateHistoryUpdateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductUpdateHistoryUpdateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductUpdateHistoryUpdateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProductUpdateHistoryUpdateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ProductUpdateHistoryUpdateDto
     */
    oldValue?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductUpdateHistoryUpdateDto
     */
    newValue?: string | null;
    /**
     * 
     * @type {OperationType}
     * @memberof ProductUpdateHistoryUpdateDto
     */
    operationType?: OperationType;
    /**
     * 
     * @type {ApplicationUserDto}
     * @memberof ProductUpdateHistoryUpdateDto
     */
    createdBy?: ApplicationUserDto;
    /**
     * 
     * @type {number}
     * @memberof ProductUpdateHistoryUpdateDto
     */
    productId?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductUpdateHistoryUpdateDto
     */
    translatedChangedValueName?: string | null;
}
/**
 * 
 * @export
 * @interface ProductionProcessCreateDto
 */
export interface ProductionProcessCreateDto {
    /**
     * 
     * @type {number}
     * @memberof ProductionProcessCreateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductionProcessCreateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductionProcessCreateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductionProcessCreateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProductionProcessCreateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ProductionProcessCreateDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductionProcessCreateDto
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductionProcessCreateDto
     */
    date?: string;
    /**
     * 
     * @type {StockOperationStatus}
     * @memberof ProductionProcessCreateDto
     */
    status?: StockOperationStatus;
    /**
     * 
     * @type {Array<StockOperationDto>}
     * @memberof ProductionProcessCreateDto
     */
    stockOperations?: Array<StockOperationDto> | null;
    /**
     * 
     * @type {number}
     * @memberof ProductionProcessCreateDto
     */
    strainId?: number | null;
    /**
     * 
     * @type {StrainDto}
     * @memberof ProductionProcessCreateDto
     */
    strain?: StrainDto;
    /**
     * 
     * @type {Array<PhysicochemicalTestDto>}
     * @memberof ProductionProcessCreateDto
     */
    physicochemicalTests?: Array<PhysicochemicalTestDto> | null;
}
/**
 * 
 * @export
 * @interface ProductionProcessDetailsDto
 */
export interface ProductionProcessDetailsDto {
    /**
     * 
     * @type {number}
     * @memberof ProductionProcessDetailsDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductionProcessDetailsDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductionProcessDetailsDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductionProcessDetailsDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProductionProcessDetailsDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ProductionProcessDetailsDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductionProcessDetailsDto
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductionProcessDetailsDto
     */
    date?: string;
    /**
     * 
     * @type {StockOperationStatus}
     * @memberof ProductionProcessDetailsDto
     */
    status?: StockOperationStatus;
    /**
     * 
     * @type {Array<StockOperationDto>}
     * @memberof ProductionProcessDetailsDto
     */
    stockOperations?: Array<StockOperationDto> | null;
    /**
     * 
     * @type {number}
     * @memberof ProductionProcessDetailsDto
     */
    strainId?: number | null;
    /**
     * 
     * @type {StrainDto}
     * @memberof ProductionProcessDetailsDto
     */
    strain?: StrainDto;
    /**
     * 
     * @type {Array<PhysicochemicalTestDto>}
     * @memberof ProductionProcessDetailsDto
     */
    physicochemicalTests?: Array<PhysicochemicalTestDto> | null;
}
/**
 * 
 * @export
 * @interface ProductionProcessDto
 */
export interface ProductionProcessDto {
    /**
     * 
     * @type {number}
     * @memberof ProductionProcessDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductionProcessDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductionProcessDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductionProcessDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProductionProcessDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ProductionProcessDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductionProcessDto
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductionProcessDto
     */
    date?: string;
    /**
     * 
     * @type {StockOperationStatus}
     * @memberof ProductionProcessDto
     */
    status?: StockOperationStatus;
    /**
     * 
     * @type {Array<StockOperationDto>}
     * @memberof ProductionProcessDto
     */
    stockOperations?: Array<StockOperationDto> | null;
    /**
     * 
     * @type {number}
     * @memberof ProductionProcessDto
     */
    strainId?: number | null;
    /**
     * 
     * @type {StrainDto}
     * @memberof ProductionProcessDto
     */
    strain?: StrainDto;
    /**
     * 
     * @type {Array<PhysicochemicalTestDto>}
     * @memberof ProductionProcessDto
     */
    physicochemicalTests?: Array<PhysicochemicalTestDto> | null;
}
/**
 * 
 * @export
 * @interface ProductionProcessMinimalDto
 */
export interface ProductionProcessMinimalDto {
    /**
     * 
     * @type {number}
     * @memberof ProductionProcessMinimalDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductionProcessMinimalDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductionProcessMinimalDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductionProcessMinimalDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProductionProcessMinimalDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ProductionProcessMinimalDto
     */
    name?: string | null;
    /**
     * 
     * @type {StrainDto}
     * @memberof ProductionProcessMinimalDto
     */
    strain?: StrainDto;
}
/**
 * 
 * @export
 * @interface ProductionProcessStockDto
 */
export interface ProductionProcessStockDto {
    /**
     * 
     * @type {number}
     * @memberof ProductionProcessStockDto
     */
    warehouseId?: number;
    /**
     * 
     * @type {WarehouseDto}
     * @memberof ProductionProcessStockDto
     */
    warehouse?: WarehouseDto;
    /**
     * 
     * @type {number}
     * @memberof ProductionProcessStockDto
     */
    productId?: number;
    /**
     * 
     * @type {ProductDto}
     * @memberof ProductionProcessStockDto
     */
    product?: ProductDto;
    /**
     * 
     * @type {string}
     * @memberof ProductionProcessStockDto
     */
    batchNumber?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProductionProcessStockDto
     */
    unitId?: number;
    /**
     * 
     * @type {SimpleBaseUnitDto}
     * @memberof ProductionProcessStockDto
     */
    unit?: SimpleBaseUnitDto;
    /**
     * 
     * @type {number}
     * @memberof ProductionProcessStockDto
     */
    quantity?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductionProcessStockDto
     */
    reservedQuantity?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductionProcessStockDto
     */
    lastChangedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProductionProcessStockDto
     */
    productionProcessId?: number;
}
/**
 * 
 * @export
 * @interface ProductionProcessUpdateDto
 */
export interface ProductionProcessUpdateDto {
    /**
     * 
     * @type {number}
     * @memberof ProductionProcessUpdateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductionProcessUpdateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductionProcessUpdateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductionProcessUpdateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProductionProcessUpdateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ProductionProcessUpdateDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductionProcessUpdateDto
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductionProcessUpdateDto
     */
    date?: string;
    /**
     * 
     * @type {StockOperationStatus}
     * @memberof ProductionProcessUpdateDto
     */
    status?: StockOperationStatus;
    /**
     * 
     * @type {Array<StockOperationDto>}
     * @memberof ProductionProcessUpdateDto
     */
    stockOperations?: Array<StockOperationDto> | null;
    /**
     * 
     * @type {number}
     * @memberof ProductionProcessUpdateDto
     */
    strainId?: number | null;
    /**
     * 
     * @type {StrainDto}
     * @memberof ProductionProcessUpdateDto
     */
    strain?: StrainDto;
    /**
     * 
     * @type {Array<PhysicochemicalTestDto>}
     * @memberof ProductionProcessUpdateDto
     */
    physicochemicalTests?: Array<PhysicochemicalTestDto> | null;
}
/**
 * 
 * @export
 * @interface SimpleBaseUnitDto
 */
export interface SimpleBaseUnitDto {
    /**
     * 
     * @type {number}
     * @memberof SimpleBaseUnitDto
     */
    id?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SimpleBaseUnitDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SimpleBaseUnitDto
     */
    code?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SimpleBaseUnitDto
     */
    conversionToBase?: number | null;
}
/**
 * 
 * @export
 * @interface StockDto
 */
export interface StockDto {
    /**
     * 
     * @type {number}
     * @memberof StockDto
     */
    warehouseId?: number;
    /**
     * 
     * @type {WarehouseDto}
     * @memberof StockDto
     */
    warehouse?: WarehouseDto;
    /**
     * 
     * @type {number}
     * @memberof StockDto
     */
    productId?: number;
    /**
     * 
     * @type {ProductDto}
     * @memberof StockDto
     */
    product?: ProductDto;
    /**
     * 
     * @type {string}
     * @memberof StockDto
     */
    batchNumber?: string | null;
    /**
     * 
     * @type {number}
     * @memberof StockDto
     */
    unitId?: number;
    /**
     * 
     * @type {SimpleBaseUnitDto}
     * @memberof StockDto
     */
    unit?: SimpleBaseUnitDto;
    /**
     * 
     * @type {number}
     * @memberof StockDto
     */
    quantity?: number;
    /**
     * 
     * @type {number}
     * @memberof StockDto
     */
    reservedQuantity?: number;
    /**
     * 
     * @type {string}
     * @memberof StockDto
     */
    lastChangedAt?: string | null;
}
/**
 * 
 * @export
 * @interface StockHistoryMinimalDto
 */
export interface StockHistoryMinimalDto {
    /**
     * 
     * @type {StockOperationType}
     * @memberof StockHistoryMinimalDto
     */
    operationType?: StockOperationType;
    /**
     * 
     * @type {string}
     * @memberof StockHistoryMinimalDto
     */
    documentNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StockHistoryMinimalDto
     */
    operationDate?: string;
    /**
     * 
     * @type {string}
     * @memberof StockHistoryMinimalDto
     */
    batchNumber?: string | null;
    /**
     * 
     * @type {number}
     * @memberof StockHistoryMinimalDto
     */
    unitId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof StockHistoryMinimalDto
     */
    unitCode?: string | null;
    /**
     * 
     * @type {number}
     * @memberof StockHistoryMinimalDto
     */
    quantity?: number;
    /**
     * 
     * @type {string}
     * @memberof StockHistoryMinimalDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof StockHistoryMinimalDto
     */
    stockOperationId?: number;
    /**
     * 
     * @type {number}
     * @memberof StockHistoryMinimalDto
     */
    parentStockOperationId?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof StockHistoryMinimalDto
     */
    isSourceWarehouse?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof StockHistoryMinimalDto
     */
    warehouseName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StockHistoryMinimalDto
     */
    destinationWarehouseName?: string | null;
}
/**
 * 
 * @export
 * @interface StockMcpDto
 */
export interface StockMcpDto {
    /**
     * 
     * @type {number}
     * @memberof StockMcpDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof StockMcpDto
     */
    productId?: number;
    /**
     * 
     * @type {string}
     * @memberof StockMcpDto
     */
    productName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof StockMcpDto
     */
    warehouseId?: number;
    /**
     * 
     * @type {string}
     * @memberof StockMcpDto
     */
    warehouseName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof StockMcpDto
     */
    unitId?: number;
    /**
     * 
     * @type {string}
     * @memberof StockMcpDto
     */
    unitName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof StockMcpDto
     */
    quantity?: number;
    /**
     * 
     * @type {number}
     * @memberof StockMcpDto
     */
    reservedQuantity?: number;
    /**
     * 
     * @type {string}
     * @memberof StockMcpDto
     */
    batchNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StockMcpDto
     */
    lastChangedAt?: string | null;
}
/**
 * 
 * @export
 * @interface StockMcpDtoPaginatedMcpDto
 */
export interface StockMcpDtoPaginatedMcpDto {
    /**
     * 
     * @type {number}
     * @memberof StockMcpDtoPaginatedMcpDto
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof StockMcpDtoPaginatedMcpDto
     */
    pageSize?: number;
    /**
     * 
     * @type {number}
     * @memberof StockMcpDtoPaginatedMcpDto
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<StockMcpDto>}
     * @memberof StockMcpDtoPaginatedMcpDto
     */
    items?: Array<StockMcpDto> | null;
}
/**
 * 
 * @export
 * @interface StockOperationCreateDto
 */
export interface StockOperationCreateDto {
    /**
     * 
     * @type {number}
     * @memberof StockOperationCreateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof StockOperationCreateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof StockOperationCreateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof StockOperationCreateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof StockOperationCreateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {number}
     * @memberof StockOperationCreateDto
     */
    warehouseId?: number | null;
    /**
     * 
     * @type {WarehouseDto}
     * @memberof StockOperationCreateDto
     */
    warehouse?: WarehouseDto;
    /**
     * 
     * @type {number}
     * @memberof StockOperationCreateDto
     */
    contractorId?: number | null;
    /**
     * 
     * @type {ContractorDto}
     * @memberof StockOperationCreateDto
     */
    contractor?: ContractorDto;
    /**
     * 
     * @type {StockOperationType}
     * @memberof StockOperationCreateDto
     */
    type?: StockOperationType;
    /**
     * 
     * @type {number}
     * @memberof StockOperationCreateDto
     */
    destinationWarehouseId?: number | null;
    /**
     * 
     * @type {WarehouseDto}
     * @memberof StockOperationCreateDto
     */
    destinationWarehouse?: WarehouseDto;
    /**
     * 
     * @type {string}
     * @memberof StockOperationCreateDto
     */
    documentNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StockOperationCreateDto
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StockOperationCreateDto
     */
    date?: string;
    /**
     * 
     * @type {boolean}
     * @memberof StockOperationCreateDto
     */
    isDeleted?: boolean;
    /**
     * 
     * @type {Array<StockOperationDetailCreateDto>}
     * @memberof StockOperationCreateDto
     */
    stockOperationDetails?: Array<StockOperationDetailCreateDto> | null;
    /**
     * 
     * @type {StockOperationStatus}
     * @memberof StockOperationCreateDto
     */
    status?: StockOperationStatus;
    /**
     * 
     * @type {string}
     * @memberof StockOperationCreateDto
     */
    publicationDate?: string | null;
    /**
     * 
     * @type {number}
     * @memberof StockOperationCreateDto
     */
    parentStockOperationId?: number | null;
    /**
     * 
     * @type {Array<StockOperationCreateDto>}
     * @memberof StockOperationCreateDto
     */
    stockOperations?: Array<StockOperationCreateDto> | null;
    /**
     * 
     * @type {number}
     * @memberof StockOperationCreateDto
     */
    productionProcessId?: number | null;
    /**
     * 
     * @type {ProductionProcessMinimalDto}
     * @memberof StockOperationCreateDto
     */
    productionProcess?: ProductionProcessMinimalDto;
    /**
     * 
     * @type {StockOperationStage}
     * @memberof StockOperationCreateDto
     */
    stage?: StockOperationStage;
    /**
     * 
     * @type {CropDto}
     * @memberof StockOperationCreateDto
     */
    crop?: CropDto;
    /**
     * 
     * @type {number}
     * @memberof StockOperationCreateDto
     */
    cropId?: number | null;
    /**
     * 
     * @type {Array<VinificationAdditiveDto>}
     * @memberof StockOperationCreateDto
     */
    vinificationAdditives?: Array<VinificationAdditiveDto> | null;
    /**
     * 
     * @type {ApplicationUserMinimalDto}
     * @memberof StockOperationCreateDto
     */
    createdBy?: ApplicationUserMinimalDto;
    /**
     * 
     * @type {boolean}
     * @memberof StockOperationCreateDto
     */
    isOrder?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StockOperationCreateDto
     */
    hasRelatedInvoice?: boolean;
    /**
     * 
     * @type {number}
     * @memberof StockOperationCreateDto
     */
    pipedriveDealId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof StockOperationCreateDto
     */
    pipedriveNote?: string | null;
}
/**
 * 
 * @export
 * @interface StockOperationDetailCreateDto
 */
export interface StockOperationDetailCreateDto {
    /**
     * 
     * @type {number}
     * @memberof StockOperationDetailCreateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof StockOperationDetailCreateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof StockOperationDetailCreateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof StockOperationDetailCreateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof StockOperationDetailCreateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {number}
     * @memberof StockOperationDetailCreateDto
     */
    productId?: number;
    /**
     * 
     * @type {number}
     * @memberof StockOperationDetailCreateDto
     */
    stockOperationId?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof StockOperationDetailCreateDto
     */
    isDeleted?: boolean;
    /**
     * 
     * @type {number}
     * @memberof StockOperationDetailCreateDto
     */
    pipedriveDealProductId?: number | null;
    /**
     * 
     * @type {Array<BatchNumberCreateDto>}
     * @memberof StockOperationDetailCreateDto
     */
    batchNumbers?: Array<BatchNumberCreateDto> | null;
}
/**
 * 
 * @export
 * @interface StockOperationDetailDto
 */
export interface StockOperationDetailDto {
    /**
     * 
     * @type {number}
     * @memberof StockOperationDetailDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof StockOperationDetailDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof StockOperationDetailDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof StockOperationDetailDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof StockOperationDetailDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {number}
     * @memberof StockOperationDetailDto
     */
    productId?: number;
    /**
     * 
     * @type {number}
     * @memberof StockOperationDetailDto
     */
    stockOperationId?: number | null;
    /**
     * 
     * @type {ProductDto}
     * @memberof StockOperationDetailDto
     */
    product?: ProductDto;
    /**
     * 
     * @type {boolean}
     * @memberof StockOperationDetailDto
     */
    isDeleted?: boolean;
    /**
     * 
     * @type {number}
     * @memberof StockOperationDetailDto
     */
    pipedriveDealProductId?: number | null;
    /**
     * 
     * @type {Array<BatchNumberDto>}
     * @memberof StockOperationDetailDto
     */
    batchNumbers?: Array<BatchNumberDto> | null;
}
/**
 * 
 * @export
 * @interface StockOperationDetailsDto
 */
export interface StockOperationDetailsDto {
    /**
     * 
     * @type {number}
     * @memberof StockOperationDetailsDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof StockOperationDetailsDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof StockOperationDetailsDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof StockOperationDetailsDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof StockOperationDetailsDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {number}
     * @memberof StockOperationDetailsDto
     */
    warehouseId?: number | null;
    /**
     * 
     * @type {WarehouseDto}
     * @memberof StockOperationDetailsDto
     */
    warehouse?: WarehouseDto;
    /**
     * 
     * @type {number}
     * @memberof StockOperationDetailsDto
     */
    contractorId?: number | null;
    /**
     * 
     * @type {ContractorDto}
     * @memberof StockOperationDetailsDto
     */
    contractor?: ContractorDto;
    /**
     * 
     * @type {StockOperationType}
     * @memberof StockOperationDetailsDto
     */
    type?: StockOperationType;
    /**
     * 
     * @type {number}
     * @memberof StockOperationDetailsDto
     */
    destinationWarehouseId?: number | null;
    /**
     * 
     * @type {WarehouseDto}
     * @memberof StockOperationDetailsDto
     */
    destinationWarehouse?: WarehouseDto;
    /**
     * 
     * @type {string}
     * @memberof StockOperationDetailsDto
     */
    documentNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StockOperationDetailsDto
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StockOperationDetailsDto
     */
    date?: string;
    /**
     * 
     * @type {boolean}
     * @memberof StockOperationDetailsDto
     */
    isDeleted?: boolean;
    /**
     * 
     * @type {Array<StockOperationDetailDto>}
     * @memberof StockOperationDetailsDto
     */
    stockOperationDetails?: Array<StockOperationDetailDto> | null;
    /**
     * 
     * @type {StockOperationStatus}
     * @memberof StockOperationDetailsDto
     */
    status?: StockOperationStatus;
    /**
     * 
     * @type {string}
     * @memberof StockOperationDetailsDto
     */
    publicationDate?: string | null;
    /**
     * 
     * @type {number}
     * @memberof StockOperationDetailsDto
     */
    parentStockOperationId?: number | null;
    /**
     * 
     * @type {Array<StockOperationDto>}
     * @memberof StockOperationDetailsDto
     */
    stockOperations?: Array<StockOperationDto> | null;
    /**
     * 
     * @type {number}
     * @memberof StockOperationDetailsDto
     */
    productionProcessId?: number | null;
    /**
     * 
     * @type {ProductionProcessMinimalDto}
     * @memberof StockOperationDetailsDto
     */
    productionProcess?: ProductionProcessMinimalDto;
    /**
     * 
     * @type {StockOperationStage}
     * @memberof StockOperationDetailsDto
     */
    stage?: StockOperationStage;
    /**
     * 
     * @type {CropDto}
     * @memberof StockOperationDetailsDto
     */
    crop?: CropDto;
    /**
     * 
     * @type {number}
     * @memberof StockOperationDetailsDto
     */
    cropId?: number | null;
    /**
     * 
     * @type {Array<VinificationAdditiveDto>}
     * @memberof StockOperationDetailsDto
     */
    vinificationAdditives?: Array<VinificationAdditiveDto> | null;
    /**
     * 
     * @type {ApplicationUserMinimalDto}
     * @memberof StockOperationDetailsDto
     */
    createdBy?: ApplicationUserMinimalDto;
    /**
     * 
     * @type {boolean}
     * @memberof StockOperationDetailsDto
     */
    isOrder?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StockOperationDetailsDto
     */
    hasRelatedInvoice?: boolean;
    /**
     * 
     * @type {number}
     * @memberof StockOperationDetailsDto
     */
    pipedriveDealId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof StockOperationDetailsDto
     */
    pipedriveNote?: string | null;
}
/**
 * 
 * @export
 * @interface StockOperationDto
 */
export interface StockOperationDto {
    /**
     * 
     * @type {number}
     * @memberof StockOperationDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof StockOperationDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof StockOperationDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof StockOperationDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof StockOperationDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {number}
     * @memberof StockOperationDto
     */
    warehouseId?: number | null;
    /**
     * 
     * @type {WarehouseDto}
     * @memberof StockOperationDto
     */
    warehouse?: WarehouseDto;
    /**
     * 
     * @type {number}
     * @memberof StockOperationDto
     */
    contractorId?: number | null;
    /**
     * 
     * @type {ContractorDto}
     * @memberof StockOperationDto
     */
    contractor?: ContractorDto;
    /**
     * 
     * @type {StockOperationType}
     * @memberof StockOperationDto
     */
    type?: StockOperationType;
    /**
     * 
     * @type {number}
     * @memberof StockOperationDto
     */
    destinationWarehouseId?: number | null;
    /**
     * 
     * @type {WarehouseDto}
     * @memberof StockOperationDto
     */
    destinationWarehouse?: WarehouseDto;
    /**
     * 
     * @type {string}
     * @memberof StockOperationDto
     */
    documentNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StockOperationDto
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StockOperationDto
     */
    date?: string;
    /**
     * 
     * @type {boolean}
     * @memberof StockOperationDto
     */
    isDeleted?: boolean;
    /**
     * 
     * @type {Array<StockOperationDetailDto>}
     * @memberof StockOperationDto
     */
    stockOperationDetails?: Array<StockOperationDetailDto> | null;
    /**
     * 
     * @type {StockOperationStatus}
     * @memberof StockOperationDto
     */
    status?: StockOperationStatus;
    /**
     * 
     * @type {string}
     * @memberof StockOperationDto
     */
    publicationDate?: string | null;
    /**
     * 
     * @type {number}
     * @memberof StockOperationDto
     */
    parentStockOperationId?: number | null;
    /**
     * 
     * @type {Array<StockOperationDto>}
     * @memberof StockOperationDto
     */
    stockOperations?: Array<StockOperationDto> | null;
    /**
     * 
     * @type {number}
     * @memberof StockOperationDto
     */
    productionProcessId?: number | null;
    /**
     * 
     * @type {ProductionProcessMinimalDto}
     * @memberof StockOperationDto
     */
    productionProcess?: ProductionProcessMinimalDto;
    /**
     * 
     * @type {StockOperationStage}
     * @memberof StockOperationDto
     */
    stage?: StockOperationStage;
    /**
     * 
     * @type {CropDto}
     * @memberof StockOperationDto
     */
    crop?: CropDto;
    /**
     * 
     * @type {number}
     * @memberof StockOperationDto
     */
    cropId?: number | null;
    /**
     * 
     * @type {Array<VinificationAdditiveDto>}
     * @memberof StockOperationDto
     */
    vinificationAdditives?: Array<VinificationAdditiveDto> | null;
    /**
     * 
     * @type {ApplicationUserMinimalDto}
     * @memberof StockOperationDto
     */
    createdBy?: ApplicationUserMinimalDto;
    /**
     * 
     * @type {boolean}
     * @memberof StockOperationDto
     */
    isOrder?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StockOperationDto
     */
    hasRelatedInvoice?: boolean;
    /**
     * 
     * @type {number}
     * @memberof StockOperationDto
     */
    pipedriveDealId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof StockOperationDto
     */
    pipedriveNote?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum StockOperationHistoryValues {
    Date = 'Date',
    Type = 'Type',
    Status = 'Status',
    Product = 'Product',
    Quantity = 'Quantity',
    Operation = 'Operation',
    Contractor = 'Contractor',
    BatchNumber = 'BatchNumber',
    DocumentNumber = 'DocumentNumber',
    StockOperationDetail = 'StockOperationDetail'
}

/**
 * 
 * @export
 * @interface StockOperationMcpDto
 */
export interface StockOperationMcpDto {
    /**
     * 
     * @type {number}
     * @memberof StockOperationMcpDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof StockOperationMcpDto
     */
    warehouseId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof StockOperationMcpDto
     */
    productName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StockOperationMcpDto
     */
    type?: string | null;
    /**
     * 
     * @type {number}
     * @memberof StockOperationMcpDto
     */
    quantity?: number;
    /**
     * 
     * @type {string}
     * @memberof StockOperationMcpDto
     */
    date?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StockOperationMcpDto
     */
    documentNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StockOperationMcpDto
     */
    description?: string | null;
    /**
     * 
     * @type {number}
     * @memberof StockOperationMcpDto
     */
    contractorId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof StockOperationMcpDto
     */
    contractorName?: string | null;
}
/**
 * 
 * @export
 * @interface StockOperationMcpDtoPaginatedMcpDto
 */
export interface StockOperationMcpDtoPaginatedMcpDto {
    /**
     * 
     * @type {number}
     * @memberof StockOperationMcpDtoPaginatedMcpDto
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof StockOperationMcpDtoPaginatedMcpDto
     */
    pageSize?: number;
    /**
     * 
     * @type {number}
     * @memberof StockOperationMcpDtoPaginatedMcpDto
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<StockOperationMcpDto>}
     * @memberof StockOperationMcpDtoPaginatedMcpDto
     */
    items?: Array<StockOperationMcpDto> | null;
}
/**
 * 
 * @export
 * @interface StockOperationMinimalDto
 */
export interface StockOperationMinimalDto {
    /**
     * 
     * @type {number}
     * @memberof StockOperationMinimalDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof StockOperationMinimalDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof StockOperationMinimalDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof StockOperationMinimalDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof StockOperationMinimalDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof StockOperationMinimalDto
     */
    documentNumber?: string | null;
    /**
     * 
     * @type {number}
     * @memberof StockOperationMinimalDto
     */
    contractorId?: number | null;
    /**
     * 
     * @type {ContractorDto}
     * @memberof StockOperationMinimalDto
     */
    contractor?: ContractorDto;
    /**
     * 
     * @type {string}
     * @memberof StockOperationMinimalDto
     */
    date?: string;
    /**
     * 
     * @type {StockOperationType}
     * @memberof StockOperationMinimalDto
     */
    type?: StockOperationType;
    /**
     * 
     * @type {StockOperationStatus}
     * @memberof StockOperationMinimalDto
     */
    status?: StockOperationStatus;
    /**
     * 
     * @type {string}
     * @memberof StockOperationMinimalDto
     */
    publicationDate?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof StockOperationMinimalDto
     */
    isDeleted?: boolean;
    /**
     * 
     * @type {number}
     * @memberof StockOperationMinimalDto
     */
    parentStockOperationId?: number | null;
    /**
     * 
     * @type {ApplicationUserMinimalDto}
     * @memberof StockOperationMinimalDto
     */
    createdBy?: ApplicationUserMinimalDto;
    /**
     * 
     * @type {boolean}
     * @memberof StockOperationMinimalDto
     */
    isOrder?: boolean;
}
/**
 * 
 * @export
 * @interface StockOperationMinimalWithWarehouseDto
 */
export interface StockOperationMinimalWithWarehouseDto {
    /**
     * 
     * @type {number}
     * @memberof StockOperationMinimalWithWarehouseDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof StockOperationMinimalWithWarehouseDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof StockOperationMinimalWithWarehouseDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof StockOperationMinimalWithWarehouseDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof StockOperationMinimalWithWarehouseDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof StockOperationMinimalWithWarehouseDto
     */
    documentNumber?: string | null;
    /**
     * 
     * @type {number}
     * @memberof StockOperationMinimalWithWarehouseDto
     */
    contractorId?: number | null;
    /**
     * 
     * @type {ContractorDto}
     * @memberof StockOperationMinimalWithWarehouseDto
     */
    contractor?: ContractorDto;
    /**
     * 
     * @type {string}
     * @memberof StockOperationMinimalWithWarehouseDto
     */
    date?: string;
    /**
     * 
     * @type {StockOperationType}
     * @memberof StockOperationMinimalWithWarehouseDto
     */
    type?: StockOperationType;
    /**
     * 
     * @type {StockOperationStatus}
     * @memberof StockOperationMinimalWithWarehouseDto
     */
    status?: StockOperationStatus;
    /**
     * 
     * @type {string}
     * @memberof StockOperationMinimalWithWarehouseDto
     */
    publicationDate?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof StockOperationMinimalWithWarehouseDto
     */
    isDeleted?: boolean;
    /**
     * 
     * @type {number}
     * @memberof StockOperationMinimalWithWarehouseDto
     */
    parentStockOperationId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof StockOperationMinimalWithWarehouseDto
     */
    warehouseId?: number | null;
    /**
     * 
     * @type {WarehouseDto}
     * @memberof StockOperationMinimalWithWarehouseDto
     */
    warehouse?: WarehouseDto;
    /**
     * 
     * @type {number}
     * @memberof StockOperationMinimalWithWarehouseDto
     */
    destinationWarehouseId?: number | null;
    /**
     * 
     * @type {WarehouseDto}
     * @memberof StockOperationMinimalWithWarehouseDto
     */
    destinationWarehouse?: WarehouseDto;
    /**
     * 
     * @type {Array<StockOperationMinimalWithWarehouseDto>}
     * @memberof StockOperationMinimalWithWarehouseDto
     */
    stockOperations?: Array<StockOperationMinimalWithWarehouseDto> | null;
    /**
     * 
     * @type {ApplicationUserMinimalDto}
     * @memberof StockOperationMinimalWithWarehouseDto
     */
    createdBy?: ApplicationUserMinimalDto;
    /**
     * 
     * @type {boolean}
     * @memberof StockOperationMinimalWithWarehouseDto
     */
    isOrder?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum StockOperationStage {
    Harvest = 'Harvest',
    Embossing = 'Embossing',
    Transfer = 'Transfer',
    Racking = 'Racking',
    Fermentation = 'Fermentation',
    Stabilization = 'Stabilization',
    Bottling = 'Bottling',
    Labeling = 'Labeling'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum StockOperationStatus {
    Draft = 'Draft',
    ForCompletion = 'ForCompletion',
    Published = 'Published'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum StockOperationType {
    Pz = 'PZ',
    Wz = 'WZ',
    Mm = 'MM',
    Pw = 'PW',
    Rw = 'RW',
    Opp = 'OPP',
    Opw = 'OPW',
    Oi = 'OI',
    Vn = 'VN'
}

/**
 * 
 * @export
 * @interface StockOperationUpdateDto
 */
export interface StockOperationUpdateDto {
    /**
     * 
     * @type {number}
     * @memberof StockOperationUpdateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof StockOperationUpdateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof StockOperationUpdateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof StockOperationUpdateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof StockOperationUpdateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {number}
     * @memberof StockOperationUpdateDto
     */
    warehouseId?: number | null;
    /**
     * 
     * @type {WarehouseDto}
     * @memberof StockOperationUpdateDto
     */
    warehouse?: WarehouseDto;
    /**
     * 
     * @type {number}
     * @memberof StockOperationUpdateDto
     */
    contractorId?: number | null;
    /**
     * 
     * @type {ContractorDto}
     * @memberof StockOperationUpdateDto
     */
    contractor?: ContractorDto;
    /**
     * 
     * @type {StockOperationType}
     * @memberof StockOperationUpdateDto
     */
    type?: StockOperationType;
    /**
     * 
     * @type {number}
     * @memberof StockOperationUpdateDto
     */
    destinationWarehouseId?: number | null;
    /**
     * 
     * @type {WarehouseDto}
     * @memberof StockOperationUpdateDto
     */
    destinationWarehouse?: WarehouseDto;
    /**
     * 
     * @type {string}
     * @memberof StockOperationUpdateDto
     */
    documentNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StockOperationUpdateDto
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StockOperationUpdateDto
     */
    date?: string;
    /**
     * 
     * @type {boolean}
     * @memberof StockOperationUpdateDto
     */
    isDeleted?: boolean;
    /**
     * 
     * @type {Array<StockOperationDetailDto>}
     * @memberof StockOperationUpdateDto
     */
    stockOperationDetails?: Array<StockOperationDetailDto> | null;
    /**
     * 
     * @type {StockOperationStatus}
     * @memberof StockOperationUpdateDto
     */
    status?: StockOperationStatus;
    /**
     * 
     * @type {string}
     * @memberof StockOperationUpdateDto
     */
    publicationDate?: string | null;
    /**
     * 
     * @type {number}
     * @memberof StockOperationUpdateDto
     */
    parentStockOperationId?: number | null;
    /**
     * 
     * @type {Array<StockOperationDto>}
     * @memberof StockOperationUpdateDto
     */
    stockOperations?: Array<StockOperationDto> | null;
    /**
     * 
     * @type {number}
     * @memberof StockOperationUpdateDto
     */
    productionProcessId?: number | null;
    /**
     * 
     * @type {ProductionProcessMinimalDto}
     * @memberof StockOperationUpdateDto
     */
    productionProcess?: ProductionProcessMinimalDto;
    /**
     * 
     * @type {StockOperationStage}
     * @memberof StockOperationUpdateDto
     */
    stage?: StockOperationStage;
    /**
     * 
     * @type {CropDto}
     * @memberof StockOperationUpdateDto
     */
    crop?: CropDto;
    /**
     * 
     * @type {number}
     * @memberof StockOperationUpdateDto
     */
    cropId?: number | null;
    /**
     * 
     * @type {Array<VinificationAdditiveDto>}
     * @memberof StockOperationUpdateDto
     */
    vinificationAdditives?: Array<VinificationAdditiveDto> | null;
    /**
     * 
     * @type {ApplicationUserMinimalDto}
     * @memberof StockOperationUpdateDto
     */
    createdBy?: ApplicationUserMinimalDto;
    /**
     * 
     * @type {boolean}
     * @memberof StockOperationUpdateDto
     */
    isOrder?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StockOperationUpdateDto
     */
    hasRelatedInvoice?: boolean;
    /**
     * 
     * @type {number}
     * @memberof StockOperationUpdateDto
     */
    pipedriveDealId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof StockOperationUpdateDto
     */
    pipedriveNote?: string | null;
}
/**
 * 
 * @export
 * @interface StockOperationUpdateHistoryCreateDto
 */
export interface StockOperationUpdateHistoryCreateDto {
    /**
     * 
     * @type {number}
     * @memberof StockOperationUpdateHistoryCreateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof StockOperationUpdateHistoryCreateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof StockOperationUpdateHistoryCreateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof StockOperationUpdateHistoryCreateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof StockOperationUpdateHistoryCreateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof StockOperationUpdateHistoryCreateDto
     */
    oldValue?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StockOperationUpdateHistoryCreateDto
     */
    newValue?: string | null;
    /**
     * 
     * @type {OperationType}
     * @memberof StockOperationUpdateHistoryCreateDto
     */
    operationType?: OperationType;
    /**
     * 
     * @type {ApplicationUserDto}
     * @memberof StockOperationUpdateHistoryCreateDto
     */
    createdBy?: ApplicationUserDto;
    /**
     * 
     * @type {number}
     * @memberof StockOperationUpdateHistoryCreateDto
     */
    stockOperationId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof StockOperationUpdateHistoryCreateDto
     */
    stockOperationDetailId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof StockOperationUpdateHistoryCreateDto
     */
    translatedChangedValueName?: string | null;
    /**
     * 
     * @type {BatchNumberDto}
     * @memberof StockOperationUpdateHistoryCreateDto
     */
    batchNumber?: BatchNumberDto;
    /**
     * 
     * @type {StockOperationDetailDto}
     * @memberof StockOperationUpdateHistoryCreateDto
     */
    stockOperationDetail?: StockOperationDetailDto;
    /**
     * 
     * @type {StockOperationHistoryValues}
     * @memberof StockOperationUpdateHistoryCreateDto
     */
    changedValueName?: StockOperationHistoryValues;
    /**
     * 
     * @type {StockOperationType}
     * @memberof StockOperationUpdateHistoryCreateDto
     */
    stockOperationType?: StockOperationType;
    /**
     * 
     * @type {StockOperationDto}
     * @memberof StockOperationUpdateHistoryCreateDto
     */
    stockOperation?: StockOperationDto;
}
/**
 * 
 * @export
 * @interface StockOperationUpdateHistoryDetailsDto
 */
export interface StockOperationUpdateHistoryDetailsDto {
    /**
     * 
     * @type {number}
     * @memberof StockOperationUpdateHistoryDetailsDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof StockOperationUpdateHistoryDetailsDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof StockOperationUpdateHistoryDetailsDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof StockOperationUpdateHistoryDetailsDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof StockOperationUpdateHistoryDetailsDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof StockOperationUpdateHistoryDetailsDto
     */
    oldValue?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StockOperationUpdateHistoryDetailsDto
     */
    newValue?: string | null;
    /**
     * 
     * @type {OperationType}
     * @memberof StockOperationUpdateHistoryDetailsDto
     */
    operationType?: OperationType;
    /**
     * 
     * @type {ApplicationUserDto}
     * @memberof StockOperationUpdateHistoryDetailsDto
     */
    createdBy?: ApplicationUserDto;
    /**
     * 
     * @type {number}
     * @memberof StockOperationUpdateHistoryDetailsDto
     */
    stockOperationId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof StockOperationUpdateHistoryDetailsDto
     */
    stockOperationDetailId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof StockOperationUpdateHistoryDetailsDto
     */
    translatedChangedValueName?: string | null;
    /**
     * 
     * @type {StockOperationHistoryValues}
     * @memberof StockOperationUpdateHistoryDetailsDto
     */
    changedValueName?: StockOperationHistoryValues;
    /**
     * 
     * @type {StockOperationType}
     * @memberof StockOperationUpdateHistoryDetailsDto
     */
    stockOperationType?: StockOperationType;
    /**
     * 
     * @type {StockOperationDto}
     * @memberof StockOperationUpdateHistoryDetailsDto
     */
    stockOperation?: StockOperationDto;
    /**
     * 
     * @type {StockOperationDetailDto}
     * @memberof StockOperationUpdateHistoryDetailsDto
     */
    stockOperationDetail?: StockOperationDetailDto;
    /**
     * 
     * @type {StockOperationType}
     * @memberof StockOperationUpdateHistoryDetailsDto
     */
    type?: StockOperationType;
    /**
     * 
     * @type {number}
     * @memberof StockOperationUpdateHistoryDetailsDto
     */
    quantity?: number;
    /**
     * 
     * @type {UnitOfMeasureDto}
     * @memberof StockOperationUpdateHistoryDetailsDto
     */
    unit?: UnitOfMeasureDto;
    /**
     * 
     * @type {BatchNumberDto}
     * @memberof StockOperationUpdateHistoryDetailsDto
     */
    batchNumber?: BatchNumberDto;
    /**
     * 
     * @type {string}
     * @memberof StockOperationUpdateHistoryDetailsDto
     */
    documentNumber?: string | null;
    /**
     * 
     * @type {number}
     * @memberof StockOperationUpdateHistoryDetailsDto
     */
    internalStockOperationWarehouseSourceId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof StockOperationUpdateHistoryDetailsDto
     */
    internalStockOperationWarehouseDestinationId?: number | null;
}
/**
 * 
 * @export
 * @interface StockOperationUpdateHistoryDto
 */
export interface StockOperationUpdateHistoryDto {
    /**
     * 
     * @type {number}
     * @memberof StockOperationUpdateHistoryDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof StockOperationUpdateHistoryDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof StockOperationUpdateHistoryDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof StockOperationUpdateHistoryDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof StockOperationUpdateHistoryDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof StockOperationUpdateHistoryDto
     */
    oldValue?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StockOperationUpdateHistoryDto
     */
    newValue?: string | null;
    /**
     * 
     * @type {OperationType}
     * @memberof StockOperationUpdateHistoryDto
     */
    operationType?: OperationType;
    /**
     * 
     * @type {ApplicationUserDto}
     * @memberof StockOperationUpdateHistoryDto
     */
    createdBy?: ApplicationUserDto;
    /**
     * 
     * @type {number}
     * @memberof StockOperationUpdateHistoryDto
     */
    stockOperationId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof StockOperationUpdateHistoryDto
     */
    stockOperationDetailId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof StockOperationUpdateHistoryDto
     */
    translatedChangedValueName?: string | null;
    /**
     * 
     * @type {BatchNumberDto}
     * @memberof StockOperationUpdateHistoryDto
     */
    batchNumber?: BatchNumberDto;
    /**
     * 
     * @type {StockOperationDetailDto}
     * @memberof StockOperationUpdateHistoryDto
     */
    stockOperationDetail?: StockOperationDetailDto;
    /**
     * 
     * @type {StockOperationHistoryValues}
     * @memberof StockOperationUpdateHistoryDto
     */
    changedValueName?: StockOperationHistoryValues;
    /**
     * 
     * @type {StockOperationType}
     * @memberof StockOperationUpdateHistoryDto
     */
    stockOperationType?: StockOperationType;
    /**
     * 
     * @type {StockOperationDto}
     * @memberof StockOperationUpdateHistoryDto
     */
    stockOperation?: StockOperationDto;
}
/**
 * 
 * @export
 * @interface StockOperationUpdateHistoryUpdateDto
 */
export interface StockOperationUpdateHistoryUpdateDto {
    /**
     * 
     * @type {number}
     * @memberof StockOperationUpdateHistoryUpdateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof StockOperationUpdateHistoryUpdateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof StockOperationUpdateHistoryUpdateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof StockOperationUpdateHistoryUpdateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof StockOperationUpdateHistoryUpdateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof StockOperationUpdateHistoryUpdateDto
     */
    oldValue?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StockOperationUpdateHistoryUpdateDto
     */
    newValue?: string | null;
    /**
     * 
     * @type {OperationType}
     * @memberof StockOperationUpdateHistoryUpdateDto
     */
    operationType?: OperationType;
    /**
     * 
     * @type {ApplicationUserDto}
     * @memberof StockOperationUpdateHistoryUpdateDto
     */
    createdBy?: ApplicationUserDto;
    /**
     * 
     * @type {number}
     * @memberof StockOperationUpdateHistoryUpdateDto
     */
    stockOperationId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof StockOperationUpdateHistoryUpdateDto
     */
    stockOperationDetailId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof StockOperationUpdateHistoryUpdateDto
     */
    translatedChangedValueName?: string | null;
    /**
     * 
     * @type {BatchNumberDto}
     * @memberof StockOperationUpdateHistoryUpdateDto
     */
    batchNumber?: BatchNumberDto;
    /**
     * 
     * @type {StockOperationDetailDto}
     * @memberof StockOperationUpdateHistoryUpdateDto
     */
    stockOperationDetail?: StockOperationDetailDto;
    /**
     * 
     * @type {StockOperationHistoryValues}
     * @memberof StockOperationUpdateHistoryUpdateDto
     */
    changedValueName?: StockOperationHistoryValues;
    /**
     * 
     * @type {StockOperationType}
     * @memberof StockOperationUpdateHistoryUpdateDto
     */
    stockOperationType?: StockOperationType;
    /**
     * 
     * @type {StockOperationDto}
     * @memberof StockOperationUpdateHistoryUpdateDto
     */
    stockOperation?: StockOperationDto;
}
/**
 * 
 * @export
 * @interface StrainCreateDto
 */
export interface StrainCreateDto {
    /**
     * 
     * @type {number}
     * @memberof StrainCreateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof StrainCreateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof StrainCreateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof StrainCreateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof StrainCreateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof StrainCreateDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StrainCreateDto
     */
    description?: string | null;
}
/**
 * 
 * @export
 * @interface StrainDetailsDto
 */
export interface StrainDetailsDto {
    /**
     * 
     * @type {number}
     * @memberof StrainDetailsDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof StrainDetailsDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof StrainDetailsDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof StrainDetailsDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof StrainDetailsDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof StrainDetailsDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StrainDetailsDto
     */
    description?: string | null;
    /**
     * 
     * @type {Array<ProductionProcessDto>}
     * @memberof StrainDetailsDto
     */
    productionProcesses?: Array<ProductionProcessDto> | null;
    /**
     * 
     * @type {Array<CropDto>}
     * @memberof StrainDetailsDto
     */
    crops?: Array<CropDto> | null;
    /**
     * 
     * @type {Array<CropStrainMinimalDto>}
     * @memberof StrainDetailsDto
     */
    cropStrains?: Array<CropStrainMinimalDto> | null;
}
/**
 * 
 * @export
 * @interface StrainDto
 */
export interface StrainDto {
    /**
     * 
     * @type {number}
     * @memberof StrainDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof StrainDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof StrainDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof StrainDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof StrainDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof StrainDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StrainDto
     */
    description?: string | null;
}
/**
 * 
 * @export
 * @interface StrainMcpDto
 */
export interface StrainMcpDto {
    /**
     * 
     * @type {number}
     * @memberof StrainMcpDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof StrainMcpDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StrainMcpDto
     */
    description?: string | null;
    /**
     * 
     * @type {number}
     * @memberof StrainMcpDto
     */
    cropId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof StrainMcpDto
     */
    cropName?: string | null;
}
/**
 * 
 * @export
 * @interface StrainMcpDtoPaginatedMcpDto
 */
export interface StrainMcpDtoPaginatedMcpDto {
    /**
     * 
     * @type {number}
     * @memberof StrainMcpDtoPaginatedMcpDto
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof StrainMcpDtoPaginatedMcpDto
     */
    pageSize?: number;
    /**
     * 
     * @type {number}
     * @memberof StrainMcpDtoPaginatedMcpDto
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<StrainMcpDto>}
     * @memberof StrainMcpDtoPaginatedMcpDto
     */
    items?: Array<StrainMcpDto> | null;
}
/**
 * 
 * @export
 * @interface StrainUpdateDto
 */
export interface StrainUpdateDto {
    /**
     * 
     * @type {number}
     * @memberof StrainUpdateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof StrainUpdateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof StrainUpdateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof StrainUpdateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof StrainUpdateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof StrainUpdateDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StrainUpdateDto
     */
    description?: string | null;
}
/**
 * 
 * @export
 * @interface UnitOfMeasureCreateDto
 */
export interface UnitOfMeasureCreateDto {
    /**
     * 
     * @type {number}
     * @memberof UnitOfMeasureCreateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof UnitOfMeasureCreateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof UnitOfMeasureCreateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof UnitOfMeasureCreateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UnitOfMeasureCreateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UnitOfMeasureCreateDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnitOfMeasureCreateDto
     */
    code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnitOfMeasureCreateDto
     */
    description?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UnitOfMeasureCreateDto
     */
    conversionToBase?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UnitOfMeasureCreateDto
     */
    baseUnitId?: number | null;
    /**
     * 
     * @type {SimpleBaseUnitDto}
     * @memberof UnitOfMeasureCreateDto
     */
    baseUnit?: SimpleBaseUnitDto;
    /**
     * 
     * @type {Array<UnitOfMeasureDto>}
     * @memberof UnitOfMeasureCreateDto
     */
    auxiliaryUnits?: Array<UnitOfMeasureDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof UnitOfMeasureCreateDto
     */
    isDeleted?: boolean;
}
/**
 * 
 * @export
 * @interface UnitOfMeasureDetailsDto
 */
export interface UnitOfMeasureDetailsDto {
    /**
     * 
     * @type {number}
     * @memberof UnitOfMeasureDetailsDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof UnitOfMeasureDetailsDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof UnitOfMeasureDetailsDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof UnitOfMeasureDetailsDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UnitOfMeasureDetailsDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UnitOfMeasureDetailsDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnitOfMeasureDetailsDto
     */
    code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnitOfMeasureDetailsDto
     */
    description?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UnitOfMeasureDetailsDto
     */
    conversionToBase?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UnitOfMeasureDetailsDto
     */
    baseUnitId?: number | null;
    /**
     * 
     * @type {SimpleBaseUnitDto}
     * @memberof UnitOfMeasureDetailsDto
     */
    baseUnit?: SimpleBaseUnitDto;
    /**
     * 
     * @type {Array<UnitOfMeasureDto>}
     * @memberof UnitOfMeasureDetailsDto
     */
    auxiliaryUnits?: Array<UnitOfMeasureDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof UnitOfMeasureDetailsDto
     */
    isDeleted?: boolean;
    /**
     * 
     * @type {Array<ProductDto>}
     * @memberof UnitOfMeasureDetailsDto
     */
    baseUnitProducts?: Array<ProductDto> | null;
    /**
     * 
     * @type {Array<ProductDto>}
     * @memberof UnitOfMeasureDetailsDto
     */
    auxilaryUnitsProducts?: Array<ProductDto> | null;
}
/**
 * 
 * @export
 * @interface UnitOfMeasureDto
 */
export interface UnitOfMeasureDto {
    /**
     * 
     * @type {number}
     * @memberof UnitOfMeasureDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof UnitOfMeasureDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof UnitOfMeasureDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof UnitOfMeasureDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UnitOfMeasureDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UnitOfMeasureDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnitOfMeasureDto
     */
    code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnitOfMeasureDto
     */
    description?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UnitOfMeasureDto
     */
    conversionToBase?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UnitOfMeasureDto
     */
    baseUnitId?: number | null;
    /**
     * 
     * @type {SimpleBaseUnitDto}
     * @memberof UnitOfMeasureDto
     */
    baseUnit?: SimpleBaseUnitDto;
    /**
     * 
     * @type {Array<UnitOfMeasureDto>}
     * @memberof UnitOfMeasureDto
     */
    auxiliaryUnits?: Array<UnitOfMeasureDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof UnitOfMeasureDto
     */
    isDeleted?: boolean;
}
/**
 * 
 * @export
 * @interface UnitOfMeasureUpdateDto
 */
export interface UnitOfMeasureUpdateDto {
    /**
     * 
     * @type {number}
     * @memberof UnitOfMeasureUpdateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof UnitOfMeasureUpdateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof UnitOfMeasureUpdateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof UnitOfMeasureUpdateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UnitOfMeasureUpdateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UnitOfMeasureUpdateDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnitOfMeasureUpdateDto
     */
    code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnitOfMeasureUpdateDto
     */
    description?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UnitOfMeasureUpdateDto
     */
    conversionToBase?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UnitOfMeasureUpdateDto
     */
    baseUnitId?: number | null;
    /**
     * 
     * @type {SimpleBaseUnitDto}
     * @memberof UnitOfMeasureUpdateDto
     */
    baseUnit?: SimpleBaseUnitDto;
    /**
     * 
     * @type {Array<UnitOfMeasureDto>}
     * @memberof UnitOfMeasureUpdateDto
     */
    auxiliaryUnits?: Array<UnitOfMeasureDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof UnitOfMeasureUpdateDto
     */
    isDeleted?: boolean;
}
/**
 * 
 * @export
 * @interface VinificationAdditiveCreateDto
 */
export interface VinificationAdditiveCreateDto {
    /**
     * 
     * @type {number}
     * @memberof VinificationAdditiveCreateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof VinificationAdditiveCreateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof VinificationAdditiveCreateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof VinificationAdditiveCreateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VinificationAdditiveCreateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {number}
     * @memberof VinificationAdditiveCreateDto
     */
    stockOperationId?: number;
    /**
     * 
     * @type {string}
     * @memberof VinificationAdditiveCreateDto
     */
    additiveName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VinificationAdditiveCreateDto
     */
    quantity?: number;
    /**
     * 
     * @type {number}
     * @memberof VinificationAdditiveCreateDto
     */
    unitId?: number;
    /**
     * 
     * @type {UnitOfMeasureDto}
     * @memberof VinificationAdditiveCreateDto
     */
    unit?: UnitOfMeasureDto;
}
/**
 * 
 * @export
 * @interface VinificationAdditiveDetailsDto
 */
export interface VinificationAdditiveDetailsDto {
    /**
     * 
     * @type {number}
     * @memberof VinificationAdditiveDetailsDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof VinificationAdditiveDetailsDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof VinificationAdditiveDetailsDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof VinificationAdditiveDetailsDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VinificationAdditiveDetailsDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {number}
     * @memberof VinificationAdditiveDetailsDto
     */
    stockOperationId?: number;
    /**
     * 
     * @type {string}
     * @memberof VinificationAdditiveDetailsDto
     */
    additiveName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VinificationAdditiveDetailsDto
     */
    quantity?: number;
    /**
     * 
     * @type {number}
     * @memberof VinificationAdditiveDetailsDto
     */
    unitId?: number;
    /**
     * 
     * @type {UnitOfMeasureDto}
     * @memberof VinificationAdditiveDetailsDto
     */
    unit?: UnitOfMeasureDto;
}
/**
 * 
 * @export
 * @interface VinificationAdditiveDto
 */
export interface VinificationAdditiveDto {
    /**
     * 
     * @type {number}
     * @memberof VinificationAdditiveDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof VinificationAdditiveDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof VinificationAdditiveDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof VinificationAdditiveDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VinificationAdditiveDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {number}
     * @memberof VinificationAdditiveDto
     */
    stockOperationId?: number;
    /**
     * 
     * @type {string}
     * @memberof VinificationAdditiveDto
     */
    additiveName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VinificationAdditiveDto
     */
    quantity?: number;
    /**
     * 
     * @type {number}
     * @memberof VinificationAdditiveDto
     */
    unitId?: number;
    /**
     * 
     * @type {UnitOfMeasureDto}
     * @memberof VinificationAdditiveDto
     */
    unit?: UnitOfMeasureDto;
}
/**
 * 
 * @export
 * @interface VinificationAdditiveUpdateDto
 */
export interface VinificationAdditiveUpdateDto {
    /**
     * 
     * @type {number}
     * @memberof VinificationAdditiveUpdateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof VinificationAdditiveUpdateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof VinificationAdditiveUpdateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof VinificationAdditiveUpdateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VinificationAdditiveUpdateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {number}
     * @memberof VinificationAdditiveUpdateDto
     */
    stockOperationId?: number;
    /**
     * 
     * @type {string}
     * @memberof VinificationAdditiveUpdateDto
     */
    additiveName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VinificationAdditiveUpdateDto
     */
    quantity?: number;
    /**
     * 
     * @type {number}
     * @memberof VinificationAdditiveUpdateDto
     */
    unitId?: number;
    /**
     * 
     * @type {UnitOfMeasureDto}
     * @memberof VinificationAdditiveUpdateDto
     */
    unit?: UnitOfMeasureDto;
}
/**
 * 
 * @export
 * @interface WarehouseCreateDto
 */
export interface WarehouseCreateDto {
    /**
     * 
     * @type {number}
     * @memberof WarehouseCreateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof WarehouseCreateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof WarehouseCreateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof WarehouseCreateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WarehouseCreateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof WarehouseCreateDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WarehouseCreateDto
     */
    description?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WarehouseCreateDto
     */
    parentWarehouseId?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof WarehouseCreateDto
     */
    isDeleted?: boolean;
    /**
     * 
     * @type {WarehouseType}
     * @memberof WarehouseCreateDto
     */
    type?: WarehouseType;
}
/**
 * 
 * @export
 * @interface WarehouseDetailsDto
 */
export interface WarehouseDetailsDto {
    /**
     * 
     * @type {number}
     * @memberof WarehouseDetailsDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof WarehouseDetailsDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof WarehouseDetailsDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof WarehouseDetailsDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WarehouseDetailsDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof WarehouseDetailsDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WarehouseDetailsDto
     */
    description?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WarehouseDetailsDto
     */
    parentWarehouseId?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof WarehouseDetailsDto
     */
    isDeleted?: boolean;
    /**
     * 
     * @type {WarehouseType}
     * @memberof WarehouseDetailsDto
     */
    type?: WarehouseType;
    /**
     * 
     * @type {WarehouseDto}
     * @memberof WarehouseDetailsDto
     */
    parentWarehouse?: WarehouseDto;
    /**
     * 
     * @type {Array<WarehouseDto>}
     * @memberof WarehouseDetailsDto
     */
    warehouses?: Array<WarehouseDto> | null;
}
/**
 * 
 * @export
 * @interface WarehouseDto
 */
export interface WarehouseDto {
    /**
     * 
     * @type {number}
     * @memberof WarehouseDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof WarehouseDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof WarehouseDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof WarehouseDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WarehouseDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof WarehouseDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WarehouseDto
     */
    description?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WarehouseDto
     */
    parentWarehouseId?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof WarehouseDto
     */
    isDeleted?: boolean;
    /**
     * 
     * @type {WarehouseType}
     * @memberof WarehouseDto
     */
    type?: WarehouseType;
}
/**
 * 
 * @export
 * @interface WarehouseMcpDto
 */
export interface WarehouseMcpDto {
    /**
     * 
     * @type {number}
     * @memberof WarehouseMcpDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof WarehouseMcpDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WarehouseMcpDto
     */
    description?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof WarehouseMcpDto
     */
    isDeleted?: boolean;
}
/**
 * 
 * @export
 * @interface WarehouseMcpDtoPaginatedMcpDto
 */
export interface WarehouseMcpDtoPaginatedMcpDto {
    /**
     * 
     * @type {number}
     * @memberof WarehouseMcpDtoPaginatedMcpDto
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof WarehouseMcpDtoPaginatedMcpDto
     */
    pageSize?: number;
    /**
     * 
     * @type {number}
     * @memberof WarehouseMcpDtoPaginatedMcpDto
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<WarehouseMcpDto>}
     * @memberof WarehouseMcpDtoPaginatedMcpDto
     */
    items?: Array<WarehouseMcpDto> | null;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum WarehouseType {
    Tank = 'Tank',
    Other = 'Other',
    FinishedProducts = 'FinishedProducts'
}

/**
 * 
 * @export
 * @interface WarehouseUpdateDto
 */
export interface WarehouseUpdateDto {
    /**
     * 
     * @type {number}
     * @memberof WarehouseUpdateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof WarehouseUpdateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof WarehouseUpdateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof WarehouseUpdateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WarehouseUpdateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof WarehouseUpdateDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WarehouseUpdateDto
     */
    description?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WarehouseUpdateDto
     */
    parentWarehouseId?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof WarehouseUpdateDto
     */
    isDeleted?: boolean;
    /**
     * 
     * @type {WarehouseType}
     * @memberof WarehouseUpdateDto
     */
    type?: WarehouseType;
}
/**
 * 
 * @export
 * @interface WarehouseUpdateHistoryCreateDto
 */
export interface WarehouseUpdateHistoryCreateDto {
    /**
     * 
     * @type {number}
     * @memberof WarehouseUpdateHistoryCreateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof WarehouseUpdateHistoryCreateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof WarehouseUpdateHistoryCreateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof WarehouseUpdateHistoryCreateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WarehouseUpdateHistoryCreateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof WarehouseUpdateHistoryCreateDto
     */
    oldValue?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WarehouseUpdateHistoryCreateDto
     */
    newValue?: string | null;
    /**
     * 
     * @type {OperationType}
     * @memberof WarehouseUpdateHistoryCreateDto
     */
    operationType?: OperationType;
    /**
     * 
     * @type {ApplicationUserDto}
     * @memberof WarehouseUpdateHistoryCreateDto
     */
    createdBy?: ApplicationUserDto;
    /**
     * 
     * @type {number}
     * @memberof WarehouseUpdateHistoryCreateDto
     */
    warehouseId?: number;
    /**
     * 
     * @type {string}
     * @memberof WarehouseUpdateHistoryCreateDto
     */
    translatedChangedValueName?: string | null;
}
/**
 * 
 * @export
 * @interface WarehouseUpdateHistoryDetailsDto
 */
export interface WarehouseUpdateHistoryDetailsDto {
    /**
     * 
     * @type {number}
     * @memberof WarehouseUpdateHistoryDetailsDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof WarehouseUpdateHistoryDetailsDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof WarehouseUpdateHistoryDetailsDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof WarehouseUpdateHistoryDetailsDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WarehouseUpdateHistoryDetailsDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof WarehouseUpdateHistoryDetailsDto
     */
    oldValue?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WarehouseUpdateHistoryDetailsDto
     */
    newValue?: string | null;
    /**
     * 
     * @type {OperationType}
     * @memberof WarehouseUpdateHistoryDetailsDto
     */
    operationType?: OperationType;
    /**
     * 
     * @type {ApplicationUserDto}
     * @memberof WarehouseUpdateHistoryDetailsDto
     */
    createdBy?: ApplicationUserDto;
    /**
     * 
     * @type {number}
     * @memberof WarehouseUpdateHistoryDetailsDto
     */
    warehouseId?: number;
    /**
     * 
     * @type {string}
     * @memberof WarehouseUpdateHistoryDetailsDto
     */
    translatedChangedValueName?: string | null;
}
/**
 * 
 * @export
 * @interface WarehouseUpdateHistoryDto
 */
export interface WarehouseUpdateHistoryDto {
    /**
     * 
     * @type {number}
     * @memberof WarehouseUpdateHistoryDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof WarehouseUpdateHistoryDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof WarehouseUpdateHistoryDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof WarehouseUpdateHistoryDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WarehouseUpdateHistoryDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof WarehouseUpdateHistoryDto
     */
    oldValue?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WarehouseUpdateHistoryDto
     */
    newValue?: string | null;
    /**
     * 
     * @type {OperationType}
     * @memberof WarehouseUpdateHistoryDto
     */
    operationType?: OperationType;
    /**
     * 
     * @type {ApplicationUserDto}
     * @memberof WarehouseUpdateHistoryDto
     */
    createdBy?: ApplicationUserDto;
    /**
     * 
     * @type {number}
     * @memberof WarehouseUpdateHistoryDto
     */
    warehouseId?: number;
    /**
     * 
     * @type {string}
     * @memberof WarehouseUpdateHistoryDto
     */
    translatedChangedValueName?: string | null;
}
/**
 * 
 * @export
 * @interface WarehouseUpdateHistoryUpdateDto
 */
export interface WarehouseUpdateHistoryUpdateDto {
    /**
     * 
     * @type {number}
     * @memberof WarehouseUpdateHistoryUpdateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof WarehouseUpdateHistoryUpdateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof WarehouseUpdateHistoryUpdateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof WarehouseUpdateHistoryUpdateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WarehouseUpdateHistoryUpdateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof WarehouseUpdateHistoryUpdateDto
     */
    oldValue?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WarehouseUpdateHistoryUpdateDto
     */
    newValue?: string | null;
    /**
     * 
     * @type {OperationType}
     * @memberof WarehouseUpdateHistoryUpdateDto
     */
    operationType?: OperationType;
    /**
     * 
     * @type {ApplicationUserDto}
     * @memberof WarehouseUpdateHistoryUpdateDto
     */
    createdBy?: ApplicationUserDto;
    /**
     * 
     * @type {number}
     * @memberof WarehouseUpdateHistoryUpdateDto
     */
    warehouseId?: number;
    /**
     * 
     * @type {string}
     * @memberof WarehouseUpdateHistoryUpdateDto
     */
    translatedChangedValueName?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum WineColor {
    Red = 'Red',
    White = 'White',
    Rose = 'Rose',
    Orange = 'Orange'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum WineSweetness {
    Dry = 'Dry',
    SemiDry = 'SemiDry',
    SemiSweet = 'SemiSweet',
    Sweet = 'Sweet'
}


/**
 * ApplicationUserApi - axios parameter creator
 * @export
 */
export const ApplicationUserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [auth0UserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserDelete: async (auth0UserId?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ApplicationUser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (auth0UserId !== undefined) {
                localVarQueryParameter['auth0UserId'] = auth0UserId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ApplicationUser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApplicationUserRegisterDto} [applicationUserRegisterDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserInviteUserPost: async (applicationUserRegisterDto?: ApplicationUserRegisterDto, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ApplicationUser/inviteUser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(applicationUserRegisterDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserMerchantsGet: async (userId?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ApplicationUser/merchants`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserPingHead: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ApplicationUser/ping`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'HEAD', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [userId] 
         * @param {ApplicationUserRegisterDto} [applicationUserRegisterDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserPut: async (userId?: number, applicationUserRegisterDto?: ApplicationUserRegisterDto, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ApplicationUser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(applicationUserRegisterDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserUserDetailsGet: async (userId?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ApplicationUser/userDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserUserDetailsMinimalGet: async (userId?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ApplicationUser/userDetailsMinimal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserUsersGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ApplicationUser/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ApplicationUserApi - functional programming interface
 * @export
 */
export const ApplicationUserApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ApplicationUserApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [auth0UserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiApplicationUserDelete(auth0UserId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiApplicationUserDelete(auth0UserId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiApplicationUserGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApplicationUserDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiApplicationUserGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApplicationUserRegisterDto} [applicationUserRegisterDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiApplicationUserInviteUserPost(applicationUserRegisterDto?: ApplicationUserRegisterDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApplicationUserRegisterDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiApplicationUserInviteUserPost(applicationUserRegisterDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiApplicationUserMerchantsGet(userId?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApplicationUserDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiApplicationUserMerchantsGet(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiApplicationUserPingHead(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiApplicationUserPingHead(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [userId] 
         * @param {ApplicationUserRegisterDto} [applicationUserRegisterDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiApplicationUserPut(userId?: number, applicationUserRegisterDto?: ApplicationUserRegisterDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApplicationUserDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiApplicationUserPut(userId, applicationUserRegisterDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiApplicationUserUserDetailsGet(userId?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApplicationUserRegisterDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiApplicationUserUserDetailsGet(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiApplicationUserUserDetailsMinimalGet(userId?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApplicationUserBaseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiApplicationUserUserDetailsMinimalGet(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiApplicationUserUsersGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApplicationUserDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiApplicationUserUsersGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ApplicationUserApi - factory interface
 * @export
 */
export const ApplicationUserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ApplicationUserApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [auth0UserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserDelete(auth0UserId?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiApplicationUserDelete(auth0UserId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserGet(options?: any): AxiosPromise<ApplicationUserDetailsDto> {
            return localVarFp.apiApplicationUserGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApplicationUserRegisterDto} [applicationUserRegisterDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserInviteUserPost(applicationUserRegisterDto?: ApplicationUserRegisterDto, options?: any): AxiosPromise<ApplicationUserRegisterDto> {
            return localVarFp.apiApplicationUserInviteUserPost(applicationUserRegisterDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserMerchantsGet(userId?: number, options?: any): AxiosPromise<Array<ApplicationUserDto>> {
            return localVarFp.apiApplicationUserMerchantsGet(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserPingHead(options?: any): AxiosPromise<void> {
            return localVarFp.apiApplicationUserPingHead(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [userId] 
         * @param {ApplicationUserRegisterDto} [applicationUserRegisterDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserPut(userId?: number, applicationUserRegisterDto?: ApplicationUserRegisterDto, options?: any): AxiosPromise<ApplicationUserDetailsDto> {
            return localVarFp.apiApplicationUserPut(userId, applicationUserRegisterDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserUserDetailsGet(userId?: number, options?: any): AxiosPromise<ApplicationUserRegisterDto> {
            return localVarFp.apiApplicationUserUserDetailsGet(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserUserDetailsMinimalGet(userId?: number, options?: any): AxiosPromise<ApplicationUserBaseDto> {
            return localVarFp.apiApplicationUserUserDetailsMinimalGet(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserUsersGet(options?: any): AxiosPromise<Array<ApplicationUserDto>> {
            return localVarFp.apiApplicationUserUsersGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ApplicationUserApi - object-oriented interface
 * @export
 * @class ApplicationUserApi
 * @extends {BaseAPI}
 */
export class ApplicationUserApi extends BaseAPI {
    /**
     * 
     * @param {string} [auth0UserId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationUserApi
     */
    public apiApplicationUserDelete(auth0UserId?: string, options?: any) {
        return ApplicationUserApiFp(this.configuration).apiApplicationUserDelete(auth0UserId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationUserApi
     */
    public apiApplicationUserGet(options?: any) {
        return ApplicationUserApiFp(this.configuration).apiApplicationUserGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApplicationUserRegisterDto} [applicationUserRegisterDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationUserApi
     */
    public apiApplicationUserInviteUserPost(applicationUserRegisterDto?: ApplicationUserRegisterDto, options?: any) {
        return ApplicationUserApiFp(this.configuration).apiApplicationUserInviteUserPost(applicationUserRegisterDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationUserApi
     */
    public apiApplicationUserMerchantsGet(userId?: number, options?: any) {
        return ApplicationUserApiFp(this.configuration).apiApplicationUserMerchantsGet(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationUserApi
     */
    public apiApplicationUserPingHead(options?: any) {
        return ApplicationUserApiFp(this.configuration).apiApplicationUserPingHead(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [userId] 
     * @param {ApplicationUserRegisterDto} [applicationUserRegisterDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationUserApi
     */
    public apiApplicationUserPut(userId?: number, applicationUserRegisterDto?: ApplicationUserRegisterDto, options?: any) {
        return ApplicationUserApiFp(this.configuration).apiApplicationUserPut(userId, applicationUserRegisterDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationUserApi
     */
    public apiApplicationUserUserDetailsGet(userId?: number, options?: any) {
        return ApplicationUserApiFp(this.configuration).apiApplicationUserUserDetailsGet(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationUserApi
     */
    public apiApplicationUserUserDetailsMinimalGet(userId?: number, options?: any) {
        return ApplicationUserApiFp(this.configuration).apiApplicationUserUserDetailsMinimalGet(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationUserApi
     */
    public apiApplicationUserUsersGet(options?: any) {
        return ApplicationUserApiFp(this.configuration).apiApplicationUserUsersGet(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ApplicationUserUpdateHistoryApi - axios parameter creator
 * @export
 */
export const ApplicationUserUpdateHistoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserUpdateHistoryGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ApplicationUserUpdateHistory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserUpdateHistoryHistoryUserIdGet: async (userId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('apiApplicationUserUpdateHistoryHistoryUserIdGet', 'userId', userId)
            const localVarPath = `/api/ApplicationUserUpdateHistory/history/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserUpdateHistoryIdDelete: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiApplicationUserUpdateHistoryIdDelete', 'id', id)
            const localVarPath = `/api/ApplicationUserUpdateHistory/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserUpdateHistoryIdGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiApplicationUserUpdateHistoryIdGet', 'id', id)
            const localVarPath = `/api/ApplicationUserUpdateHistory/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ApplicationUserUpdateHistoryUpdateDto} [applicationUserUpdateHistoryUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserUpdateHistoryIdPut: async (id: number, applicationUserUpdateHistoryUpdateDto?: ApplicationUserUpdateHistoryUpdateDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiApplicationUserUpdateHistoryIdPut', 'id', id)
            const localVarPath = `/api/ApplicationUserUpdateHistory/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(applicationUserUpdateHistoryUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApplicationUserUpdateHistoryCreateDto} [applicationUserUpdateHistoryCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserUpdateHistoryPost: async (applicationUserUpdateHistoryCreateDto?: ApplicationUserUpdateHistoryCreateDto, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ApplicationUserUpdateHistory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(applicationUserUpdateHistoryCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ApplicationUserUpdateHistoryApi - functional programming interface
 * @export
 */
export const ApplicationUserUpdateHistoryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ApplicationUserUpdateHistoryApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiApplicationUserUpdateHistoryGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApplicationUserUpdateHistoryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiApplicationUserUpdateHistoryGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiApplicationUserUpdateHistoryHistoryUserIdGet(userId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApplicationUserUpdateHistoryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiApplicationUserUpdateHistoryHistoryUserIdGet(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiApplicationUserUpdateHistoryIdDelete(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiApplicationUserUpdateHistoryIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiApplicationUserUpdateHistoryIdGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApplicationUserUpdateHistoryDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiApplicationUserUpdateHistoryIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {ApplicationUserUpdateHistoryUpdateDto} [applicationUserUpdateHistoryUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiApplicationUserUpdateHistoryIdPut(id: number, applicationUserUpdateHistoryUpdateDto?: ApplicationUserUpdateHistoryUpdateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApplicationUserUpdateHistoryDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiApplicationUserUpdateHistoryIdPut(id, applicationUserUpdateHistoryUpdateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApplicationUserUpdateHistoryCreateDto} [applicationUserUpdateHistoryCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiApplicationUserUpdateHistoryPost(applicationUserUpdateHistoryCreateDto?: ApplicationUserUpdateHistoryCreateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApplicationUserUpdateHistoryDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiApplicationUserUpdateHistoryPost(applicationUserUpdateHistoryCreateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ApplicationUserUpdateHistoryApi - factory interface
 * @export
 */
export const ApplicationUserUpdateHistoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ApplicationUserUpdateHistoryApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserUpdateHistoryGet(options?: any): AxiosPromise<Array<ApplicationUserUpdateHistoryDto>> {
            return localVarFp.apiApplicationUserUpdateHistoryGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserUpdateHistoryHistoryUserIdGet(userId: number, options?: any): AxiosPromise<Array<ApplicationUserUpdateHistoryDto>> {
            return localVarFp.apiApplicationUserUpdateHistoryHistoryUserIdGet(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserUpdateHistoryIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiApplicationUserUpdateHistoryIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserUpdateHistoryIdGet(id: number, options?: any): AxiosPromise<ApplicationUserUpdateHistoryDetailsDto> {
            return localVarFp.apiApplicationUserUpdateHistoryIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ApplicationUserUpdateHistoryUpdateDto} [applicationUserUpdateHistoryUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserUpdateHistoryIdPut(id: number, applicationUserUpdateHistoryUpdateDto?: ApplicationUserUpdateHistoryUpdateDto, options?: any): AxiosPromise<ApplicationUserUpdateHistoryDetailsDto> {
            return localVarFp.apiApplicationUserUpdateHistoryIdPut(id, applicationUserUpdateHistoryUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApplicationUserUpdateHistoryCreateDto} [applicationUserUpdateHistoryCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserUpdateHistoryPost(applicationUserUpdateHistoryCreateDto?: ApplicationUserUpdateHistoryCreateDto, options?: any): AxiosPromise<ApplicationUserUpdateHistoryDetailsDto> {
            return localVarFp.apiApplicationUserUpdateHistoryPost(applicationUserUpdateHistoryCreateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ApplicationUserUpdateHistoryApi - object-oriented interface
 * @export
 * @class ApplicationUserUpdateHistoryApi
 * @extends {BaseAPI}
 */
export class ApplicationUserUpdateHistoryApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationUserUpdateHistoryApi
     */
    public apiApplicationUserUpdateHistoryGet(options?: any) {
        return ApplicationUserUpdateHistoryApiFp(this.configuration).apiApplicationUserUpdateHistoryGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationUserUpdateHistoryApi
     */
    public apiApplicationUserUpdateHistoryHistoryUserIdGet(userId: number, options?: any) {
        return ApplicationUserUpdateHistoryApiFp(this.configuration).apiApplicationUserUpdateHistoryHistoryUserIdGet(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationUserUpdateHistoryApi
     */
    public apiApplicationUserUpdateHistoryIdDelete(id: number, options?: any) {
        return ApplicationUserUpdateHistoryApiFp(this.configuration).apiApplicationUserUpdateHistoryIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationUserUpdateHistoryApi
     */
    public apiApplicationUserUpdateHistoryIdGet(id: number, options?: any) {
        return ApplicationUserUpdateHistoryApiFp(this.configuration).apiApplicationUserUpdateHistoryIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ApplicationUserUpdateHistoryUpdateDto} [applicationUserUpdateHistoryUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationUserUpdateHistoryApi
     */
    public apiApplicationUserUpdateHistoryIdPut(id: number, applicationUserUpdateHistoryUpdateDto?: ApplicationUserUpdateHistoryUpdateDto, options?: any) {
        return ApplicationUserUpdateHistoryApiFp(this.configuration).apiApplicationUserUpdateHistoryIdPut(id, applicationUserUpdateHistoryUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApplicationUserUpdateHistoryCreateDto} [applicationUserUpdateHistoryCreateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationUserUpdateHistoryApi
     */
    public apiApplicationUserUpdateHistoryPost(applicationUserUpdateHistoryCreateDto?: ApplicationUserUpdateHistoryCreateDto, options?: any) {
        return ApplicationUserUpdateHistoryApiFp(this.configuration).apiApplicationUserUpdateHistoryPost(applicationUserUpdateHistoryCreateDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CompanyDataApi - axios parameter creator
 * @export
 */
export const CompanyDataApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCompanyDataGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/CompanyData`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCompanyDataIdDelete: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiCompanyDataIdDelete', 'id', id)
            const localVarPath = `/api/CompanyData/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCompanyDataIdGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiCompanyDataIdGet', 'id', id)
            const localVarPath = `/api/CompanyData/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {CompanyDataUpdateDto} [companyDataUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCompanyDataIdPut: async (id: number, companyDataUpdateDto?: CompanyDataUpdateDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiCompanyDataIdPut', 'id', id)
            const localVarPath = `/api/CompanyData/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(companyDataUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCompanyDataMinimalGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/CompanyData/minimal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CompanyDataCreateDto} [companyDataCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCompanyDataPost: async (companyDataCreateDto?: CompanyDataCreateDto, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/CompanyData`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(companyDataCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CompanyDataApi - functional programming interface
 * @export
 */
export const CompanyDataApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CompanyDataApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCompanyDataGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CompanyDataDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCompanyDataGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCompanyDataIdDelete(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCompanyDataIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCompanyDataIdGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyDataDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCompanyDataIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {CompanyDataUpdateDto} [companyDataUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCompanyDataIdPut(id: number, companyDataUpdateDto?: CompanyDataUpdateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyDataDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCompanyDataIdPut(id, companyDataUpdateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCompanyDataMinimalGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyDataMinimalDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCompanyDataMinimalGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CompanyDataCreateDto} [companyDataCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCompanyDataPost(companyDataCreateDto?: CompanyDataCreateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyDataDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCompanyDataPost(companyDataCreateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CompanyDataApi - factory interface
 * @export
 */
export const CompanyDataApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CompanyDataApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCompanyDataGet(options?: any): AxiosPromise<Array<CompanyDataDto>> {
            return localVarFp.apiCompanyDataGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCompanyDataIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiCompanyDataIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCompanyDataIdGet(id: number, options?: any): AxiosPromise<CompanyDataDetailsDto> {
            return localVarFp.apiCompanyDataIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {CompanyDataUpdateDto} [companyDataUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCompanyDataIdPut(id: number, companyDataUpdateDto?: CompanyDataUpdateDto, options?: any): AxiosPromise<CompanyDataDetailsDto> {
            return localVarFp.apiCompanyDataIdPut(id, companyDataUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCompanyDataMinimalGet(options?: any): AxiosPromise<CompanyDataMinimalDto> {
            return localVarFp.apiCompanyDataMinimalGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompanyDataCreateDto} [companyDataCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCompanyDataPost(companyDataCreateDto?: CompanyDataCreateDto, options?: any): AxiosPromise<CompanyDataDetailsDto> {
            return localVarFp.apiCompanyDataPost(companyDataCreateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CompanyDataApi - object-oriented interface
 * @export
 * @class CompanyDataApi
 * @extends {BaseAPI}
 */
export class CompanyDataApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyDataApi
     */
    public apiCompanyDataGet(options?: any) {
        return CompanyDataApiFp(this.configuration).apiCompanyDataGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyDataApi
     */
    public apiCompanyDataIdDelete(id: number, options?: any) {
        return CompanyDataApiFp(this.configuration).apiCompanyDataIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyDataApi
     */
    public apiCompanyDataIdGet(id: number, options?: any) {
        return CompanyDataApiFp(this.configuration).apiCompanyDataIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {CompanyDataUpdateDto} [companyDataUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyDataApi
     */
    public apiCompanyDataIdPut(id: number, companyDataUpdateDto?: CompanyDataUpdateDto, options?: any) {
        return CompanyDataApiFp(this.configuration).apiCompanyDataIdPut(id, companyDataUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyDataApi
     */
    public apiCompanyDataMinimalGet(options?: any) {
        return CompanyDataApiFp(this.configuration).apiCompanyDataMinimalGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompanyDataCreateDto} [companyDataCreateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyDataApi
     */
    public apiCompanyDataPost(companyDataCreateDto?: CompanyDataCreateDto, options?: any) {
        return CompanyDataApiFp(this.configuration).apiCompanyDataPost(companyDataCreateDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CompanyDataUpdateHistoryApi - axios parameter creator
 * @export
 */
export const CompanyDataUpdateHistoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCompanyDataUpdateHistoryGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/CompanyDataUpdateHistory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCompanyDataUpdateHistoryIdDelete: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiCompanyDataUpdateHistoryIdDelete', 'id', id)
            const localVarPath = `/api/CompanyDataUpdateHistory/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCompanyDataUpdateHistoryIdGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiCompanyDataUpdateHistoryIdGet', 'id', id)
            const localVarPath = `/api/CompanyDataUpdateHistory/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {CompanyDataUpdateHistoryUpdateDto} [companyDataUpdateHistoryUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCompanyDataUpdateHistoryIdPut: async (id: number, companyDataUpdateHistoryUpdateDto?: CompanyDataUpdateHistoryUpdateDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiCompanyDataUpdateHistoryIdPut', 'id', id)
            const localVarPath = `/api/CompanyDataUpdateHistory/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(companyDataUpdateHistoryUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CompanyDataUpdateHistoryCreateDto} [companyDataUpdateHistoryCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCompanyDataUpdateHistoryPost: async (companyDataUpdateHistoryCreateDto?: CompanyDataUpdateHistoryCreateDto, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/CompanyDataUpdateHistory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(companyDataUpdateHistoryCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CompanyDataUpdateHistoryApi - functional programming interface
 * @export
 */
export const CompanyDataUpdateHistoryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CompanyDataUpdateHistoryApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCompanyDataUpdateHistoryGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CompanyDataUpdateHistoryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCompanyDataUpdateHistoryGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCompanyDataUpdateHistoryIdDelete(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCompanyDataUpdateHistoryIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCompanyDataUpdateHistoryIdGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyDataUpdateHistoryDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCompanyDataUpdateHistoryIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {CompanyDataUpdateHistoryUpdateDto} [companyDataUpdateHistoryUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCompanyDataUpdateHistoryIdPut(id: number, companyDataUpdateHistoryUpdateDto?: CompanyDataUpdateHistoryUpdateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyDataUpdateHistoryDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCompanyDataUpdateHistoryIdPut(id, companyDataUpdateHistoryUpdateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CompanyDataUpdateHistoryCreateDto} [companyDataUpdateHistoryCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCompanyDataUpdateHistoryPost(companyDataUpdateHistoryCreateDto?: CompanyDataUpdateHistoryCreateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyDataUpdateHistoryDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCompanyDataUpdateHistoryPost(companyDataUpdateHistoryCreateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CompanyDataUpdateHistoryApi - factory interface
 * @export
 */
export const CompanyDataUpdateHistoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CompanyDataUpdateHistoryApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCompanyDataUpdateHistoryGet(options?: any): AxiosPromise<Array<CompanyDataUpdateHistoryDto>> {
            return localVarFp.apiCompanyDataUpdateHistoryGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCompanyDataUpdateHistoryIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiCompanyDataUpdateHistoryIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCompanyDataUpdateHistoryIdGet(id: number, options?: any): AxiosPromise<CompanyDataUpdateHistoryDetailsDto> {
            return localVarFp.apiCompanyDataUpdateHistoryIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {CompanyDataUpdateHistoryUpdateDto} [companyDataUpdateHistoryUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCompanyDataUpdateHistoryIdPut(id: number, companyDataUpdateHistoryUpdateDto?: CompanyDataUpdateHistoryUpdateDto, options?: any): AxiosPromise<CompanyDataUpdateHistoryDetailsDto> {
            return localVarFp.apiCompanyDataUpdateHistoryIdPut(id, companyDataUpdateHistoryUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompanyDataUpdateHistoryCreateDto} [companyDataUpdateHistoryCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCompanyDataUpdateHistoryPost(companyDataUpdateHistoryCreateDto?: CompanyDataUpdateHistoryCreateDto, options?: any): AxiosPromise<CompanyDataUpdateHistoryDetailsDto> {
            return localVarFp.apiCompanyDataUpdateHistoryPost(companyDataUpdateHistoryCreateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CompanyDataUpdateHistoryApi - object-oriented interface
 * @export
 * @class CompanyDataUpdateHistoryApi
 * @extends {BaseAPI}
 */
export class CompanyDataUpdateHistoryApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyDataUpdateHistoryApi
     */
    public apiCompanyDataUpdateHistoryGet(options?: any) {
        return CompanyDataUpdateHistoryApiFp(this.configuration).apiCompanyDataUpdateHistoryGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyDataUpdateHistoryApi
     */
    public apiCompanyDataUpdateHistoryIdDelete(id: number, options?: any) {
        return CompanyDataUpdateHistoryApiFp(this.configuration).apiCompanyDataUpdateHistoryIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyDataUpdateHistoryApi
     */
    public apiCompanyDataUpdateHistoryIdGet(id: number, options?: any) {
        return CompanyDataUpdateHistoryApiFp(this.configuration).apiCompanyDataUpdateHistoryIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {CompanyDataUpdateHistoryUpdateDto} [companyDataUpdateHistoryUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyDataUpdateHistoryApi
     */
    public apiCompanyDataUpdateHistoryIdPut(id: number, companyDataUpdateHistoryUpdateDto?: CompanyDataUpdateHistoryUpdateDto, options?: any) {
        return CompanyDataUpdateHistoryApiFp(this.configuration).apiCompanyDataUpdateHistoryIdPut(id, companyDataUpdateHistoryUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompanyDataUpdateHistoryCreateDto} [companyDataUpdateHistoryCreateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyDataUpdateHistoryApi
     */
    public apiCompanyDataUpdateHistoryPost(companyDataUpdateHistoryCreateDto?: CompanyDataUpdateHistoryCreateDto, options?: any) {
        return CompanyDataUpdateHistoryApiFp(this.configuration).apiCompanyDataUpdateHistoryPost(companyDataUpdateHistoryCreateDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ContractorApi - axios parameter creator
 * @export
 */
export const ContractorApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorCalendarFeedTokenPost: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Contractor/calendar/feed-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorCalendarTokenIcsGet: async (token: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('apiContractorCalendarTokenIcsGet', 'token', token)
            const localVarPath = `/api/Contractor/calendar/{token}.ics`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Contractor`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorIdDelete: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiContractorIdDelete', 'id', id)
            const localVarPath = `/api/Contractor/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorIdGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiContractorIdGet', 'id', id)
            const localVarPath = `/api/Contractor/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorIdMeetingsGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiContractorIdMeetingsGet', 'id', id)
            const localVarPath = `/api/Contractor/{id}/meetings`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {MeetingDto} [meetingDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorIdMeetingsPost: async (id: string, meetingDto?: MeetingDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiContractorIdMeetingsPost', 'id', id)
            const localVarPath = `/api/Contractor/{id}/meetings`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(meetingDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {MeetingChangeStatusDto} [meetingChangeStatusDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorIdMeetingsPut: async (id: string, meetingChangeStatusDto?: MeetingChangeStatusDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiContractorIdMeetingsPut', 'id', id)
            const localVarPath = `/api/Contractor/{id}/meetings`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(meetingChangeStatusDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ContractorUpdateDto} [contractorUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorIdPut: async (id: number, contractorUpdateDto?: ContractorUpdateDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiContractorIdPut', 'id', id)
            const localVarPath = `/api/Contractor/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(contractorUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} date 
         * @param {boolean} [isMonth] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorMeetingsDateGet: async (date: string, isMonth?: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'date' is not null or undefined
            assertParamExists('apiContractorMeetingsDateGet', 'date', date)
            const localVarPath = `/api/Contractor/meetings/{date}`
                .replace(`{${"date"}}`, encodeURIComponent(String(date)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (isMonth !== undefined) {
                localVarQueryParameter['isMonth'] = isMonth;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} date 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorMeetingsYearDateGet: async (date: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'date' is not null or undefined
            assertParamExists('apiContractorMeetingsYearDateGet', 'date', date)
            const localVarPath = `/api/Contractor/meetings/year/{date}`
                .replace(`{${"date"}}`, encodeURIComponent(String(date)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean} mineOnly 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorMineOnlyContractorsByMerchantGet: async (mineOnly: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'mineOnly' is not null or undefined
            assertParamExists('apiContractorMineOnlyContractorsByMerchantGet', 'mineOnly', mineOnly)
            const localVarPath = `/api/Contractor/{mineOnly}/contractorsByMerchant`
                .replace(`{${"mineOnly"}}`, encodeURIComponent(String(mineOnly)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ContractorCreateDto} [contractorCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorPost: async (contractorCreateDto?: ContractorCreateDto, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Contractor`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(contractorCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ContractorApi - functional programming interface
 * @export
 */
export const ContractorApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ContractorApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiContractorCalendarFeedTokenPost(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiContractorCalendarFeedTokenPost(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiContractorCalendarTokenIcsGet(token: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiContractorCalendarTokenIcsGet(token, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiContractorGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ContractorDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiContractorGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiContractorIdDelete(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiContractorIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiContractorIdGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContractorDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiContractorIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiContractorIdMeetingsGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MeetingDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiContractorIdMeetingsGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {MeetingDto} [meetingDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiContractorIdMeetingsPost(id: string, meetingDto?: MeetingDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MeetingDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiContractorIdMeetingsPost(id, meetingDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {MeetingChangeStatusDto} [meetingChangeStatusDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiContractorIdMeetingsPut(id: string, meetingChangeStatusDto?: MeetingChangeStatusDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MeetingDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiContractorIdMeetingsPut(id, meetingChangeStatusDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {ContractorUpdateDto} [contractorUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiContractorIdPut(id: number, contractorUpdateDto?: ContractorUpdateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContractorDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiContractorIdPut(id, contractorUpdateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} date 
         * @param {boolean} [isMonth] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiContractorMeetingsDateGet(date: string, isMonth?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MeetingDetailsDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiContractorMeetingsDateGet(date, isMonth, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} date 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiContractorMeetingsYearDateGet(date: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MeetingDetailsDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiContractorMeetingsYearDateGet(date, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {boolean} mineOnly 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiContractorMineOnlyContractorsByMerchantGet(mineOnly: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ContractorDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiContractorMineOnlyContractorsByMerchantGet(mineOnly, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ContractorCreateDto} [contractorCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiContractorPost(contractorCreateDto?: ContractorCreateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContractorDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiContractorPost(contractorCreateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ContractorApi - factory interface
 * @export
 */
export const ContractorApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ContractorApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorCalendarFeedTokenPost(options?: any): AxiosPromise<void> {
            return localVarFp.apiContractorCalendarFeedTokenPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorCalendarTokenIcsGet(token: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiContractorCalendarTokenIcsGet(token, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorGet(options?: any): AxiosPromise<Array<ContractorDto>> {
            return localVarFp.apiContractorGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiContractorIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorIdGet(id: number, options?: any): AxiosPromise<ContractorDetailsDto> {
            return localVarFp.apiContractorIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorIdMeetingsGet(id: number, options?: any): AxiosPromise<Array<MeetingDto>> {
            return localVarFp.apiContractorIdMeetingsGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {MeetingDto} [meetingDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorIdMeetingsPost(id: string, meetingDto?: MeetingDto, options?: any): AxiosPromise<Array<MeetingDto>> {
            return localVarFp.apiContractorIdMeetingsPost(id, meetingDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {MeetingChangeStatusDto} [meetingChangeStatusDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorIdMeetingsPut(id: string, meetingChangeStatusDto?: MeetingChangeStatusDto, options?: any): AxiosPromise<Array<MeetingDto>> {
            return localVarFp.apiContractorIdMeetingsPut(id, meetingChangeStatusDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ContractorUpdateDto} [contractorUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorIdPut(id: number, contractorUpdateDto?: ContractorUpdateDto, options?: any): AxiosPromise<ContractorDetailsDto> {
            return localVarFp.apiContractorIdPut(id, contractorUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} date 
         * @param {boolean} [isMonth] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorMeetingsDateGet(date: string, isMonth?: boolean, options?: any): AxiosPromise<Array<MeetingDetailsDto>> {
            return localVarFp.apiContractorMeetingsDateGet(date, isMonth, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} date 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorMeetingsYearDateGet(date: string, options?: any): AxiosPromise<Array<MeetingDetailsDto>> {
            return localVarFp.apiContractorMeetingsYearDateGet(date, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {boolean} mineOnly 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorMineOnlyContractorsByMerchantGet(mineOnly: boolean, options?: any): AxiosPromise<Array<ContractorDto>> {
            return localVarFp.apiContractorMineOnlyContractorsByMerchantGet(mineOnly, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ContractorCreateDto} [contractorCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorPost(contractorCreateDto?: ContractorCreateDto, options?: any): AxiosPromise<ContractorDetailsDto> {
            return localVarFp.apiContractorPost(contractorCreateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ContractorApi - object-oriented interface
 * @export
 * @class ContractorApi
 * @extends {BaseAPI}
 */
export class ContractorApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractorApi
     */
    public apiContractorCalendarFeedTokenPost(options?: any) {
        return ContractorApiFp(this.configuration).apiContractorCalendarFeedTokenPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} token 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractorApi
     */
    public apiContractorCalendarTokenIcsGet(token: string, options?: any) {
        return ContractorApiFp(this.configuration).apiContractorCalendarTokenIcsGet(token, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractorApi
     */
    public apiContractorGet(options?: any) {
        return ContractorApiFp(this.configuration).apiContractorGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractorApi
     */
    public apiContractorIdDelete(id: number, options?: any) {
        return ContractorApiFp(this.configuration).apiContractorIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractorApi
     */
    public apiContractorIdGet(id: number, options?: any) {
        return ContractorApiFp(this.configuration).apiContractorIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractorApi
     */
    public apiContractorIdMeetingsGet(id: number, options?: any) {
        return ContractorApiFp(this.configuration).apiContractorIdMeetingsGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {MeetingDto} [meetingDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractorApi
     */
    public apiContractorIdMeetingsPost(id: string, meetingDto?: MeetingDto, options?: any) {
        return ContractorApiFp(this.configuration).apiContractorIdMeetingsPost(id, meetingDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {MeetingChangeStatusDto} [meetingChangeStatusDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractorApi
     */
    public apiContractorIdMeetingsPut(id: string, meetingChangeStatusDto?: MeetingChangeStatusDto, options?: any) {
        return ContractorApiFp(this.configuration).apiContractorIdMeetingsPut(id, meetingChangeStatusDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ContractorUpdateDto} [contractorUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractorApi
     */
    public apiContractorIdPut(id: number, contractorUpdateDto?: ContractorUpdateDto, options?: any) {
        return ContractorApiFp(this.configuration).apiContractorIdPut(id, contractorUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} date 
     * @param {boolean} [isMonth] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractorApi
     */
    public apiContractorMeetingsDateGet(date: string, isMonth?: boolean, options?: any) {
        return ContractorApiFp(this.configuration).apiContractorMeetingsDateGet(date, isMonth, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} date 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractorApi
     */
    public apiContractorMeetingsYearDateGet(date: string, options?: any) {
        return ContractorApiFp(this.configuration).apiContractorMeetingsYearDateGet(date, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {boolean} mineOnly 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractorApi
     */
    public apiContractorMineOnlyContractorsByMerchantGet(mineOnly: boolean, options?: any) {
        return ContractorApiFp(this.configuration).apiContractorMineOnlyContractorsByMerchantGet(mineOnly, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ContractorCreateDto} [contractorCreateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractorApi
     */
    public apiContractorPost(contractorCreateDto?: ContractorCreateDto, options?: any) {
        return ContractorApiFp(this.configuration).apiContractorPost(contractorCreateDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ContractorUpdateHistoryApi - axios parameter creator
 * @export
 */
export const ContractorUpdateHistoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorUpdateHistoryGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ContractorUpdateHistory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorUpdateHistoryIdDelete: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiContractorUpdateHistoryIdDelete', 'id', id)
            const localVarPath = `/api/ContractorUpdateHistory/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorUpdateHistoryIdGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiContractorUpdateHistoryIdGet', 'id', id)
            const localVarPath = `/api/ContractorUpdateHistory/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorUpdateHistoryIdHistoryGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiContractorUpdateHistoryIdHistoryGet', 'id', id)
            const localVarPath = `/api/ContractorUpdateHistory/{id}/history`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ContractorUpdateHistoryUpdateDto} [contractorUpdateHistoryUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorUpdateHistoryIdPut: async (id: number, contractorUpdateHistoryUpdateDto?: ContractorUpdateHistoryUpdateDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiContractorUpdateHistoryIdPut', 'id', id)
            const localVarPath = `/api/ContractorUpdateHistory/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(contractorUpdateHistoryUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ContractorUpdateHistoryCreateDto} [contractorUpdateHistoryCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorUpdateHistoryPost: async (contractorUpdateHistoryCreateDto?: ContractorUpdateHistoryCreateDto, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ContractorUpdateHistory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(contractorUpdateHistoryCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ContractorUpdateHistoryApi - functional programming interface
 * @export
 */
export const ContractorUpdateHistoryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ContractorUpdateHistoryApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiContractorUpdateHistoryGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ContractorUpdateHistoryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiContractorUpdateHistoryGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiContractorUpdateHistoryIdDelete(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiContractorUpdateHistoryIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiContractorUpdateHistoryIdGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContractorUpdateHistoryDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiContractorUpdateHistoryIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiContractorUpdateHistoryIdHistoryGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ContractorUpdateHistoryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiContractorUpdateHistoryIdHistoryGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {ContractorUpdateHistoryUpdateDto} [contractorUpdateHistoryUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiContractorUpdateHistoryIdPut(id: number, contractorUpdateHistoryUpdateDto?: ContractorUpdateHistoryUpdateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContractorUpdateHistoryDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiContractorUpdateHistoryIdPut(id, contractorUpdateHistoryUpdateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ContractorUpdateHistoryCreateDto} [contractorUpdateHistoryCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiContractorUpdateHistoryPost(contractorUpdateHistoryCreateDto?: ContractorUpdateHistoryCreateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContractorUpdateHistoryDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiContractorUpdateHistoryPost(contractorUpdateHistoryCreateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ContractorUpdateHistoryApi - factory interface
 * @export
 */
export const ContractorUpdateHistoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ContractorUpdateHistoryApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorUpdateHistoryGet(options?: any): AxiosPromise<Array<ContractorUpdateHistoryDto>> {
            return localVarFp.apiContractorUpdateHistoryGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorUpdateHistoryIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiContractorUpdateHistoryIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorUpdateHistoryIdGet(id: number, options?: any): AxiosPromise<ContractorUpdateHistoryDetailsDto> {
            return localVarFp.apiContractorUpdateHistoryIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorUpdateHistoryIdHistoryGet(id: number, options?: any): AxiosPromise<Array<ContractorUpdateHistoryDto>> {
            return localVarFp.apiContractorUpdateHistoryIdHistoryGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ContractorUpdateHistoryUpdateDto} [contractorUpdateHistoryUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorUpdateHistoryIdPut(id: number, contractorUpdateHistoryUpdateDto?: ContractorUpdateHistoryUpdateDto, options?: any): AxiosPromise<ContractorUpdateHistoryDetailsDto> {
            return localVarFp.apiContractorUpdateHistoryIdPut(id, contractorUpdateHistoryUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ContractorUpdateHistoryCreateDto} [contractorUpdateHistoryCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorUpdateHistoryPost(contractorUpdateHistoryCreateDto?: ContractorUpdateHistoryCreateDto, options?: any): AxiosPromise<ContractorUpdateHistoryDetailsDto> {
            return localVarFp.apiContractorUpdateHistoryPost(contractorUpdateHistoryCreateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ContractorUpdateHistoryApi - object-oriented interface
 * @export
 * @class ContractorUpdateHistoryApi
 * @extends {BaseAPI}
 */
export class ContractorUpdateHistoryApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractorUpdateHistoryApi
     */
    public apiContractorUpdateHistoryGet(options?: any) {
        return ContractorUpdateHistoryApiFp(this.configuration).apiContractorUpdateHistoryGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractorUpdateHistoryApi
     */
    public apiContractorUpdateHistoryIdDelete(id: number, options?: any) {
        return ContractorUpdateHistoryApiFp(this.configuration).apiContractorUpdateHistoryIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractorUpdateHistoryApi
     */
    public apiContractorUpdateHistoryIdGet(id: number, options?: any) {
        return ContractorUpdateHistoryApiFp(this.configuration).apiContractorUpdateHistoryIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractorUpdateHistoryApi
     */
    public apiContractorUpdateHistoryIdHistoryGet(id: number, options?: any) {
        return ContractorUpdateHistoryApiFp(this.configuration).apiContractorUpdateHistoryIdHistoryGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ContractorUpdateHistoryUpdateDto} [contractorUpdateHistoryUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractorUpdateHistoryApi
     */
    public apiContractorUpdateHistoryIdPut(id: number, contractorUpdateHistoryUpdateDto?: ContractorUpdateHistoryUpdateDto, options?: any) {
        return ContractorUpdateHistoryApiFp(this.configuration).apiContractorUpdateHistoryIdPut(id, contractorUpdateHistoryUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ContractorUpdateHistoryCreateDto} [contractorUpdateHistoryCreateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractorUpdateHistoryApi
     */
    public apiContractorUpdateHistoryPost(contractorUpdateHistoryCreateDto?: ContractorUpdateHistoryCreateDto, options?: any) {
        return ContractorUpdateHistoryApiFp(this.configuration).apiContractorUpdateHistoryPost(contractorUpdateHistoryCreateDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CropApi - axios parameter creator
 * @export
 */
export const CropApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCropGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Crop`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCropIdDelete: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiCropIdDelete', 'id', id)
            const localVarPath = `/api/Crop/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCropIdGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiCropIdGet', 'id', id)
            const localVarPath = `/api/Crop/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {CropUpdateDto} [cropUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCropIdPut: async (id: number, cropUpdateDto?: CropUpdateDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiCropIdPut', 'id', id)
            const localVarPath = `/api/Crop/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cropUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CropCreateDto} [cropCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCropPost: async (cropCreateDto?: CropCreateDto, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Crop`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cropCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CropApi - functional programming interface
 * @export
 */
export const CropApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CropApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCropGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CropDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCropGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCropIdDelete(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCropIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCropIdGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CropDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCropIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {CropUpdateDto} [cropUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCropIdPut(id: number, cropUpdateDto?: CropUpdateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CropDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCropIdPut(id, cropUpdateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CropCreateDto} [cropCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCropPost(cropCreateDto?: CropCreateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CropDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCropPost(cropCreateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CropApi - factory interface
 * @export
 */
export const CropApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CropApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCropGet(options?: any): AxiosPromise<Array<CropDto>> {
            return localVarFp.apiCropGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCropIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiCropIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCropIdGet(id: number, options?: any): AxiosPromise<CropDetailsDto> {
            return localVarFp.apiCropIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {CropUpdateDto} [cropUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCropIdPut(id: number, cropUpdateDto?: CropUpdateDto, options?: any): AxiosPromise<CropDetailsDto> {
            return localVarFp.apiCropIdPut(id, cropUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CropCreateDto} [cropCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCropPost(cropCreateDto?: CropCreateDto, options?: any): AxiosPromise<CropDetailsDto> {
            return localVarFp.apiCropPost(cropCreateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CropApi - object-oriented interface
 * @export
 * @class CropApi
 * @extends {BaseAPI}
 */
export class CropApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CropApi
     */
    public apiCropGet(options?: any) {
        return CropApiFp(this.configuration).apiCropGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CropApi
     */
    public apiCropIdDelete(id: number, options?: any) {
        return CropApiFp(this.configuration).apiCropIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CropApi
     */
    public apiCropIdGet(id: number, options?: any) {
        return CropApiFp(this.configuration).apiCropIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {CropUpdateDto} [cropUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CropApi
     */
    public apiCropIdPut(id: number, cropUpdateDto?: CropUpdateDto, options?: any) {
        return CropApiFp(this.configuration).apiCropIdPut(id, cropUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CropCreateDto} [cropCreateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CropApi
     */
    public apiCropPost(cropCreateDto?: CropCreateDto, options?: any) {
        return CropApiFp(this.configuration).apiCropPost(cropCreateDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * InventoryOperationApi - axios parameter creator
 * @export
 */
export const InventoryOperationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInventoryOperationGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/InventoryOperation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInventoryOperationIdDelete: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiInventoryOperationIdDelete', 'id', id)
            const localVarPath = `/api/InventoryOperation/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInventoryOperationIdGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiInventoryOperationIdGet', 'id', id)
            const localVarPath = `/api/InventoryOperation/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {InventoryOperationUpdateDto} [inventoryOperationUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInventoryOperationIdPut: async (id: number, inventoryOperationUpdateDto?: InventoryOperationUpdateDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiInventoryOperationIdPut', 'id', id)
            const localVarPath = `/api/InventoryOperation/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inventoryOperationUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInventoryOperationIdStatusPut: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiInventoryOperationIdStatusPut', 'id', id)
            const localVarPath = `/api/InventoryOperation/{id}/status`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {InventoryOperationCreateDto} [inventoryOperationCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInventoryOperationPost: async (inventoryOperationCreateDto?: InventoryOperationCreateDto, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/InventoryOperation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inventoryOperationCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InventoryOperationApi - functional programming interface
 * @export
 */
export const InventoryOperationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InventoryOperationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiInventoryOperationGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InventoryOperationDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiInventoryOperationGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiInventoryOperationIdDelete(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiInventoryOperationIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiInventoryOperationIdGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InventoryOperationDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiInventoryOperationIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {InventoryOperationUpdateDto} [inventoryOperationUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiInventoryOperationIdPut(id: number, inventoryOperationUpdateDto?: InventoryOperationUpdateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InventoryOperationDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiInventoryOperationIdPut(id, inventoryOperationUpdateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiInventoryOperationIdStatusPut(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InventoryOperationDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiInventoryOperationIdStatusPut(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {InventoryOperationCreateDto} [inventoryOperationCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiInventoryOperationPost(inventoryOperationCreateDto?: InventoryOperationCreateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InventoryOperationDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiInventoryOperationPost(inventoryOperationCreateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * InventoryOperationApi - factory interface
 * @export
 */
export const InventoryOperationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InventoryOperationApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInventoryOperationGet(options?: any): AxiosPromise<Array<InventoryOperationDto>> {
            return localVarFp.apiInventoryOperationGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInventoryOperationIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiInventoryOperationIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInventoryOperationIdGet(id: number, options?: any): AxiosPromise<InventoryOperationDetailsDto> {
            return localVarFp.apiInventoryOperationIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {InventoryOperationUpdateDto} [inventoryOperationUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInventoryOperationIdPut(id: number, inventoryOperationUpdateDto?: InventoryOperationUpdateDto, options?: any): AxiosPromise<InventoryOperationDetailsDto> {
            return localVarFp.apiInventoryOperationIdPut(id, inventoryOperationUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInventoryOperationIdStatusPut(id: number, options?: any): AxiosPromise<InventoryOperationDetailsDto> {
            return localVarFp.apiInventoryOperationIdStatusPut(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InventoryOperationCreateDto} [inventoryOperationCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInventoryOperationPost(inventoryOperationCreateDto?: InventoryOperationCreateDto, options?: any): AxiosPromise<InventoryOperationDetailsDto> {
            return localVarFp.apiInventoryOperationPost(inventoryOperationCreateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InventoryOperationApi - object-oriented interface
 * @export
 * @class InventoryOperationApi
 * @extends {BaseAPI}
 */
export class InventoryOperationApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryOperationApi
     */
    public apiInventoryOperationGet(options?: any) {
        return InventoryOperationApiFp(this.configuration).apiInventoryOperationGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryOperationApi
     */
    public apiInventoryOperationIdDelete(id: number, options?: any) {
        return InventoryOperationApiFp(this.configuration).apiInventoryOperationIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryOperationApi
     */
    public apiInventoryOperationIdGet(id: number, options?: any) {
        return InventoryOperationApiFp(this.configuration).apiInventoryOperationIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {InventoryOperationUpdateDto} [inventoryOperationUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryOperationApi
     */
    public apiInventoryOperationIdPut(id: number, inventoryOperationUpdateDto?: InventoryOperationUpdateDto, options?: any) {
        return InventoryOperationApiFp(this.configuration).apiInventoryOperationIdPut(id, inventoryOperationUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryOperationApi
     */
    public apiInventoryOperationIdStatusPut(id: number, options?: any) {
        return InventoryOperationApiFp(this.configuration).apiInventoryOperationIdStatusPut(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InventoryOperationCreateDto} [inventoryOperationCreateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryOperationApi
     */
    public apiInventoryOperationPost(inventoryOperationCreateDto?: InventoryOperationCreateDto, options?: any) {
        return InventoryOperationApiFp(this.configuration).apiInventoryOperationPost(inventoryOperationCreateDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * McpApi - axios parameter creator
 * @export
 */
export const McpApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpDataCompanyDataGet: async (page?: number, pageSize?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/mcp/data/company-data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpDataContractorsGet: async (page?: number, pageSize?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/mcp/data/contractors`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpDataCropsGet: async (page?: number, pageSize?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/mcp/data/crops`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpDataInventoryOperationsGet: async (page?: number, pageSize?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/mcp/data/inventory-operations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpDataProductsGet: async (page?: number, pageSize?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/mcp/data/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpDataStockOperationsGet: async (page?: number, pageSize?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/mcp/data/stock-operations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpDataStocksGet: async (page?: number, pageSize?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/mcp/data/stocks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpDataStrainsGet: async (page?: number, pageSize?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/mcp/data/strains`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpDataUsersGet: async (page?: number, pageSize?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/mcp/data/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpDataWarehousesGet: async (page?: number, pageSize?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/mcp/data/warehouses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/mcp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpOptions: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/mcp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {McpJsonRpcRequest} [mcpJsonRpcRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpPost: async (mcpJsonRpcRequest?: McpJsonRpcRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/mcp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(mcpJsonRpcRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * McpApi - functional programming interface
 * @export
 */
export const McpApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = McpApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mcpDataCompanyDataGet(page?: number, pageSize?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyDataMcpDtoPaginatedMcpDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mcpDataCompanyDataGet(page, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mcpDataContractorsGet(page?: number, pageSize?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContractorMcpDtoPaginatedMcpDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mcpDataContractorsGet(page, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mcpDataCropsGet(page?: number, pageSize?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CropMcpDtoPaginatedMcpDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mcpDataCropsGet(page, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mcpDataInventoryOperationsGet(page?: number, pageSize?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InventoryOperationMcpDtoPaginatedMcpDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mcpDataInventoryOperationsGet(page, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mcpDataProductsGet(page?: number, pageSize?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductMcpDtoPaginatedMcpDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mcpDataProductsGet(page, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mcpDataStockOperationsGet(page?: number, pageSize?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StockOperationMcpDtoPaginatedMcpDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mcpDataStockOperationsGet(page, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mcpDataStocksGet(page?: number, pageSize?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StockMcpDtoPaginatedMcpDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mcpDataStocksGet(page, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mcpDataStrainsGet(page?: number, pageSize?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StrainMcpDtoPaginatedMcpDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mcpDataStrainsGet(page, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mcpDataUsersGet(page?: number, pageSize?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApplicationUserMcpDtoPaginatedMcpDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mcpDataUsersGet(page, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mcpDataWarehousesGet(page?: number, pageSize?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WarehouseMcpDtoPaginatedMcpDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mcpDataWarehousesGet(page, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mcpGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mcpGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mcpOptions(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mcpOptions(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {McpJsonRpcRequest} [mcpJsonRpcRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mcpPost(mcpJsonRpcRequest?: McpJsonRpcRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mcpPost(mcpJsonRpcRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * McpApi - factory interface
 * @export
 */
export const McpApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = McpApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpDataCompanyDataGet(page?: number, pageSize?: number, options?: any): AxiosPromise<CompanyDataMcpDtoPaginatedMcpDto> {
            return localVarFp.mcpDataCompanyDataGet(page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpDataContractorsGet(page?: number, pageSize?: number, options?: any): AxiosPromise<ContractorMcpDtoPaginatedMcpDto> {
            return localVarFp.mcpDataContractorsGet(page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpDataCropsGet(page?: number, pageSize?: number, options?: any): AxiosPromise<CropMcpDtoPaginatedMcpDto> {
            return localVarFp.mcpDataCropsGet(page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpDataInventoryOperationsGet(page?: number, pageSize?: number, options?: any): AxiosPromise<InventoryOperationMcpDtoPaginatedMcpDto> {
            return localVarFp.mcpDataInventoryOperationsGet(page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpDataProductsGet(page?: number, pageSize?: number, options?: any): AxiosPromise<ProductMcpDtoPaginatedMcpDto> {
            return localVarFp.mcpDataProductsGet(page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpDataStockOperationsGet(page?: number, pageSize?: number, options?: any): AxiosPromise<StockOperationMcpDtoPaginatedMcpDto> {
            return localVarFp.mcpDataStockOperationsGet(page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpDataStocksGet(page?: number, pageSize?: number, options?: any): AxiosPromise<StockMcpDtoPaginatedMcpDto> {
            return localVarFp.mcpDataStocksGet(page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpDataStrainsGet(page?: number, pageSize?: number, options?: any): AxiosPromise<StrainMcpDtoPaginatedMcpDto> {
            return localVarFp.mcpDataStrainsGet(page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpDataUsersGet(page?: number, pageSize?: number, options?: any): AxiosPromise<ApplicationUserMcpDtoPaginatedMcpDto> {
            return localVarFp.mcpDataUsersGet(page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpDataWarehousesGet(page?: number, pageSize?: number, options?: any): AxiosPromise<WarehouseMcpDtoPaginatedMcpDto> {
            return localVarFp.mcpDataWarehousesGet(page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpGet(options?: any): AxiosPromise<void> {
            return localVarFp.mcpGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpOptions(options?: any): AxiosPromise<void> {
            return localVarFp.mcpOptions(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {McpJsonRpcRequest} [mcpJsonRpcRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpPost(mcpJsonRpcRequest?: McpJsonRpcRequest, options?: any): AxiosPromise<void> {
            return localVarFp.mcpPost(mcpJsonRpcRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * McpApi - object-oriented interface
 * @export
 * @class McpApi
 * @extends {BaseAPI}
 */
export class McpApi extends BaseAPI {
    /**
     * 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof McpApi
     */
    public mcpDataCompanyDataGet(page?: number, pageSize?: number, options?: any) {
        return McpApiFp(this.configuration).mcpDataCompanyDataGet(page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof McpApi
     */
    public mcpDataContractorsGet(page?: number, pageSize?: number, options?: any) {
        return McpApiFp(this.configuration).mcpDataContractorsGet(page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof McpApi
     */
    public mcpDataCropsGet(page?: number, pageSize?: number, options?: any) {
        return McpApiFp(this.configuration).mcpDataCropsGet(page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof McpApi
     */
    public mcpDataInventoryOperationsGet(page?: number, pageSize?: number, options?: any) {
        return McpApiFp(this.configuration).mcpDataInventoryOperationsGet(page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof McpApi
     */
    public mcpDataProductsGet(page?: number, pageSize?: number, options?: any) {
        return McpApiFp(this.configuration).mcpDataProductsGet(page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof McpApi
     */
    public mcpDataStockOperationsGet(page?: number, pageSize?: number, options?: any) {
        return McpApiFp(this.configuration).mcpDataStockOperationsGet(page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof McpApi
     */
    public mcpDataStocksGet(page?: number, pageSize?: number, options?: any) {
        return McpApiFp(this.configuration).mcpDataStocksGet(page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof McpApi
     */
    public mcpDataStrainsGet(page?: number, pageSize?: number, options?: any) {
        return McpApiFp(this.configuration).mcpDataStrainsGet(page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof McpApi
     */
    public mcpDataUsersGet(page?: number, pageSize?: number, options?: any) {
        return McpApiFp(this.configuration).mcpDataUsersGet(page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof McpApi
     */
    public mcpDataWarehousesGet(page?: number, pageSize?: number, options?: any) {
        return McpApiFp(this.configuration).mcpDataWarehousesGet(page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof McpApi
     */
    public mcpGet(options?: any) {
        return McpApiFp(this.configuration).mcpGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof McpApi
     */
    public mcpOptions(options?: any) {
        return McpApiFp(this.configuration).mcpOptions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {McpJsonRpcRequest} [mcpJsonRpcRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof McpApi
     */
    public mcpPost(mcpJsonRpcRequest?: McpJsonRpcRequest, options?: any) {
        return McpApiFp(this.configuration).mcpPost(mcpJsonRpcRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PhysicochemicalTestApi - axios parameter creator
 * @export
 */
export const PhysicochemicalTestApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPhysicochemicalTestGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/PhysicochemicalTest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPhysicochemicalTestIdDelete: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiPhysicochemicalTestIdDelete', 'id', id)
            const localVarPath = `/api/PhysicochemicalTest/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPhysicochemicalTestIdGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiPhysicochemicalTestIdGet', 'id', id)
            const localVarPath = `/api/PhysicochemicalTest/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {PhysicochemicalTestUpdateDto} [physicochemicalTestUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPhysicochemicalTestIdPut: async (id: number, physicochemicalTestUpdateDto?: PhysicochemicalTestUpdateDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiPhysicochemicalTestIdPut', 'id', id)
            const localVarPath = `/api/PhysicochemicalTest/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(physicochemicalTestUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PhysicochemicalTestCreateDto} [physicochemicalTestCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPhysicochemicalTestPost: async (physicochemicalTestCreateDto?: PhysicochemicalTestCreateDto, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/PhysicochemicalTest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(physicochemicalTestCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [productionProcessId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPhysicochemicalTestProductionProcessGet: async (productionProcessId?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/PhysicochemicalTest/ProductionProcess`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (productionProcessId !== undefined) {
                localVarQueryParameter['productionProcessId'] = productionProcessId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PhysicochemicalTestApi - functional programming interface
 * @export
 */
export const PhysicochemicalTestApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PhysicochemicalTestApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPhysicochemicalTestGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PhysicochemicalTestDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPhysicochemicalTestGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPhysicochemicalTestIdDelete(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPhysicochemicalTestIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPhysicochemicalTestIdGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PhysicochemicalTestDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPhysicochemicalTestIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {PhysicochemicalTestUpdateDto} [physicochemicalTestUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPhysicochemicalTestIdPut(id: number, physicochemicalTestUpdateDto?: PhysicochemicalTestUpdateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PhysicochemicalTestDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPhysicochemicalTestIdPut(id, physicochemicalTestUpdateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PhysicochemicalTestCreateDto} [physicochemicalTestCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPhysicochemicalTestPost(physicochemicalTestCreateDto?: PhysicochemicalTestCreateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PhysicochemicalTestDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPhysicochemicalTestPost(physicochemicalTestCreateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [productionProcessId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPhysicochemicalTestProductionProcessGet(productionProcessId?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PhysicochemicalTestDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPhysicochemicalTestProductionProcessGet(productionProcessId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PhysicochemicalTestApi - factory interface
 * @export
 */
export const PhysicochemicalTestApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PhysicochemicalTestApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPhysicochemicalTestGet(options?: any): AxiosPromise<Array<PhysicochemicalTestDto>> {
            return localVarFp.apiPhysicochemicalTestGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPhysicochemicalTestIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiPhysicochemicalTestIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPhysicochemicalTestIdGet(id: number, options?: any): AxiosPromise<PhysicochemicalTestDetailsDto> {
            return localVarFp.apiPhysicochemicalTestIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {PhysicochemicalTestUpdateDto} [physicochemicalTestUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPhysicochemicalTestIdPut(id: number, physicochemicalTestUpdateDto?: PhysicochemicalTestUpdateDto, options?: any): AxiosPromise<PhysicochemicalTestDetailsDto> {
            return localVarFp.apiPhysicochemicalTestIdPut(id, physicochemicalTestUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PhysicochemicalTestCreateDto} [physicochemicalTestCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPhysicochemicalTestPost(physicochemicalTestCreateDto?: PhysicochemicalTestCreateDto, options?: any): AxiosPromise<PhysicochemicalTestDetailsDto> {
            return localVarFp.apiPhysicochemicalTestPost(physicochemicalTestCreateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [productionProcessId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPhysicochemicalTestProductionProcessGet(productionProcessId?: number, options?: any): AxiosPromise<Array<PhysicochemicalTestDto>> {
            return localVarFp.apiPhysicochemicalTestProductionProcessGet(productionProcessId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PhysicochemicalTestApi - object-oriented interface
 * @export
 * @class PhysicochemicalTestApi
 * @extends {BaseAPI}
 */
export class PhysicochemicalTestApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PhysicochemicalTestApi
     */
    public apiPhysicochemicalTestGet(options?: any) {
        return PhysicochemicalTestApiFp(this.configuration).apiPhysicochemicalTestGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PhysicochemicalTestApi
     */
    public apiPhysicochemicalTestIdDelete(id: number, options?: any) {
        return PhysicochemicalTestApiFp(this.configuration).apiPhysicochemicalTestIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PhysicochemicalTestApi
     */
    public apiPhysicochemicalTestIdGet(id: number, options?: any) {
        return PhysicochemicalTestApiFp(this.configuration).apiPhysicochemicalTestIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {PhysicochemicalTestUpdateDto} [physicochemicalTestUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PhysicochemicalTestApi
     */
    public apiPhysicochemicalTestIdPut(id: number, physicochemicalTestUpdateDto?: PhysicochemicalTestUpdateDto, options?: any) {
        return PhysicochemicalTestApiFp(this.configuration).apiPhysicochemicalTestIdPut(id, physicochemicalTestUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PhysicochemicalTestCreateDto} [physicochemicalTestCreateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PhysicochemicalTestApi
     */
    public apiPhysicochemicalTestPost(physicochemicalTestCreateDto?: PhysicochemicalTestCreateDto, options?: any) {
        return PhysicochemicalTestApiFp(this.configuration).apiPhysicochemicalTestPost(physicochemicalTestCreateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [productionProcessId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PhysicochemicalTestApi
     */
    public apiPhysicochemicalTestProductionProcessGet(productionProcessId?: number, options?: any) {
        return PhysicochemicalTestApiFp(this.configuration).apiPhysicochemicalTestProductionProcessGet(productionProcessId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PipedriveAdminApi - axios parameter creator
 * @export
 */
export const PipedriveAdminApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPipedriveAppAdminSyncActivitiesPost: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/pipedrive-app/admin/sync/activities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPipedriveAppAdminSyncDealsPost: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/pipedrive-app/admin/sync/deals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPipedriveAppAdminSyncOrganizationsPost: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/pipedrive-app/admin/sync/organizations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPipedriveAppAdminSyncProductsPost: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/pipedrive-app/admin/sync/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PipedriveAdminApi - functional programming interface
 * @export
 */
export const PipedriveAdminApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PipedriveAdminApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPipedriveAppAdminSyncActivitiesPost(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPipedriveAppAdminSyncActivitiesPost(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPipedriveAppAdminSyncDealsPost(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPipedriveAppAdminSyncDealsPost(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPipedriveAppAdminSyncOrganizationsPost(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPipedriveAppAdminSyncOrganizationsPost(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPipedriveAppAdminSyncProductsPost(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPipedriveAppAdminSyncProductsPost(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PipedriveAdminApi - factory interface
 * @export
 */
export const PipedriveAdminApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PipedriveAdminApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPipedriveAppAdminSyncActivitiesPost(options?: any): AxiosPromise<void> {
            return localVarFp.apiPipedriveAppAdminSyncActivitiesPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPipedriveAppAdminSyncDealsPost(options?: any): AxiosPromise<void> {
            return localVarFp.apiPipedriveAppAdminSyncDealsPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPipedriveAppAdminSyncOrganizationsPost(options?: any): AxiosPromise<void> {
            return localVarFp.apiPipedriveAppAdminSyncOrganizationsPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPipedriveAppAdminSyncProductsPost(options?: any): AxiosPromise<void> {
            return localVarFp.apiPipedriveAppAdminSyncProductsPost(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PipedriveAdminApi - object-oriented interface
 * @export
 * @class PipedriveAdminApi
 * @extends {BaseAPI}
 */
export class PipedriveAdminApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PipedriveAdminApi
     */
    public apiPipedriveAppAdminSyncActivitiesPost(options?: any) {
        return PipedriveAdminApiFp(this.configuration).apiPipedriveAppAdminSyncActivitiesPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PipedriveAdminApi
     */
    public apiPipedriveAppAdminSyncDealsPost(options?: any) {
        return PipedriveAdminApiFp(this.configuration).apiPipedriveAppAdminSyncDealsPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PipedriveAdminApi
     */
    public apiPipedriveAppAdminSyncOrganizationsPost(options?: any) {
        return PipedriveAdminApiFp(this.configuration).apiPipedriveAppAdminSyncOrganizationsPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PipedriveAdminApi
     */
    public apiPipedriveAppAdminSyncProductsPost(options?: any) {
        return PipedriveAdminApiFp(this.configuration).apiPipedriveAppAdminSyncProductsPost(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PipedriveAppApi - axios parameter creator
 * @export
 */
export const PipedriveAppApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} dealId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPipedriveAppDealsDealIdConfirmPost: async (dealId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'dealId' is not null or undefined
            assertParamExists('apiPipedriveAppDealsDealIdConfirmPost', 'dealId', dealId)
            const localVarPath = `/api/pipedrive-app/deals/{dealId}/confirm`
                .replace(`{${"dealId"}}`, encodeURIComponent(String(dealId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} dealId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPipedriveAppDealsDealIdSummaryGet: async (dealId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'dealId' is not null or undefined
            assertParamExists('apiPipedriveAppDealsDealIdSummaryGet', 'dealId', dealId)
            const localVarPath = `/api/pipedrive-app/deals/{dealId}/summary`
                .replace(`{${"dealId"}}`, encodeURIComponent(String(dealId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} dealId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPipedriveAppDealsDealIdSyncPost: async (dealId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'dealId' is not null or undefined
            assertParamExists('apiPipedriveAppDealsDealIdSyncPost', 'dealId', dealId)
            const localVarPath = `/api/pipedrive-app/deals/{dealId}/sync`
                .replace(`{${"dealId"}}`, encodeURIComponent(String(dealId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PipedriveAppApi - functional programming interface
 * @export
 */
export const PipedriveAppApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PipedriveAppApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} dealId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPipedriveAppDealsDealIdConfirmPost(dealId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPipedriveAppDealsDealIdConfirmPost(dealId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} dealId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPipedriveAppDealsDealIdSummaryGet(dealId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PipedriveDealIntegrationSummaryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPipedriveAppDealsDealIdSummaryGet(dealId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} dealId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPipedriveAppDealsDealIdSyncPost(dealId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPipedriveAppDealsDealIdSyncPost(dealId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PipedriveAppApi - factory interface
 * @export
 */
export const PipedriveAppApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PipedriveAppApiFp(configuration)
    return {
        /**
         * 
         * @param {number} dealId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPipedriveAppDealsDealIdConfirmPost(dealId: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiPipedriveAppDealsDealIdConfirmPost(dealId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} dealId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPipedriveAppDealsDealIdSummaryGet(dealId: number, options?: any): AxiosPromise<PipedriveDealIntegrationSummaryDto> {
            return localVarFp.apiPipedriveAppDealsDealIdSummaryGet(dealId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} dealId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPipedriveAppDealsDealIdSyncPost(dealId: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiPipedriveAppDealsDealIdSyncPost(dealId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PipedriveAppApi - object-oriented interface
 * @export
 * @class PipedriveAppApi
 * @extends {BaseAPI}
 */
export class PipedriveAppApi extends BaseAPI {
    /**
     * 
     * @param {number} dealId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PipedriveAppApi
     */
    public apiPipedriveAppDealsDealIdConfirmPost(dealId: number, options?: any) {
        return PipedriveAppApiFp(this.configuration).apiPipedriveAppDealsDealIdConfirmPost(dealId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} dealId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PipedriveAppApi
     */
    public apiPipedriveAppDealsDealIdSummaryGet(dealId: number, options?: any) {
        return PipedriveAppApiFp(this.configuration).apiPipedriveAppDealsDealIdSummaryGet(dealId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} dealId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PipedriveAppApi
     */
    public apiPipedriveAppDealsDealIdSyncPost(dealId: number, options?: any) {
        return PipedriveAppApiFp(this.configuration).apiPipedriveAppDealsDealIdSyncPost(dealId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PipedriveOAuthApi - axios parameter creator
 * @export
 */
export const PipedriveOAuthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [code] 
         * @param {string} [error] 
         * @param {string} [state] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPipedriveOauthCallbackGet: async (code?: string, error?: string, state?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/pipedrive/oauth/callback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }

            if (error !== undefined) {
                localVarQueryParameter['error'] = error;
            }

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PipedriveOAuthApi - functional programming interface
 * @export
 */
export const PipedriveOAuthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PipedriveOAuthApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [code] 
         * @param {string} [error] 
         * @param {string} [state] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPipedriveOauthCallbackGet(code?: string, error?: string, state?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPipedriveOauthCallbackGet(code, error, state, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PipedriveOAuthApi - factory interface
 * @export
 */
export const PipedriveOAuthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PipedriveOAuthApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [code] 
         * @param {string} [error] 
         * @param {string} [state] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPipedriveOauthCallbackGet(code?: string, error?: string, state?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiPipedriveOauthCallbackGet(code, error, state, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PipedriveOAuthApi - object-oriented interface
 * @export
 * @class PipedriveOAuthApi
 * @extends {BaseAPI}
 */
export class PipedriveOAuthApi extends BaseAPI {
    /**
     * 
     * @param {string} [code] 
     * @param {string} [error] 
     * @param {string} [state] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PipedriveOAuthApi
     */
    public apiPipedriveOauthCallbackGet(code?: string, error?: string, state?: string, options?: any) {
        return PipedriveOAuthApiFp(this.configuration).apiPipedriveOauthCallbackGet(code, error, state, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PipedriveWebhookApi - axios parameter creator
 * @export
 */
export const PipedriveWebhookApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPipedriveWebhookPost: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/pipedrive/webhook`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PipedriveWebhookApi - functional programming interface
 * @export
 */
export const PipedriveWebhookApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PipedriveWebhookApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPipedriveWebhookPost(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPipedriveWebhookPost(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PipedriveWebhookApi - factory interface
 * @export
 */
export const PipedriveWebhookApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PipedriveWebhookApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPipedriveWebhookPost(options?: any): AxiosPromise<void> {
            return localVarFp.apiPipedriveWebhookPost(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PipedriveWebhookApi - object-oriented interface
 * @export
 * @class PipedriveWebhookApi
 * @extends {BaseAPI}
 */
export class PipedriveWebhookApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PipedriveWebhookApi
     */
    public apiPipedriveWebhookPost(options?: any) {
        return PipedriveWebhookApiFp(this.configuration).apiPipedriveWebhookPost(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ProductApi - axios parameter creator
 * @export
 */
export const ProductApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} ean 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductByEanEanGet: async (ean: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'ean' is not null or undefined
            assertParamExists('apiProductByEanEanGet', 'ean', ean)
            const localVarPath = `/api/Product/by-ean/{ean}`
                .replace(`{${"ean"}}`, encodeURIComponent(String(ean)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Product`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductIdDelete: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiProductIdDelete', 'id', id)
            const localVarPath = `/api/Product/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductIdGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiProductIdGet', 'id', id)
            const localVarPath = `/api/Product/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductIdMinimalGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiProductIdMinimalGet', 'id', id)
            const localVarPath = `/api/Product/{id}/minimal`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ProductUpdateDto} [productUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductIdPut: async (id: number, productUpdateDto?: ProductUpdateDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiProductIdPut', 'id', id)
            const localVarPath = `/api/Product/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(productUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ProductCreateDto} [productCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductPost: async (productCreateDto?: ProductCreateDto, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Product`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(productCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} warehouseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsWarehouseWarehouseIdGet: async (warehouseId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'warehouseId' is not null or undefined
            assertParamExists('productsWarehouseWarehouseIdGet', 'warehouseId', warehouseId)
            const localVarPath = `/products/warehouse/{warehouseId}`
                .replace(`{${"warehouseId"}}`, encodeURIComponent(String(warehouseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} warehouseId 
         * @param {number} productionProcessId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsWarehouseWarehouseIdProducitonProcessProductionProcessIdGet: async (warehouseId: number, productionProcessId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'warehouseId' is not null or undefined
            assertParamExists('productsWarehouseWarehouseIdProducitonProcessProductionProcessIdGet', 'warehouseId', warehouseId)
            // verify required parameter 'productionProcessId' is not null or undefined
            assertParamExists('productsWarehouseWarehouseIdProducitonProcessProductionProcessIdGet', 'productionProcessId', productionProcessId)
            const localVarPath = `/products/warehouse/{warehouseId}/producitonProcess/{productionProcessId}`
                .replace(`{${"warehouseId"}}`, encodeURIComponent(String(warehouseId)))
                .replace(`{${"productionProcessId"}}`, encodeURIComponent(String(productionProcessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductApi - functional programming interface
 * @export
 */
export const ProductApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} ean 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProductByEanEanGet(ean: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProductByEanEanGet(ean, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProductGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProductDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProductGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProductIdDelete(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProductIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProductIdGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProductIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProductIdMinimalGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductMinimalDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProductIdMinimalGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {ProductUpdateDto} [productUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProductIdPut(id: number, productUpdateDto?: ProductUpdateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProductIdPut(id, productUpdateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ProductCreateDto} [productCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProductPost(productCreateDto?: ProductCreateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProductPost(productCreateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} warehouseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productsWarehouseWarehouseIdGet(warehouseId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProductDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productsWarehouseWarehouseIdGet(warehouseId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} warehouseId 
         * @param {number} productionProcessId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productsWarehouseWarehouseIdProducitonProcessProductionProcessIdGet(warehouseId: number, productionProcessId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProductDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productsWarehouseWarehouseIdProducitonProcessProductionProcessIdGet(warehouseId, productionProcessId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProductApi - factory interface
 * @export
 */
export const ProductApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductApiFp(configuration)
    return {
        /**
         * 
         * @param {string} ean 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductByEanEanGet(ean: string, options?: any): AxiosPromise<ProductDetailsDto> {
            return localVarFp.apiProductByEanEanGet(ean, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductGet(options?: any): AxiosPromise<Array<ProductDto>> {
            return localVarFp.apiProductGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiProductIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductIdGet(id: number, options?: any): AxiosPromise<ProductDetailsDto> {
            return localVarFp.apiProductIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductIdMinimalGet(id: number, options?: any): AxiosPromise<ProductMinimalDto> {
            return localVarFp.apiProductIdMinimalGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ProductUpdateDto} [productUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductIdPut(id: number, productUpdateDto?: ProductUpdateDto, options?: any): AxiosPromise<ProductDetailsDto> {
            return localVarFp.apiProductIdPut(id, productUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ProductCreateDto} [productCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductPost(productCreateDto?: ProductCreateDto, options?: any): AxiosPromise<ProductDetailsDto> {
            return localVarFp.apiProductPost(productCreateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} warehouseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsWarehouseWarehouseIdGet(warehouseId: number, options?: any): AxiosPromise<Array<ProductDto>> {
            return localVarFp.productsWarehouseWarehouseIdGet(warehouseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} warehouseId 
         * @param {number} productionProcessId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsWarehouseWarehouseIdProducitonProcessProductionProcessIdGet(warehouseId: number, productionProcessId: number, options?: any): AxiosPromise<Array<ProductDto>> {
            return localVarFp.productsWarehouseWarehouseIdProducitonProcessProductionProcessIdGet(warehouseId, productionProcessId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProductApi - object-oriented interface
 * @export
 * @class ProductApi
 * @extends {BaseAPI}
 */
export class ProductApi extends BaseAPI {
    /**
     * 
     * @param {string} ean 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    public apiProductByEanEanGet(ean: string, options?: any) {
        return ProductApiFp(this.configuration).apiProductByEanEanGet(ean, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    public apiProductGet(options?: any) {
        return ProductApiFp(this.configuration).apiProductGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    public apiProductIdDelete(id: number, options?: any) {
        return ProductApiFp(this.configuration).apiProductIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    public apiProductIdGet(id: number, options?: any) {
        return ProductApiFp(this.configuration).apiProductIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    public apiProductIdMinimalGet(id: number, options?: any) {
        return ProductApiFp(this.configuration).apiProductIdMinimalGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ProductUpdateDto} [productUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    public apiProductIdPut(id: number, productUpdateDto?: ProductUpdateDto, options?: any) {
        return ProductApiFp(this.configuration).apiProductIdPut(id, productUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ProductCreateDto} [productCreateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    public apiProductPost(productCreateDto?: ProductCreateDto, options?: any) {
        return ProductApiFp(this.configuration).apiProductPost(productCreateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} warehouseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    public productsWarehouseWarehouseIdGet(warehouseId: number, options?: any) {
        return ProductApiFp(this.configuration).productsWarehouseWarehouseIdGet(warehouseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} warehouseId 
     * @param {number} productionProcessId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    public productsWarehouseWarehouseIdProducitonProcessProductionProcessIdGet(warehouseId: number, productionProcessId: number, options?: any) {
        return ProductApiFp(this.configuration).productsWarehouseWarehouseIdProducitonProcessProductionProcessIdGet(warehouseId, productionProcessId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ProductPriceApi - axios parameter creator
 * @export
 */
export const ProductPriceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductPriceGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ProductPrice`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductPriceIdDelete: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiProductPriceIdDelete', 'id', id)
            const localVarPath = `/api/ProductPrice/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductPriceIdGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiProductPriceIdGet', 'id', id)
            const localVarPath = `/api/ProductPrice/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ProductPriceUpdateDto} [productPriceUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductPriceIdPut: async (id: number, productPriceUpdateDto?: ProductPriceUpdateDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiProductPriceIdPut', 'id', id)
            const localVarPath = `/api/ProductPrice/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(productPriceUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ProductPriceCreateDto} [productPriceCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductPricePost: async (productPriceCreateDto?: ProductPriceCreateDto, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ProductPrice`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(productPriceCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductPriceApi - functional programming interface
 * @export
 */
export const ProductPriceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductPriceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProductPriceGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProductPriceDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProductPriceGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProductPriceIdDelete(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProductPriceIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProductPriceIdGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductPriceDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProductPriceIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {ProductPriceUpdateDto} [productPriceUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProductPriceIdPut(id: number, productPriceUpdateDto?: ProductPriceUpdateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductPriceDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProductPriceIdPut(id, productPriceUpdateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ProductPriceCreateDto} [productPriceCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProductPricePost(productPriceCreateDto?: ProductPriceCreateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductPriceDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProductPricePost(productPriceCreateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProductPriceApi - factory interface
 * @export
 */
export const ProductPriceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductPriceApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductPriceGet(options?: any): AxiosPromise<Array<ProductPriceDto>> {
            return localVarFp.apiProductPriceGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductPriceIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiProductPriceIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductPriceIdGet(id: number, options?: any): AxiosPromise<ProductPriceDetailsDto> {
            return localVarFp.apiProductPriceIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ProductPriceUpdateDto} [productPriceUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductPriceIdPut(id: number, productPriceUpdateDto?: ProductPriceUpdateDto, options?: any): AxiosPromise<ProductPriceDetailsDto> {
            return localVarFp.apiProductPriceIdPut(id, productPriceUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ProductPriceCreateDto} [productPriceCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductPricePost(productPriceCreateDto?: ProductPriceCreateDto, options?: any): AxiosPromise<ProductPriceDetailsDto> {
            return localVarFp.apiProductPricePost(productPriceCreateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProductPriceApi - object-oriented interface
 * @export
 * @class ProductPriceApi
 * @extends {BaseAPI}
 */
export class ProductPriceApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductPriceApi
     */
    public apiProductPriceGet(options?: any) {
        return ProductPriceApiFp(this.configuration).apiProductPriceGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductPriceApi
     */
    public apiProductPriceIdDelete(id: number, options?: any) {
        return ProductPriceApiFp(this.configuration).apiProductPriceIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductPriceApi
     */
    public apiProductPriceIdGet(id: number, options?: any) {
        return ProductPriceApiFp(this.configuration).apiProductPriceIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ProductPriceUpdateDto} [productPriceUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductPriceApi
     */
    public apiProductPriceIdPut(id: number, productPriceUpdateDto?: ProductPriceUpdateDto, options?: any) {
        return ProductPriceApiFp(this.configuration).apiProductPriceIdPut(id, productPriceUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ProductPriceCreateDto} [productPriceCreateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductPriceApi
     */
    public apiProductPricePost(productPriceCreateDto?: ProductPriceCreateDto, options?: any) {
        return ProductPriceApiFp(this.configuration).apiProductPricePost(productPriceCreateDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ProductUpdateHistoryApi - axios parameter creator
 * @export
 */
export const ProductUpdateHistoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductUpdateHistoryGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ProductUpdateHistory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductUpdateHistoryHistoryProductIdGet: async (productId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('apiProductUpdateHistoryHistoryProductIdGet', 'productId', productId)
            const localVarPath = `/api/ProductUpdateHistory/history/{productId}`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductUpdateHistoryIdDelete: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiProductUpdateHistoryIdDelete', 'id', id)
            const localVarPath = `/api/ProductUpdateHistory/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductUpdateHistoryIdGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiProductUpdateHistoryIdGet', 'id', id)
            const localVarPath = `/api/ProductUpdateHistory/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ProductUpdateHistoryUpdateDto} [productUpdateHistoryUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductUpdateHistoryIdPut: async (id: number, productUpdateHistoryUpdateDto?: ProductUpdateHistoryUpdateDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiProductUpdateHistoryIdPut', 'id', id)
            const localVarPath = `/api/ProductUpdateHistory/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(productUpdateHistoryUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ProductUpdateHistoryCreateDto} [productUpdateHistoryCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductUpdateHistoryPost: async (productUpdateHistoryCreateDto?: ProductUpdateHistoryCreateDto, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ProductUpdateHistory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(productUpdateHistoryCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductUpdateHistoryApi - functional programming interface
 * @export
 */
export const ProductUpdateHistoryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductUpdateHistoryApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProductUpdateHistoryGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProductUpdateHistoryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProductUpdateHistoryGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProductUpdateHistoryHistoryProductIdGet(productId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProductUpdateHistoryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProductUpdateHistoryHistoryProductIdGet(productId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProductUpdateHistoryIdDelete(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProductUpdateHistoryIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProductUpdateHistoryIdGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductUpdateHistoryDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProductUpdateHistoryIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {ProductUpdateHistoryUpdateDto} [productUpdateHistoryUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProductUpdateHistoryIdPut(id: number, productUpdateHistoryUpdateDto?: ProductUpdateHistoryUpdateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductUpdateHistoryDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProductUpdateHistoryIdPut(id, productUpdateHistoryUpdateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ProductUpdateHistoryCreateDto} [productUpdateHistoryCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProductUpdateHistoryPost(productUpdateHistoryCreateDto?: ProductUpdateHistoryCreateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductUpdateHistoryDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProductUpdateHistoryPost(productUpdateHistoryCreateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProductUpdateHistoryApi - factory interface
 * @export
 */
export const ProductUpdateHistoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductUpdateHistoryApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductUpdateHistoryGet(options?: any): AxiosPromise<Array<ProductUpdateHistoryDto>> {
            return localVarFp.apiProductUpdateHistoryGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductUpdateHistoryHistoryProductIdGet(productId: number, options?: any): AxiosPromise<Array<ProductUpdateHistoryDto>> {
            return localVarFp.apiProductUpdateHistoryHistoryProductIdGet(productId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductUpdateHistoryIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiProductUpdateHistoryIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductUpdateHistoryIdGet(id: number, options?: any): AxiosPromise<ProductUpdateHistoryDetailsDto> {
            return localVarFp.apiProductUpdateHistoryIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ProductUpdateHistoryUpdateDto} [productUpdateHistoryUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductUpdateHistoryIdPut(id: number, productUpdateHistoryUpdateDto?: ProductUpdateHistoryUpdateDto, options?: any): AxiosPromise<ProductUpdateHistoryDetailsDto> {
            return localVarFp.apiProductUpdateHistoryIdPut(id, productUpdateHistoryUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ProductUpdateHistoryCreateDto} [productUpdateHistoryCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductUpdateHistoryPost(productUpdateHistoryCreateDto?: ProductUpdateHistoryCreateDto, options?: any): AxiosPromise<ProductUpdateHistoryDetailsDto> {
            return localVarFp.apiProductUpdateHistoryPost(productUpdateHistoryCreateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProductUpdateHistoryApi - object-oriented interface
 * @export
 * @class ProductUpdateHistoryApi
 * @extends {BaseAPI}
 */
export class ProductUpdateHistoryApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductUpdateHistoryApi
     */
    public apiProductUpdateHistoryGet(options?: any) {
        return ProductUpdateHistoryApiFp(this.configuration).apiProductUpdateHistoryGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} productId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductUpdateHistoryApi
     */
    public apiProductUpdateHistoryHistoryProductIdGet(productId: number, options?: any) {
        return ProductUpdateHistoryApiFp(this.configuration).apiProductUpdateHistoryHistoryProductIdGet(productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductUpdateHistoryApi
     */
    public apiProductUpdateHistoryIdDelete(id: number, options?: any) {
        return ProductUpdateHistoryApiFp(this.configuration).apiProductUpdateHistoryIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductUpdateHistoryApi
     */
    public apiProductUpdateHistoryIdGet(id: number, options?: any) {
        return ProductUpdateHistoryApiFp(this.configuration).apiProductUpdateHistoryIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ProductUpdateHistoryUpdateDto} [productUpdateHistoryUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductUpdateHistoryApi
     */
    public apiProductUpdateHistoryIdPut(id: number, productUpdateHistoryUpdateDto?: ProductUpdateHistoryUpdateDto, options?: any) {
        return ProductUpdateHistoryApiFp(this.configuration).apiProductUpdateHistoryIdPut(id, productUpdateHistoryUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ProductUpdateHistoryCreateDto} [productUpdateHistoryCreateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductUpdateHistoryApi
     */
    public apiProductUpdateHistoryPost(productUpdateHistoryCreateDto?: ProductUpdateHistoryCreateDto, options?: any) {
        return ProductUpdateHistoryApiFp(this.configuration).apiProductUpdateHistoryPost(productUpdateHistoryCreateDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ProductionProcessApi - axios parameter creator
 * @export
 */
export const ProductionProcessApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductionProcessDetailsForCharacteristicsGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ProductionProcess/detailsForCharacteristics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [productionProcessId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductionProcessDetailsMinimalGet: async (productionProcessId?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ProductionProcess/detailsMinimal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (productionProcessId !== undefined) {
                localVarQueryParameter['productionProcessId'] = productionProcessId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductionProcessGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ProductionProcess`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductionProcessIdDelete: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiProductionProcessIdDelete', 'id', id)
            const localVarPath = `/api/ProductionProcess/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductionProcessIdGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiProductionProcessIdGet', 'id', id)
            const localVarPath = `/api/ProductionProcess/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ProductionProcessUpdateDto} [productionProcessUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductionProcessIdPut: async (id: number, productionProcessUpdateDto?: ProductionProcessUpdateDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiProductionProcessIdPut', 'id', id)
            const localVarPath = `/api/ProductionProcess/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(productionProcessUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {StockOperationStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductionProcessIdStatusPut: async (id: number, status?: StockOperationStatus, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiProductionProcessIdStatusPut', 'id', id)
            const localVarPath = `/api/ProductionProcess/{id}/status`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ProductionProcessCreateDto} [productionProcessCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductionProcessPost: async (productionProcessCreateDto?: ProductionProcessCreateDto, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ProductionProcess`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(productionProcessCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {StockOperationStatus} status 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductionProcessStatusStatusGet: async (status: StockOperationStatus, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'status' is not null or undefined
            assertParamExists('apiProductionProcessStatusStatusGet', 'status', status)
            const localVarPath = `/api/ProductionProcess/status/{status}`
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductionProcessApi - functional programming interface
 * @export
 */
export const ProductionProcessApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductionProcessApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProductionProcessDetailsForCharacteristicsGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProductionProcessDetailsDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProductionProcessDetailsForCharacteristicsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [productionProcessId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProductionProcessDetailsMinimalGet(productionProcessId?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductionProcessMinimalDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProductionProcessDetailsMinimalGet(productionProcessId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProductionProcessGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProductionProcessDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProductionProcessGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProductionProcessIdDelete(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProductionProcessIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProductionProcessIdGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductionProcessDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProductionProcessIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {ProductionProcessUpdateDto} [productionProcessUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProductionProcessIdPut(id: number, productionProcessUpdateDto?: ProductionProcessUpdateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductionProcessDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProductionProcessIdPut(id, productionProcessUpdateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {StockOperationStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProductionProcessIdStatusPut(id: number, status?: StockOperationStatus, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductionProcessDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProductionProcessIdStatusPut(id, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ProductionProcessCreateDto} [productionProcessCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProductionProcessPost(productionProcessCreateDto?: ProductionProcessCreateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductionProcessDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProductionProcessPost(productionProcessCreateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {StockOperationStatus} status 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProductionProcessStatusStatusGet(status: StockOperationStatus, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProductionProcessDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProductionProcessStatusStatusGet(status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProductionProcessApi - factory interface
 * @export
 */
export const ProductionProcessApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductionProcessApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductionProcessDetailsForCharacteristicsGet(options?: any): AxiosPromise<Array<ProductionProcessDetailsDto>> {
            return localVarFp.apiProductionProcessDetailsForCharacteristicsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [productionProcessId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductionProcessDetailsMinimalGet(productionProcessId?: number, options?: any): AxiosPromise<ProductionProcessMinimalDto> {
            return localVarFp.apiProductionProcessDetailsMinimalGet(productionProcessId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductionProcessGet(options?: any): AxiosPromise<Array<ProductionProcessDto>> {
            return localVarFp.apiProductionProcessGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductionProcessIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiProductionProcessIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductionProcessIdGet(id: number, options?: any): AxiosPromise<ProductionProcessDetailsDto> {
            return localVarFp.apiProductionProcessIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ProductionProcessUpdateDto} [productionProcessUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductionProcessIdPut(id: number, productionProcessUpdateDto?: ProductionProcessUpdateDto, options?: any): AxiosPromise<ProductionProcessDetailsDto> {
            return localVarFp.apiProductionProcessIdPut(id, productionProcessUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {StockOperationStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductionProcessIdStatusPut(id: number, status?: StockOperationStatus, options?: any): AxiosPromise<ProductionProcessDetailsDto> {
            return localVarFp.apiProductionProcessIdStatusPut(id, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ProductionProcessCreateDto} [productionProcessCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductionProcessPost(productionProcessCreateDto?: ProductionProcessCreateDto, options?: any): AxiosPromise<ProductionProcessDetailsDto> {
            return localVarFp.apiProductionProcessPost(productionProcessCreateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StockOperationStatus} status 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductionProcessStatusStatusGet(status: StockOperationStatus, options?: any): AxiosPromise<Array<ProductionProcessDto>> {
            return localVarFp.apiProductionProcessStatusStatusGet(status, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProductionProcessApi - object-oriented interface
 * @export
 * @class ProductionProcessApi
 * @extends {BaseAPI}
 */
export class ProductionProcessApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductionProcessApi
     */
    public apiProductionProcessDetailsForCharacteristicsGet(options?: any) {
        return ProductionProcessApiFp(this.configuration).apiProductionProcessDetailsForCharacteristicsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [productionProcessId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductionProcessApi
     */
    public apiProductionProcessDetailsMinimalGet(productionProcessId?: number, options?: any) {
        return ProductionProcessApiFp(this.configuration).apiProductionProcessDetailsMinimalGet(productionProcessId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductionProcessApi
     */
    public apiProductionProcessGet(options?: any) {
        return ProductionProcessApiFp(this.configuration).apiProductionProcessGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductionProcessApi
     */
    public apiProductionProcessIdDelete(id: number, options?: any) {
        return ProductionProcessApiFp(this.configuration).apiProductionProcessIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductionProcessApi
     */
    public apiProductionProcessIdGet(id: number, options?: any) {
        return ProductionProcessApiFp(this.configuration).apiProductionProcessIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ProductionProcessUpdateDto} [productionProcessUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductionProcessApi
     */
    public apiProductionProcessIdPut(id: number, productionProcessUpdateDto?: ProductionProcessUpdateDto, options?: any) {
        return ProductionProcessApiFp(this.configuration).apiProductionProcessIdPut(id, productionProcessUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {StockOperationStatus} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductionProcessApi
     */
    public apiProductionProcessIdStatusPut(id: number, status?: StockOperationStatus, options?: any) {
        return ProductionProcessApiFp(this.configuration).apiProductionProcessIdStatusPut(id, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ProductionProcessCreateDto} [productionProcessCreateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductionProcessApi
     */
    public apiProductionProcessPost(productionProcessCreateDto?: ProductionProcessCreateDto, options?: any) {
        return ProductionProcessApiFp(this.configuration).apiProductionProcessPost(productionProcessCreateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StockOperationStatus} status 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductionProcessApi
     */
    public apiProductionProcessStatusStatusGet(status: StockOperationStatus, options?: any) {
        return ProductionProcessApiFp(this.configuration).apiProductionProcessStatusStatusGet(status, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * RegonApi - axios parameter creator
 * @export
 */
export const RegonApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [nip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRegonNipGet: async (nip?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Regon/nip`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (nip !== undefined) {
                localVarQueryParameter['nip'] = nip;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RegonApi - functional programming interface
 * @export
 */
export const RegonApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RegonApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [nip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRegonNipGet(nip?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContractorDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiRegonNipGet(nip, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RegonApi - factory interface
 * @export
 */
export const RegonApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RegonApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [nip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRegonNipGet(nip?: string, options?: any): AxiosPromise<ContractorDto> {
            return localVarFp.apiRegonNipGet(nip, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RegonApi - object-oriented interface
 * @export
 * @class RegonApi
 * @extends {BaseAPI}
 */
export class RegonApi extends BaseAPI {
    /**
     * 
     * @param {string} [nip] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegonApi
     */
    public apiRegonNipGet(nip?: string, options?: any) {
        return RegonApiFp(this.configuration).apiRegonNipGet(nip, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * StockApi - axios parameter creator
 * @export
 */
export const StockApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockStockGetAllFinalProductsGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Stock/stock/getAllFinalProducts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockStockGetAllGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Stock/stock/getAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockStockGetBottlesGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Stock/stock/getBottles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} productId 
         * @param {string} batchNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockStockProductProductIdBatchBatchNumberGet: async (productId: number, batchNumber: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('apiStockStockProductProductIdBatchBatchNumberGet', 'productId', productId)
            // verify required parameter 'batchNumber' is not null or undefined
            assertParamExists('apiStockStockProductProductIdBatchBatchNumberGet', 'batchNumber', batchNumber)
            const localVarPath = `/api/Stock/stock/product/{productId}/batch/{batchNumber}`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)))
                .replace(`{${"batchNumber"}}`, encodeURIComponent(String(batchNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockStockProductProductIdGet: async (productId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('apiStockStockProductProductIdGet', 'productId', productId)
            const localVarPath = `/api/Stock/stock/product/{productId}`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} productId 
         * @param {number} warehouseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockStockProductProductIdWarehouseWarehouseIdGet: async (productId: number, warehouseId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('apiStockStockProductProductIdWarehouseWarehouseIdGet', 'productId', productId)
            // verify required parameter 'warehouseId' is not null or undefined
            assertParamExists('apiStockStockProductProductIdWarehouseWarehouseIdGet', 'warehouseId', warehouseId)
            const localVarPath = `/api/Stock/stock/product/{productId}/warehouse/{warehouseId}`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)))
                .replace(`{${"warehouseId"}}`, encodeURIComponent(String(warehouseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockStockProductionProcessGetAllGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Stock/stock/ProductionProcess/getAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} productionProcessId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockStockProductionProcessProductionProcessIdGet: async (productionProcessId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'productionProcessId' is not null or undefined
            assertParamExists('apiStockStockProductionProcessProductionProcessIdGet', 'productionProcessId', productionProcessId)
            const localVarPath = `/api/Stock/stock/ProductionProcess/{productionProcessId}`
                .replace(`{${"productionProcessId"}}`, encodeURIComponent(String(productionProcessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} warehouseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockStockWarehouseWarehouseIdGet: async (warehouseId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'warehouseId' is not null or undefined
            assertParamExists('apiStockStockWarehouseWarehouseIdGet', 'warehouseId', warehouseId)
            const localVarPath = `/api/Stock/stock/warehouse/{warehouseId}`
                .replace(`{${"warehouseId"}}`, encodeURIComponent(String(warehouseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} warehouseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockStockWarehouseWithSubwarehousesWarehouseIdGet: async (warehouseId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'warehouseId' is not null or undefined
            assertParamExists('apiStockStockWarehouseWithSubwarehousesWarehouseIdGet', 'warehouseId', warehouseId)
            const localVarPath = `/api/Stock/stock/warehouseWithSubwarehouses/{warehouseId}`
                .replace(`{${"warehouseId"}}`, encodeURIComponent(String(warehouseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StockApi - functional programming interface
 * @export
 */
export const StockApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StockApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStockStockGetAllFinalProductsGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StockDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStockStockGetAllFinalProductsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStockStockGetAllGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StockDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStockStockGetAllGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStockStockGetBottlesGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StockDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStockStockGetBottlesGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} productId 
         * @param {string} batchNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStockStockProductProductIdBatchBatchNumberGet(productId: number, batchNumber: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StockDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStockStockProductProductIdBatchBatchNumberGet(productId, batchNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStockStockProductProductIdGet(productId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StockDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStockStockProductProductIdGet(productId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} productId 
         * @param {number} warehouseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStockStockProductProductIdWarehouseWarehouseIdGet(productId: number, warehouseId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StockDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStockStockProductProductIdWarehouseWarehouseIdGet(productId, warehouseId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStockStockProductionProcessGetAllGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProductionProcessStockDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStockStockProductionProcessGetAllGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} productionProcessId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStockStockProductionProcessProductionProcessIdGet(productionProcessId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProductionProcessStockDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStockStockProductionProcessProductionProcessIdGet(productionProcessId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} warehouseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStockStockWarehouseWarehouseIdGet(warehouseId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StockDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStockStockWarehouseWarehouseIdGet(warehouseId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} warehouseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStockStockWarehouseWithSubwarehousesWarehouseIdGet(warehouseId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StockDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStockStockWarehouseWithSubwarehousesWarehouseIdGet(warehouseId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * StockApi - factory interface
 * @export
 */
export const StockApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StockApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockStockGetAllFinalProductsGet(options?: any): AxiosPromise<Array<StockDto>> {
            return localVarFp.apiStockStockGetAllFinalProductsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockStockGetAllGet(options?: any): AxiosPromise<Array<StockDto>> {
            return localVarFp.apiStockStockGetAllGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockStockGetBottlesGet(options?: any): AxiosPromise<Array<StockDto>> {
            return localVarFp.apiStockStockGetBottlesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} productId 
         * @param {string} batchNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockStockProductProductIdBatchBatchNumberGet(productId: number, batchNumber: string, options?: any): AxiosPromise<Array<StockDto>> {
            return localVarFp.apiStockStockProductProductIdBatchBatchNumberGet(productId, batchNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockStockProductProductIdGet(productId: number, options?: any): AxiosPromise<Array<StockDto>> {
            return localVarFp.apiStockStockProductProductIdGet(productId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} productId 
         * @param {number} warehouseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockStockProductProductIdWarehouseWarehouseIdGet(productId: number, warehouseId: number, options?: any): AxiosPromise<Array<StockDto>> {
            return localVarFp.apiStockStockProductProductIdWarehouseWarehouseIdGet(productId, warehouseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockStockProductionProcessGetAllGet(options?: any): AxiosPromise<Array<ProductionProcessStockDto>> {
            return localVarFp.apiStockStockProductionProcessGetAllGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} productionProcessId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockStockProductionProcessProductionProcessIdGet(productionProcessId: number, options?: any): AxiosPromise<Array<ProductionProcessStockDto>> {
            return localVarFp.apiStockStockProductionProcessProductionProcessIdGet(productionProcessId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} warehouseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockStockWarehouseWarehouseIdGet(warehouseId: number, options?: any): AxiosPromise<Array<StockDto>> {
            return localVarFp.apiStockStockWarehouseWarehouseIdGet(warehouseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} warehouseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockStockWarehouseWithSubwarehousesWarehouseIdGet(warehouseId: number, options?: any): AxiosPromise<Array<StockDto>> {
            return localVarFp.apiStockStockWarehouseWithSubwarehousesWarehouseIdGet(warehouseId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StockApi - object-oriented interface
 * @export
 * @class StockApi
 * @extends {BaseAPI}
 */
export class StockApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockApi
     */
    public apiStockStockGetAllFinalProductsGet(options?: any) {
        return StockApiFp(this.configuration).apiStockStockGetAllFinalProductsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockApi
     */
    public apiStockStockGetAllGet(options?: any) {
        return StockApiFp(this.configuration).apiStockStockGetAllGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockApi
     */
    public apiStockStockGetBottlesGet(options?: any) {
        return StockApiFp(this.configuration).apiStockStockGetBottlesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} productId 
     * @param {string} batchNumber 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockApi
     */
    public apiStockStockProductProductIdBatchBatchNumberGet(productId: number, batchNumber: string, options?: any) {
        return StockApiFp(this.configuration).apiStockStockProductProductIdBatchBatchNumberGet(productId, batchNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} productId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockApi
     */
    public apiStockStockProductProductIdGet(productId: number, options?: any) {
        return StockApiFp(this.configuration).apiStockStockProductProductIdGet(productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} productId 
     * @param {number} warehouseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockApi
     */
    public apiStockStockProductProductIdWarehouseWarehouseIdGet(productId: number, warehouseId: number, options?: any) {
        return StockApiFp(this.configuration).apiStockStockProductProductIdWarehouseWarehouseIdGet(productId, warehouseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockApi
     */
    public apiStockStockProductionProcessGetAllGet(options?: any) {
        return StockApiFp(this.configuration).apiStockStockProductionProcessGetAllGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} productionProcessId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockApi
     */
    public apiStockStockProductionProcessProductionProcessIdGet(productionProcessId: number, options?: any) {
        return StockApiFp(this.configuration).apiStockStockProductionProcessProductionProcessIdGet(productionProcessId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} warehouseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockApi
     */
    public apiStockStockWarehouseWarehouseIdGet(warehouseId: number, options?: any) {
        return StockApiFp(this.configuration).apiStockStockWarehouseWarehouseIdGet(warehouseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} warehouseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockApi
     */
    public apiStockStockWarehouseWithSubwarehousesWarehouseIdGet(warehouseId: number, options?: any) {
        return StockApiFp(this.configuration).apiStockStockWarehouseWithSubwarehousesWarehouseIdGet(warehouseId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * StockOperationApi - axios parameter creator
 * @export
 */
export const StockOperationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [productId] 
         * @param {number} [warehouseId] 
         * @param {number} [stockOperationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationBatchNumbersGet: async (productId?: number, warehouseId?: number, stockOperationId?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/StockOperation/batchNumbers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (productId !== undefined) {
                localVarQueryParameter['productId'] = productId;
            }

            if (warehouseId !== undefined) {
                localVarQueryParameter['warehouseId'] = warehouseId;
            }

            if (stockOperationId !== undefined) {
                localVarQueryParameter['stockOperationId'] = stockOperationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} pipedriveDealId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationByPipedriveDealPipedriveDealIdGet: async (pipedriveDealId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'pipedriveDealId' is not null or undefined
            assertParamExists('apiStockOperationByPipedriveDealPipedriveDealIdGet', 'pipedriveDealId', pipedriveDealId)
            const localVarPath = `/api/StockOperation/byPipedriveDeal/{pipedriveDealId}`
                .replace(`{${"pipedriveDealId"}}`, encodeURIComponent(String(pipedriveDealId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [date] 
         * @param {StockOperationType} [operationType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationDocumentNumberGet: async (date?: string, operationType?: StockOperationType, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/StockOperation/documentNumber`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (date !== undefined) {
                localVarQueryParameter['date'] = date;
            }

            if (operationType !== undefined) {
                localVarQueryParameter['operationType'] = operationType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/StockOperation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [date] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationGetOrdersForDateGet: async (date?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/StockOperation/getOrdersForDate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (date !== undefined) {
                localVarQueryParameter['date'] = date;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [date] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationGetOrdersForYearGet: async (date?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/StockOperation/getOrdersForYear`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (date !== undefined) {
                localVarQueryParameter['date'] = date;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationIdDelete: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiStockOperationIdDelete', 'id', id)
            const localVarPath = `/api/StockOperation/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationIdGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiStockOperationIdGet', 'id', id)
            const localVarPath = `/api/StockOperation/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {StockOperationUpdateDto} [stockOperationUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationIdPut: async (id: number, stockOperationUpdateDto?: StockOperationUpdateDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiStockOperationIdPut', 'id', id)
            const localVarPath = `/api/StockOperation/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(stockOperationUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {StockOperationStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationIdStatusPut: async (id: number, status?: StockOperationStatus, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiStockOperationIdStatusPut', 'id', id)
            const localVarPath = `/api/StockOperation/{id}/status`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationInvoicePreviewGet: async (id?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/StockOperation/InvoicePreview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationLatestDraftGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/StockOperation/latestDraft`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationLatestPublishedGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/StockOperation/latestPublished`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationMinimalGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/StockOperation/minimal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationMinimalIdGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiStockOperationMinimalIdGet', 'id', id)
            const localVarPath = `/api/StockOperation/minimal/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [date] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationOperationsForDateGet: async (date?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/StockOperation/operationsForDate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (date !== undefined) {
                localVarQueryParameter['date'] = date;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [date] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationOperationsForYearGet: async (date?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/StockOperation/operationsForYear`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (date !== undefined) {
                localVarQueryParameter['date'] = date;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {StockOperationCreateDto} [stockOperationCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationPost: async (stockOperationCreateDto?: StockOperationCreateDto, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/StockOperation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(stockOperationCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {StockOperationCreateDto} [stockOperationCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationProductionStockOperationPost: async (stockOperationCreateDto?: StockOperationCreateDto, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/StockOperation/ProductionStockOperation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(stockOperationCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {StockOperationStatus} [status] 
         * @param {Array<number>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationStatusesPut: async (status?: StockOperationStatus, requestBody?: Array<number>, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/StockOperation/statuses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [documentNumber] 
         * @param {number} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationValidateDocumentNumberGet: async (documentNumber?: string, id?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/StockOperation/validateDocumentNumber`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (documentNumber !== undefined) {
                localVarQueryParameter['documentNumber'] = documentNumber;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StockOperationApi - functional programming interface
 * @export
 */
export const StockOperationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StockOperationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [productId] 
         * @param {number} [warehouseId] 
         * @param {number} [stockOperationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStockOperationBatchNumbersGet(productId?: number, warehouseId?: number, stockOperationId?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BatchNumberDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStockOperationBatchNumbersGet(productId, warehouseId, stockOperationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} pipedriveDealId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStockOperationByPipedriveDealPipedriveDealIdGet(pipedriveDealId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StockOperationDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStockOperationByPipedriveDealPipedriveDealIdGet(pipedriveDealId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [date] 
         * @param {StockOperationType} [operationType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStockOperationDocumentNumberGet(date?: string, operationType?: StockOperationType, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStockOperationDocumentNumberGet(date, operationType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStockOperationGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StockOperationDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStockOperationGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [date] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStockOperationGetOrdersForDateGet(date?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StockOperationMinimalWithWarehouseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStockOperationGetOrdersForDateGet(date, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [date] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStockOperationGetOrdersForYearGet(date?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StockOperationMinimalWithWarehouseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStockOperationGetOrdersForYearGet(date, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStockOperationIdDelete(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStockOperationIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStockOperationIdGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StockOperationDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStockOperationIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {StockOperationUpdateDto} [stockOperationUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStockOperationIdPut(id: number, stockOperationUpdateDto?: StockOperationUpdateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StockOperationDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStockOperationIdPut(id, stockOperationUpdateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {StockOperationStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStockOperationIdStatusPut(id: number, status?: StockOperationStatus, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StockOperationDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStockOperationIdStatusPut(id, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStockOperationInvoicePreviewGet(id?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoicePreviewDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStockOperationInvoicePreviewGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStockOperationLatestDraftGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StockOperationMinimalWithWarehouseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStockOperationLatestDraftGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStockOperationLatestPublishedGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StockOperationMinimalWithWarehouseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStockOperationLatestPublishedGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStockOperationMinimalGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StockOperationMinimalWithWarehouseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStockOperationMinimalGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStockOperationMinimalIdGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StockOperationMinimalDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStockOperationMinimalIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [date] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStockOperationOperationsForDateGet(date?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StockOperationMinimalWithWarehouseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStockOperationOperationsForDateGet(date, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [date] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStockOperationOperationsForYearGet(date?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StockOperationMinimalWithWarehouseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStockOperationOperationsForYearGet(date, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {StockOperationCreateDto} [stockOperationCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStockOperationPost(stockOperationCreateDto?: StockOperationCreateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StockOperationDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStockOperationPost(stockOperationCreateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {StockOperationCreateDto} [stockOperationCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStockOperationProductionStockOperationPost(stockOperationCreateDto?: StockOperationCreateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StockOperationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStockOperationProductionStockOperationPost(stockOperationCreateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {StockOperationStatus} [status] 
         * @param {Array<number>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStockOperationStatusesPut(status?: StockOperationStatus, requestBody?: Array<number>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStockOperationStatusesPut(status, requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [documentNumber] 
         * @param {number} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStockOperationValidateDocumentNumberGet(documentNumber?: string, id?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStockOperationValidateDocumentNumberGet(documentNumber, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * StockOperationApi - factory interface
 * @export
 */
export const StockOperationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StockOperationApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [productId] 
         * @param {number} [warehouseId] 
         * @param {number} [stockOperationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationBatchNumbersGet(productId?: number, warehouseId?: number, stockOperationId?: number, options?: any): AxiosPromise<Array<BatchNumberDto>> {
            return localVarFp.apiStockOperationBatchNumbersGet(productId, warehouseId, stockOperationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} pipedriveDealId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationByPipedriveDealPipedriveDealIdGet(pipedriveDealId: number, options?: any): AxiosPromise<StockOperationDetailsDto> {
            return localVarFp.apiStockOperationByPipedriveDealPipedriveDealIdGet(pipedriveDealId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [date] 
         * @param {StockOperationType} [operationType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationDocumentNumberGet(date?: string, operationType?: StockOperationType, options?: any): AxiosPromise<string> {
            return localVarFp.apiStockOperationDocumentNumberGet(date, operationType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationGet(options?: any): AxiosPromise<Array<StockOperationDto>> {
            return localVarFp.apiStockOperationGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [date] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationGetOrdersForDateGet(date?: string, options?: any): AxiosPromise<Array<StockOperationMinimalWithWarehouseDto>> {
            return localVarFp.apiStockOperationGetOrdersForDateGet(date, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [date] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationGetOrdersForYearGet(date?: string, options?: any): AxiosPromise<Array<StockOperationMinimalWithWarehouseDto>> {
            return localVarFp.apiStockOperationGetOrdersForYearGet(date, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiStockOperationIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationIdGet(id: number, options?: any): AxiosPromise<StockOperationDetailsDto> {
            return localVarFp.apiStockOperationIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {StockOperationUpdateDto} [stockOperationUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationIdPut(id: number, stockOperationUpdateDto?: StockOperationUpdateDto, options?: any): AxiosPromise<StockOperationDetailsDto> {
            return localVarFp.apiStockOperationIdPut(id, stockOperationUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {StockOperationStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationIdStatusPut(id: number, status?: StockOperationStatus, options?: any): AxiosPromise<StockOperationDetailsDto> {
            return localVarFp.apiStockOperationIdStatusPut(id, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationInvoicePreviewGet(id?: number, options?: any): AxiosPromise<InvoicePreviewDto> {
            return localVarFp.apiStockOperationInvoicePreviewGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationLatestDraftGet(options?: any): AxiosPromise<Array<StockOperationMinimalWithWarehouseDto>> {
            return localVarFp.apiStockOperationLatestDraftGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationLatestPublishedGet(options?: any): AxiosPromise<Array<StockOperationMinimalWithWarehouseDto>> {
            return localVarFp.apiStockOperationLatestPublishedGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationMinimalGet(options?: any): AxiosPromise<Array<StockOperationMinimalWithWarehouseDto>> {
            return localVarFp.apiStockOperationMinimalGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationMinimalIdGet(id: number, options?: any): AxiosPromise<StockOperationMinimalDto> {
            return localVarFp.apiStockOperationMinimalIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [date] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationOperationsForDateGet(date?: string, options?: any): AxiosPromise<Array<StockOperationMinimalWithWarehouseDto>> {
            return localVarFp.apiStockOperationOperationsForDateGet(date, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [date] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationOperationsForYearGet(date?: string, options?: any): AxiosPromise<Array<StockOperationMinimalWithWarehouseDto>> {
            return localVarFp.apiStockOperationOperationsForYearGet(date, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StockOperationCreateDto} [stockOperationCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationPost(stockOperationCreateDto?: StockOperationCreateDto, options?: any): AxiosPromise<StockOperationDetailsDto> {
            return localVarFp.apiStockOperationPost(stockOperationCreateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StockOperationCreateDto} [stockOperationCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationProductionStockOperationPost(stockOperationCreateDto?: StockOperationCreateDto, options?: any): AxiosPromise<StockOperationDto> {
            return localVarFp.apiStockOperationProductionStockOperationPost(stockOperationCreateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StockOperationStatus} [status] 
         * @param {Array<number>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationStatusesPut(status?: StockOperationStatus, requestBody?: Array<number>, options?: any): AxiosPromise<boolean> {
            return localVarFp.apiStockOperationStatusesPut(status, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [documentNumber] 
         * @param {number} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationValidateDocumentNumberGet(documentNumber?: string, id?: number, options?: any): AxiosPromise<boolean> {
            return localVarFp.apiStockOperationValidateDocumentNumberGet(documentNumber, id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StockOperationApi - object-oriented interface
 * @export
 * @class StockOperationApi
 * @extends {BaseAPI}
 */
export class StockOperationApi extends BaseAPI {
    /**
     * 
     * @param {number} [productId] 
     * @param {number} [warehouseId] 
     * @param {number} [stockOperationId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockOperationApi
     */
    public apiStockOperationBatchNumbersGet(productId?: number, warehouseId?: number, stockOperationId?: number, options?: any) {
        return StockOperationApiFp(this.configuration).apiStockOperationBatchNumbersGet(productId, warehouseId, stockOperationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} pipedriveDealId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockOperationApi
     */
    public apiStockOperationByPipedriveDealPipedriveDealIdGet(pipedriveDealId: number, options?: any) {
        return StockOperationApiFp(this.configuration).apiStockOperationByPipedriveDealPipedriveDealIdGet(pipedriveDealId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [date] 
     * @param {StockOperationType} [operationType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockOperationApi
     */
    public apiStockOperationDocumentNumberGet(date?: string, operationType?: StockOperationType, options?: any) {
        return StockOperationApiFp(this.configuration).apiStockOperationDocumentNumberGet(date, operationType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockOperationApi
     */
    public apiStockOperationGet(options?: any) {
        return StockOperationApiFp(this.configuration).apiStockOperationGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [date] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockOperationApi
     */
    public apiStockOperationGetOrdersForDateGet(date?: string, options?: any) {
        return StockOperationApiFp(this.configuration).apiStockOperationGetOrdersForDateGet(date, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [date] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockOperationApi
     */
    public apiStockOperationGetOrdersForYearGet(date?: string, options?: any) {
        return StockOperationApiFp(this.configuration).apiStockOperationGetOrdersForYearGet(date, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockOperationApi
     */
    public apiStockOperationIdDelete(id: number, options?: any) {
        return StockOperationApiFp(this.configuration).apiStockOperationIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockOperationApi
     */
    public apiStockOperationIdGet(id: number, options?: any) {
        return StockOperationApiFp(this.configuration).apiStockOperationIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {StockOperationUpdateDto} [stockOperationUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockOperationApi
     */
    public apiStockOperationIdPut(id: number, stockOperationUpdateDto?: StockOperationUpdateDto, options?: any) {
        return StockOperationApiFp(this.configuration).apiStockOperationIdPut(id, stockOperationUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {StockOperationStatus} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockOperationApi
     */
    public apiStockOperationIdStatusPut(id: number, status?: StockOperationStatus, options?: any) {
        return StockOperationApiFp(this.configuration).apiStockOperationIdStatusPut(id, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [id] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockOperationApi
     */
    public apiStockOperationInvoicePreviewGet(id?: number, options?: any) {
        return StockOperationApiFp(this.configuration).apiStockOperationInvoicePreviewGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockOperationApi
     */
    public apiStockOperationLatestDraftGet(options?: any) {
        return StockOperationApiFp(this.configuration).apiStockOperationLatestDraftGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockOperationApi
     */
    public apiStockOperationLatestPublishedGet(options?: any) {
        return StockOperationApiFp(this.configuration).apiStockOperationLatestPublishedGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockOperationApi
     */
    public apiStockOperationMinimalGet(options?: any) {
        return StockOperationApiFp(this.configuration).apiStockOperationMinimalGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockOperationApi
     */
    public apiStockOperationMinimalIdGet(id: number, options?: any) {
        return StockOperationApiFp(this.configuration).apiStockOperationMinimalIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [date] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockOperationApi
     */
    public apiStockOperationOperationsForDateGet(date?: string, options?: any) {
        return StockOperationApiFp(this.configuration).apiStockOperationOperationsForDateGet(date, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [date] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockOperationApi
     */
    public apiStockOperationOperationsForYearGet(date?: string, options?: any) {
        return StockOperationApiFp(this.configuration).apiStockOperationOperationsForYearGet(date, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StockOperationCreateDto} [stockOperationCreateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockOperationApi
     */
    public apiStockOperationPost(stockOperationCreateDto?: StockOperationCreateDto, options?: any) {
        return StockOperationApiFp(this.configuration).apiStockOperationPost(stockOperationCreateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StockOperationCreateDto} [stockOperationCreateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockOperationApi
     */
    public apiStockOperationProductionStockOperationPost(stockOperationCreateDto?: StockOperationCreateDto, options?: any) {
        return StockOperationApiFp(this.configuration).apiStockOperationProductionStockOperationPost(stockOperationCreateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StockOperationStatus} [status] 
     * @param {Array<number>} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockOperationApi
     */
    public apiStockOperationStatusesPut(status?: StockOperationStatus, requestBody?: Array<number>, options?: any) {
        return StockOperationApiFp(this.configuration).apiStockOperationStatusesPut(status, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [documentNumber] 
     * @param {number} [id] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockOperationApi
     */
    public apiStockOperationValidateDocumentNumberGet(documentNumber?: string, id?: number, options?: any) {
        return StockOperationApiFp(this.configuration).apiStockOperationValidateDocumentNumberGet(documentNumber, id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * StockOperationUpdateHistoryApi - axios parameter creator
 * @export
 */
export const StockOperationUpdateHistoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationUpdateHistoryGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/StockOperationUpdateHistory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationUpdateHistoryHistoryIdGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiStockOperationUpdateHistoryHistoryIdGet', 'id', id)
            const localVarPath = `/api/StockOperationUpdateHistory/history/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} batchNumber 
         * @param {number} [unitId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationUpdateHistoryHistoryProductIdBatchBatchNumberGet: async (id: number, batchNumber: string, unitId?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiStockOperationUpdateHistoryHistoryProductIdBatchBatchNumberGet', 'id', id)
            // verify required parameter 'batchNumber' is not null or undefined
            assertParamExists('apiStockOperationUpdateHistoryHistoryProductIdBatchBatchNumberGet', 'batchNumber', batchNumber)
            const localVarPath = `/api/StockOperationUpdateHistory/history/product/{id}/batch/{batchNumber}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"batchNumber"}}`, encodeURIComponent(String(batchNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (unitId !== undefined) {
                localVarQueryParameter['unitId'] = unitId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {number} warehouseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationUpdateHistoryHistoryProductIdReservationWarehouseIdGet: async (id: number, warehouseId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiStockOperationUpdateHistoryHistoryProductIdReservationWarehouseIdGet', 'id', id)
            // verify required parameter 'warehouseId' is not null or undefined
            assertParamExists('apiStockOperationUpdateHistoryHistoryProductIdReservationWarehouseIdGet', 'warehouseId', warehouseId)
            const localVarPath = `/api/StockOperationUpdateHistory/history/product/{id}/reservation/{warehouseId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"warehouseId"}}`, encodeURIComponent(String(warehouseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {number} warehouseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationUpdateHistoryHistoryProductIdWarehouseIdGet: async (id: number, warehouseId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiStockOperationUpdateHistoryHistoryProductIdWarehouseIdGet', 'id', id)
            // verify required parameter 'warehouseId' is not null or undefined
            assertParamExists('apiStockOperationUpdateHistoryHistoryProductIdWarehouseIdGet', 'warehouseId', warehouseId)
            const localVarPath = `/api/StockOperationUpdateHistory/history/product/{id}/{warehouseId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"warehouseId"}}`, encodeURIComponent(String(warehouseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationUpdateHistoryIdDelete: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiStockOperationUpdateHistoryIdDelete', 'id', id)
            const localVarPath = `/api/StockOperationUpdateHistory/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationUpdateHistoryIdGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiStockOperationUpdateHistoryIdGet', 'id', id)
            const localVarPath = `/api/StockOperationUpdateHistory/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {StockOperationUpdateHistoryUpdateDto} [stockOperationUpdateHistoryUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationUpdateHistoryIdPut: async (id: number, stockOperationUpdateHistoryUpdateDto?: StockOperationUpdateHistoryUpdateDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiStockOperationUpdateHistoryIdPut', 'id', id)
            const localVarPath = `/api/StockOperationUpdateHistory/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(stockOperationUpdateHistoryUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {StockOperationUpdateHistoryCreateDto} [stockOperationUpdateHistoryCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationUpdateHistoryPost: async (stockOperationUpdateHistoryCreateDto?: StockOperationUpdateHistoryCreateDto, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/StockOperationUpdateHistory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(stockOperationUpdateHistoryCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StockOperationUpdateHistoryApi - functional programming interface
 * @export
 */
export const StockOperationUpdateHistoryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StockOperationUpdateHistoryApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStockOperationUpdateHistoryGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StockOperationUpdateHistoryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStockOperationUpdateHistoryGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStockOperationUpdateHistoryHistoryIdGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StockOperationUpdateHistoryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStockOperationUpdateHistoryHistoryIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {string} batchNumber 
         * @param {number} [unitId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStockOperationUpdateHistoryHistoryProductIdBatchBatchNumberGet(id: number, batchNumber: string, unitId?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StockHistoryMinimalDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStockOperationUpdateHistoryHistoryProductIdBatchBatchNumberGet(id, batchNumber, unitId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {number} warehouseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStockOperationUpdateHistoryHistoryProductIdReservationWarehouseIdGet(id: number, warehouseId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StockOperationUpdateHistoryDetailsDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStockOperationUpdateHistoryHistoryProductIdReservationWarehouseIdGet(id, warehouseId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {number} warehouseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStockOperationUpdateHistoryHistoryProductIdWarehouseIdGet(id: number, warehouseId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StockHistoryMinimalDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStockOperationUpdateHistoryHistoryProductIdWarehouseIdGet(id, warehouseId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStockOperationUpdateHistoryIdDelete(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStockOperationUpdateHistoryIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStockOperationUpdateHistoryIdGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StockOperationUpdateHistoryDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStockOperationUpdateHistoryIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {StockOperationUpdateHistoryUpdateDto} [stockOperationUpdateHistoryUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStockOperationUpdateHistoryIdPut(id: number, stockOperationUpdateHistoryUpdateDto?: StockOperationUpdateHistoryUpdateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StockOperationUpdateHistoryDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStockOperationUpdateHistoryIdPut(id, stockOperationUpdateHistoryUpdateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {StockOperationUpdateHistoryCreateDto} [stockOperationUpdateHistoryCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStockOperationUpdateHistoryPost(stockOperationUpdateHistoryCreateDto?: StockOperationUpdateHistoryCreateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StockOperationUpdateHistoryDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStockOperationUpdateHistoryPost(stockOperationUpdateHistoryCreateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * StockOperationUpdateHistoryApi - factory interface
 * @export
 */
export const StockOperationUpdateHistoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StockOperationUpdateHistoryApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationUpdateHistoryGet(options?: any): AxiosPromise<Array<StockOperationUpdateHistoryDto>> {
            return localVarFp.apiStockOperationUpdateHistoryGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationUpdateHistoryHistoryIdGet(id: number, options?: any): AxiosPromise<Array<StockOperationUpdateHistoryDto>> {
            return localVarFp.apiStockOperationUpdateHistoryHistoryIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {string} batchNumber 
         * @param {number} [unitId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationUpdateHistoryHistoryProductIdBatchBatchNumberGet(id: number, batchNumber: string, unitId?: number, options?: any): AxiosPromise<Array<StockHistoryMinimalDto>> {
            return localVarFp.apiStockOperationUpdateHistoryHistoryProductIdBatchBatchNumberGet(id, batchNumber, unitId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {number} warehouseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationUpdateHistoryHistoryProductIdReservationWarehouseIdGet(id: number, warehouseId: number, options?: any): AxiosPromise<Array<StockOperationUpdateHistoryDetailsDto>> {
            return localVarFp.apiStockOperationUpdateHistoryHistoryProductIdReservationWarehouseIdGet(id, warehouseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {number} warehouseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationUpdateHistoryHistoryProductIdWarehouseIdGet(id: number, warehouseId: number, options?: any): AxiosPromise<Array<StockHistoryMinimalDto>> {
            return localVarFp.apiStockOperationUpdateHistoryHistoryProductIdWarehouseIdGet(id, warehouseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationUpdateHistoryIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiStockOperationUpdateHistoryIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationUpdateHistoryIdGet(id: number, options?: any): AxiosPromise<StockOperationUpdateHistoryDetailsDto> {
            return localVarFp.apiStockOperationUpdateHistoryIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {StockOperationUpdateHistoryUpdateDto} [stockOperationUpdateHistoryUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationUpdateHistoryIdPut(id: number, stockOperationUpdateHistoryUpdateDto?: StockOperationUpdateHistoryUpdateDto, options?: any): AxiosPromise<StockOperationUpdateHistoryDetailsDto> {
            return localVarFp.apiStockOperationUpdateHistoryIdPut(id, stockOperationUpdateHistoryUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StockOperationUpdateHistoryCreateDto} [stockOperationUpdateHistoryCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationUpdateHistoryPost(stockOperationUpdateHistoryCreateDto?: StockOperationUpdateHistoryCreateDto, options?: any): AxiosPromise<StockOperationUpdateHistoryDetailsDto> {
            return localVarFp.apiStockOperationUpdateHistoryPost(stockOperationUpdateHistoryCreateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StockOperationUpdateHistoryApi - object-oriented interface
 * @export
 * @class StockOperationUpdateHistoryApi
 * @extends {BaseAPI}
 */
export class StockOperationUpdateHistoryApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockOperationUpdateHistoryApi
     */
    public apiStockOperationUpdateHistoryGet(options?: any) {
        return StockOperationUpdateHistoryApiFp(this.configuration).apiStockOperationUpdateHistoryGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockOperationUpdateHistoryApi
     */
    public apiStockOperationUpdateHistoryHistoryIdGet(id: number, options?: any) {
        return StockOperationUpdateHistoryApiFp(this.configuration).apiStockOperationUpdateHistoryHistoryIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {string} batchNumber 
     * @param {number} [unitId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockOperationUpdateHistoryApi
     */
    public apiStockOperationUpdateHistoryHistoryProductIdBatchBatchNumberGet(id: number, batchNumber: string, unitId?: number, options?: any) {
        return StockOperationUpdateHistoryApiFp(this.configuration).apiStockOperationUpdateHistoryHistoryProductIdBatchBatchNumberGet(id, batchNumber, unitId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {number} warehouseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockOperationUpdateHistoryApi
     */
    public apiStockOperationUpdateHistoryHistoryProductIdReservationWarehouseIdGet(id: number, warehouseId: number, options?: any) {
        return StockOperationUpdateHistoryApiFp(this.configuration).apiStockOperationUpdateHistoryHistoryProductIdReservationWarehouseIdGet(id, warehouseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {number} warehouseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockOperationUpdateHistoryApi
     */
    public apiStockOperationUpdateHistoryHistoryProductIdWarehouseIdGet(id: number, warehouseId: number, options?: any) {
        return StockOperationUpdateHistoryApiFp(this.configuration).apiStockOperationUpdateHistoryHistoryProductIdWarehouseIdGet(id, warehouseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockOperationUpdateHistoryApi
     */
    public apiStockOperationUpdateHistoryIdDelete(id: number, options?: any) {
        return StockOperationUpdateHistoryApiFp(this.configuration).apiStockOperationUpdateHistoryIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockOperationUpdateHistoryApi
     */
    public apiStockOperationUpdateHistoryIdGet(id: number, options?: any) {
        return StockOperationUpdateHistoryApiFp(this.configuration).apiStockOperationUpdateHistoryIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {StockOperationUpdateHistoryUpdateDto} [stockOperationUpdateHistoryUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockOperationUpdateHistoryApi
     */
    public apiStockOperationUpdateHistoryIdPut(id: number, stockOperationUpdateHistoryUpdateDto?: StockOperationUpdateHistoryUpdateDto, options?: any) {
        return StockOperationUpdateHistoryApiFp(this.configuration).apiStockOperationUpdateHistoryIdPut(id, stockOperationUpdateHistoryUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StockOperationUpdateHistoryCreateDto} [stockOperationUpdateHistoryCreateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockOperationUpdateHistoryApi
     */
    public apiStockOperationUpdateHistoryPost(stockOperationUpdateHistoryCreateDto?: StockOperationUpdateHistoryCreateDto, options?: any) {
        return StockOperationUpdateHistoryApiFp(this.configuration).apiStockOperationUpdateHistoryPost(stockOperationUpdateHistoryCreateDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * StrainApi - axios parameter creator
 * @export
 */
export const StrainApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStrainGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Strain`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStrainIdDelete: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiStrainIdDelete', 'id', id)
            const localVarPath = `/api/Strain/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStrainIdGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiStrainIdGet', 'id', id)
            const localVarPath = `/api/Strain/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {StrainUpdateDto} [strainUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStrainIdPut: async (id: number, strainUpdateDto?: StrainUpdateDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiStrainIdPut', 'id', id)
            const localVarPath = `/api/Strain/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(strainUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {StrainCreateDto} [strainCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStrainPost: async (strainCreateDto?: StrainCreateDto, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Strain`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(strainCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StrainApi - functional programming interface
 * @export
 */
export const StrainApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StrainApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStrainGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StrainDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStrainGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStrainIdDelete(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStrainIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStrainIdGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StrainDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStrainIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {StrainUpdateDto} [strainUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStrainIdPut(id: number, strainUpdateDto?: StrainUpdateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StrainDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStrainIdPut(id, strainUpdateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {StrainCreateDto} [strainCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStrainPost(strainCreateDto?: StrainCreateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StrainDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStrainPost(strainCreateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * StrainApi - factory interface
 * @export
 */
export const StrainApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StrainApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStrainGet(options?: any): AxiosPromise<Array<StrainDto>> {
            return localVarFp.apiStrainGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStrainIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiStrainIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStrainIdGet(id: number, options?: any): AxiosPromise<StrainDetailsDto> {
            return localVarFp.apiStrainIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {StrainUpdateDto} [strainUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStrainIdPut(id: number, strainUpdateDto?: StrainUpdateDto, options?: any): AxiosPromise<StrainDetailsDto> {
            return localVarFp.apiStrainIdPut(id, strainUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StrainCreateDto} [strainCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStrainPost(strainCreateDto?: StrainCreateDto, options?: any): AxiosPromise<StrainDetailsDto> {
            return localVarFp.apiStrainPost(strainCreateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StrainApi - object-oriented interface
 * @export
 * @class StrainApi
 * @extends {BaseAPI}
 */
export class StrainApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StrainApi
     */
    public apiStrainGet(options?: any) {
        return StrainApiFp(this.configuration).apiStrainGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StrainApi
     */
    public apiStrainIdDelete(id: number, options?: any) {
        return StrainApiFp(this.configuration).apiStrainIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StrainApi
     */
    public apiStrainIdGet(id: number, options?: any) {
        return StrainApiFp(this.configuration).apiStrainIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {StrainUpdateDto} [strainUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StrainApi
     */
    public apiStrainIdPut(id: number, strainUpdateDto?: StrainUpdateDto, options?: any) {
        return StrainApiFp(this.configuration).apiStrainIdPut(id, strainUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StrainCreateDto} [strainCreateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StrainApi
     */
    public apiStrainPost(strainCreateDto?: StrainCreateDto, options?: any) {
        return StrainApiFp(this.configuration).apiStrainPost(strainCreateDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UnitOfMeasureApi - axios parameter creator
 * @export
 */
export const UnitOfMeasureApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} baseUnitId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUnitOfMeasureAuxiliaryUnitsBaseUnitIdGet: async (baseUnitId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'baseUnitId' is not null or undefined
            assertParamExists('apiUnitOfMeasureAuxiliaryUnitsBaseUnitIdGet', 'baseUnitId', baseUnitId)
            const localVarPath = `/api/UnitOfMeasure/auxiliaryUnits/{baseUnitId}`
                .replace(`{${"baseUnitId"}}`, encodeURIComponent(String(baseUnitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUnitOfMeasureBaseUnitsGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/UnitOfMeasure/baseUnits`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUnitOfMeasureGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/UnitOfMeasure`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUnitOfMeasureIdDelete: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiUnitOfMeasureIdDelete', 'id', id)
            const localVarPath = `/api/UnitOfMeasure/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUnitOfMeasureIdGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiUnitOfMeasureIdGet', 'id', id)
            const localVarPath = `/api/UnitOfMeasure/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {UnitOfMeasureUpdateDto} [unitOfMeasureUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUnitOfMeasureIdPut: async (id: number, unitOfMeasureUpdateDto?: UnitOfMeasureUpdateDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiUnitOfMeasureIdPut', 'id', id)
            const localVarPath = `/api/UnitOfMeasure/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(unitOfMeasureUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UnitOfMeasureCreateDto} [unitOfMeasureCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUnitOfMeasurePost: async (unitOfMeasureCreateDto?: UnitOfMeasureCreateDto, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/UnitOfMeasure`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(unitOfMeasureCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UnitOfMeasureApi - functional programming interface
 * @export
 */
export const UnitOfMeasureApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UnitOfMeasureApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} baseUnitId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUnitOfMeasureAuxiliaryUnitsBaseUnitIdGet(baseUnitId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UnitOfMeasureDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUnitOfMeasureAuxiliaryUnitsBaseUnitIdGet(baseUnitId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUnitOfMeasureBaseUnitsGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UnitOfMeasureDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUnitOfMeasureBaseUnitsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUnitOfMeasureGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UnitOfMeasureDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUnitOfMeasureGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUnitOfMeasureIdDelete(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUnitOfMeasureIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUnitOfMeasureIdGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnitOfMeasureDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUnitOfMeasureIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {UnitOfMeasureUpdateDto} [unitOfMeasureUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUnitOfMeasureIdPut(id: number, unitOfMeasureUpdateDto?: UnitOfMeasureUpdateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnitOfMeasureDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUnitOfMeasureIdPut(id, unitOfMeasureUpdateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UnitOfMeasureCreateDto} [unitOfMeasureCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUnitOfMeasurePost(unitOfMeasureCreateDto?: UnitOfMeasureCreateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnitOfMeasureDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUnitOfMeasurePost(unitOfMeasureCreateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UnitOfMeasureApi - factory interface
 * @export
 */
export const UnitOfMeasureApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UnitOfMeasureApiFp(configuration)
    return {
        /**
         * 
         * @param {number} baseUnitId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUnitOfMeasureAuxiliaryUnitsBaseUnitIdGet(baseUnitId: number, options?: any): AxiosPromise<Array<UnitOfMeasureDto>> {
            return localVarFp.apiUnitOfMeasureAuxiliaryUnitsBaseUnitIdGet(baseUnitId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUnitOfMeasureBaseUnitsGet(options?: any): AxiosPromise<Array<UnitOfMeasureDto>> {
            return localVarFp.apiUnitOfMeasureBaseUnitsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUnitOfMeasureGet(options?: any): AxiosPromise<Array<UnitOfMeasureDto>> {
            return localVarFp.apiUnitOfMeasureGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUnitOfMeasureIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiUnitOfMeasureIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUnitOfMeasureIdGet(id: number, options?: any): AxiosPromise<UnitOfMeasureDetailsDto> {
            return localVarFp.apiUnitOfMeasureIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {UnitOfMeasureUpdateDto} [unitOfMeasureUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUnitOfMeasureIdPut(id: number, unitOfMeasureUpdateDto?: UnitOfMeasureUpdateDto, options?: any): AxiosPromise<UnitOfMeasureDetailsDto> {
            return localVarFp.apiUnitOfMeasureIdPut(id, unitOfMeasureUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UnitOfMeasureCreateDto} [unitOfMeasureCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUnitOfMeasurePost(unitOfMeasureCreateDto?: UnitOfMeasureCreateDto, options?: any): AxiosPromise<UnitOfMeasureDetailsDto> {
            return localVarFp.apiUnitOfMeasurePost(unitOfMeasureCreateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UnitOfMeasureApi - object-oriented interface
 * @export
 * @class UnitOfMeasureApi
 * @extends {BaseAPI}
 */
export class UnitOfMeasureApi extends BaseAPI {
    /**
     * 
     * @param {number} baseUnitId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnitOfMeasureApi
     */
    public apiUnitOfMeasureAuxiliaryUnitsBaseUnitIdGet(baseUnitId: number, options?: any) {
        return UnitOfMeasureApiFp(this.configuration).apiUnitOfMeasureAuxiliaryUnitsBaseUnitIdGet(baseUnitId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnitOfMeasureApi
     */
    public apiUnitOfMeasureBaseUnitsGet(options?: any) {
        return UnitOfMeasureApiFp(this.configuration).apiUnitOfMeasureBaseUnitsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnitOfMeasureApi
     */
    public apiUnitOfMeasureGet(options?: any) {
        return UnitOfMeasureApiFp(this.configuration).apiUnitOfMeasureGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnitOfMeasureApi
     */
    public apiUnitOfMeasureIdDelete(id: number, options?: any) {
        return UnitOfMeasureApiFp(this.configuration).apiUnitOfMeasureIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnitOfMeasureApi
     */
    public apiUnitOfMeasureIdGet(id: number, options?: any) {
        return UnitOfMeasureApiFp(this.configuration).apiUnitOfMeasureIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {UnitOfMeasureUpdateDto} [unitOfMeasureUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnitOfMeasureApi
     */
    public apiUnitOfMeasureIdPut(id: number, unitOfMeasureUpdateDto?: UnitOfMeasureUpdateDto, options?: any) {
        return UnitOfMeasureApiFp(this.configuration).apiUnitOfMeasureIdPut(id, unitOfMeasureUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UnitOfMeasureCreateDto} [unitOfMeasureCreateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnitOfMeasureApi
     */
    public apiUnitOfMeasurePost(unitOfMeasureCreateDto?: UnitOfMeasureCreateDto, options?: any) {
        return UnitOfMeasureApiFp(this.configuration).apiUnitOfMeasurePost(unitOfMeasureCreateDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * VinificationAdditiveApi - axios parameter creator
 * @export
 */
export const VinificationAdditiveApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVinificationAdditiveGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/VinificationAdditive`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVinificationAdditiveIdDelete: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiVinificationAdditiveIdDelete', 'id', id)
            const localVarPath = `/api/VinificationAdditive/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVinificationAdditiveIdGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiVinificationAdditiveIdGet', 'id', id)
            const localVarPath = `/api/VinificationAdditive/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {VinificationAdditiveUpdateDto} [vinificationAdditiveUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVinificationAdditiveIdPut: async (id: number, vinificationAdditiveUpdateDto?: VinificationAdditiveUpdateDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiVinificationAdditiveIdPut', 'id', id)
            const localVarPath = `/api/VinificationAdditive/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(vinificationAdditiveUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {VinificationAdditiveCreateDto} [vinificationAdditiveCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVinificationAdditivePost: async (vinificationAdditiveCreateDto?: VinificationAdditiveCreateDto, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/VinificationAdditive`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(vinificationAdditiveCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VinificationAdditiveApi - functional programming interface
 * @export
 */
export const VinificationAdditiveApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VinificationAdditiveApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVinificationAdditiveGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VinificationAdditiveDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVinificationAdditiveGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVinificationAdditiveIdDelete(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVinificationAdditiveIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVinificationAdditiveIdGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VinificationAdditiveDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVinificationAdditiveIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {VinificationAdditiveUpdateDto} [vinificationAdditiveUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVinificationAdditiveIdPut(id: number, vinificationAdditiveUpdateDto?: VinificationAdditiveUpdateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VinificationAdditiveDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVinificationAdditiveIdPut(id, vinificationAdditiveUpdateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {VinificationAdditiveCreateDto} [vinificationAdditiveCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVinificationAdditivePost(vinificationAdditiveCreateDto?: VinificationAdditiveCreateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VinificationAdditiveDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVinificationAdditivePost(vinificationAdditiveCreateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * VinificationAdditiveApi - factory interface
 * @export
 */
export const VinificationAdditiveApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VinificationAdditiveApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVinificationAdditiveGet(options?: any): AxiosPromise<Array<VinificationAdditiveDto>> {
            return localVarFp.apiVinificationAdditiveGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVinificationAdditiveIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiVinificationAdditiveIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVinificationAdditiveIdGet(id: number, options?: any): AxiosPromise<VinificationAdditiveDetailsDto> {
            return localVarFp.apiVinificationAdditiveIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {VinificationAdditiveUpdateDto} [vinificationAdditiveUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVinificationAdditiveIdPut(id: number, vinificationAdditiveUpdateDto?: VinificationAdditiveUpdateDto, options?: any): AxiosPromise<VinificationAdditiveDetailsDto> {
            return localVarFp.apiVinificationAdditiveIdPut(id, vinificationAdditiveUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VinificationAdditiveCreateDto} [vinificationAdditiveCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVinificationAdditivePost(vinificationAdditiveCreateDto?: VinificationAdditiveCreateDto, options?: any): AxiosPromise<VinificationAdditiveDetailsDto> {
            return localVarFp.apiVinificationAdditivePost(vinificationAdditiveCreateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VinificationAdditiveApi - object-oriented interface
 * @export
 * @class VinificationAdditiveApi
 * @extends {BaseAPI}
 */
export class VinificationAdditiveApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VinificationAdditiveApi
     */
    public apiVinificationAdditiveGet(options?: any) {
        return VinificationAdditiveApiFp(this.configuration).apiVinificationAdditiveGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VinificationAdditiveApi
     */
    public apiVinificationAdditiveIdDelete(id: number, options?: any) {
        return VinificationAdditiveApiFp(this.configuration).apiVinificationAdditiveIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VinificationAdditiveApi
     */
    public apiVinificationAdditiveIdGet(id: number, options?: any) {
        return VinificationAdditiveApiFp(this.configuration).apiVinificationAdditiveIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {VinificationAdditiveUpdateDto} [vinificationAdditiveUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VinificationAdditiveApi
     */
    public apiVinificationAdditiveIdPut(id: number, vinificationAdditiveUpdateDto?: VinificationAdditiveUpdateDto, options?: any) {
        return VinificationAdditiveApiFp(this.configuration).apiVinificationAdditiveIdPut(id, vinificationAdditiveUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VinificationAdditiveCreateDto} [vinificationAdditiveCreateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VinificationAdditiveApi
     */
    public apiVinificationAdditivePost(vinificationAdditiveCreateDto?: VinificationAdditiveCreateDto, options?: any) {
        return VinificationAdditiveApiFp(this.configuration).apiVinificationAdditivePost(vinificationAdditiveCreateDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * WarehouseApi - axios parameter creator
 * @export
 */
export const WarehouseApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWarehouseGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Warehouse`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWarehouseIdDelete: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiWarehouseIdDelete', 'id', id)
            const localVarPath = `/api/Warehouse/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWarehouseIdGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiWarehouseIdGet', 'id', id)
            const localVarPath = `/api/Warehouse/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {WarehouseUpdateDto} [warehouseUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWarehouseIdPut: async (id: number, warehouseUpdateDto?: WarehouseUpdateDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiWarehouseIdPut', 'id', id)
            const localVarPath = `/api/Warehouse/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(warehouseUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWarehouseParentWarehousesGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Warehouse/parentWarehouses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {WarehouseCreateDto} [warehouseCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWarehousePost: async (warehouseCreateDto?: WarehouseCreateDto, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Warehouse`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(warehouseCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} warehouseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWarehouseSubWarehousesWarehouseIdGet: async (warehouseId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'warehouseId' is not null or undefined
            assertParamExists('apiWarehouseSubWarehousesWarehouseIdGet', 'warehouseId', warehouseId)
            const localVarPath = `/api/Warehouse/subWarehouses/{warehouseId}`
                .replace(`{${"warehouseId"}}`, encodeURIComponent(String(warehouseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WarehouseApi - functional programming interface
 * @export
 */
export const WarehouseApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WarehouseApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiWarehouseGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WarehouseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiWarehouseGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiWarehouseIdDelete(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiWarehouseIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiWarehouseIdGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WarehouseDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiWarehouseIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {WarehouseUpdateDto} [warehouseUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiWarehouseIdPut(id: number, warehouseUpdateDto?: WarehouseUpdateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WarehouseDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiWarehouseIdPut(id, warehouseUpdateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiWarehouseParentWarehousesGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WarehouseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiWarehouseParentWarehousesGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {WarehouseCreateDto} [warehouseCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiWarehousePost(warehouseCreateDto?: WarehouseCreateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WarehouseDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiWarehousePost(warehouseCreateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} warehouseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiWarehouseSubWarehousesWarehouseIdGet(warehouseId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WarehouseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiWarehouseSubWarehousesWarehouseIdGet(warehouseId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * WarehouseApi - factory interface
 * @export
 */
export const WarehouseApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WarehouseApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWarehouseGet(options?: any): AxiosPromise<Array<WarehouseDto>> {
            return localVarFp.apiWarehouseGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWarehouseIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiWarehouseIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWarehouseIdGet(id: number, options?: any): AxiosPromise<WarehouseDetailsDto> {
            return localVarFp.apiWarehouseIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {WarehouseUpdateDto} [warehouseUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWarehouseIdPut(id: number, warehouseUpdateDto?: WarehouseUpdateDto, options?: any): AxiosPromise<WarehouseDetailsDto> {
            return localVarFp.apiWarehouseIdPut(id, warehouseUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWarehouseParentWarehousesGet(options?: any): AxiosPromise<Array<WarehouseDto>> {
            return localVarFp.apiWarehouseParentWarehousesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WarehouseCreateDto} [warehouseCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWarehousePost(warehouseCreateDto?: WarehouseCreateDto, options?: any): AxiosPromise<WarehouseDetailsDto> {
            return localVarFp.apiWarehousePost(warehouseCreateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} warehouseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWarehouseSubWarehousesWarehouseIdGet(warehouseId: number, options?: any): AxiosPromise<Array<WarehouseDto>> {
            return localVarFp.apiWarehouseSubWarehousesWarehouseIdGet(warehouseId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WarehouseApi - object-oriented interface
 * @export
 * @class WarehouseApi
 * @extends {BaseAPI}
 */
export class WarehouseApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WarehouseApi
     */
    public apiWarehouseGet(options?: any) {
        return WarehouseApiFp(this.configuration).apiWarehouseGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WarehouseApi
     */
    public apiWarehouseIdDelete(id: number, options?: any) {
        return WarehouseApiFp(this.configuration).apiWarehouseIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WarehouseApi
     */
    public apiWarehouseIdGet(id: number, options?: any) {
        return WarehouseApiFp(this.configuration).apiWarehouseIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {WarehouseUpdateDto} [warehouseUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WarehouseApi
     */
    public apiWarehouseIdPut(id: number, warehouseUpdateDto?: WarehouseUpdateDto, options?: any) {
        return WarehouseApiFp(this.configuration).apiWarehouseIdPut(id, warehouseUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WarehouseApi
     */
    public apiWarehouseParentWarehousesGet(options?: any) {
        return WarehouseApiFp(this.configuration).apiWarehouseParentWarehousesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WarehouseCreateDto} [warehouseCreateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WarehouseApi
     */
    public apiWarehousePost(warehouseCreateDto?: WarehouseCreateDto, options?: any) {
        return WarehouseApiFp(this.configuration).apiWarehousePost(warehouseCreateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} warehouseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WarehouseApi
     */
    public apiWarehouseSubWarehousesWarehouseIdGet(warehouseId: number, options?: any) {
        return WarehouseApiFp(this.configuration).apiWarehouseSubWarehousesWarehouseIdGet(warehouseId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * WarehouseUpdateHistoryApi - axios parameter creator
 * @export
 */
export const WarehouseUpdateHistoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWarehouseUpdateHistoryGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/WarehouseUpdateHistory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} warehouseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWarehouseUpdateHistoryHistoryWarehouseIdGet: async (warehouseId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'warehouseId' is not null or undefined
            assertParamExists('apiWarehouseUpdateHistoryHistoryWarehouseIdGet', 'warehouseId', warehouseId)
            const localVarPath = `/api/WarehouseUpdateHistory/history/{warehouseId}`
                .replace(`{${"warehouseId"}}`, encodeURIComponent(String(warehouseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWarehouseUpdateHistoryIdDelete: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiWarehouseUpdateHistoryIdDelete', 'id', id)
            const localVarPath = `/api/WarehouseUpdateHistory/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWarehouseUpdateHistoryIdGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiWarehouseUpdateHistoryIdGet', 'id', id)
            const localVarPath = `/api/WarehouseUpdateHistory/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {WarehouseUpdateHistoryUpdateDto} [warehouseUpdateHistoryUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWarehouseUpdateHistoryIdPut: async (id: number, warehouseUpdateHistoryUpdateDto?: WarehouseUpdateHistoryUpdateDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiWarehouseUpdateHistoryIdPut', 'id', id)
            const localVarPath = `/api/WarehouseUpdateHistory/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(warehouseUpdateHistoryUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {WarehouseUpdateHistoryCreateDto} [warehouseUpdateHistoryCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWarehouseUpdateHistoryPost: async (warehouseUpdateHistoryCreateDto?: WarehouseUpdateHistoryCreateDto, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/WarehouseUpdateHistory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(warehouseUpdateHistoryCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WarehouseUpdateHistoryApi - functional programming interface
 * @export
 */
export const WarehouseUpdateHistoryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WarehouseUpdateHistoryApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiWarehouseUpdateHistoryGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WarehouseUpdateHistoryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiWarehouseUpdateHistoryGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} warehouseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiWarehouseUpdateHistoryHistoryWarehouseIdGet(warehouseId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WarehouseUpdateHistoryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiWarehouseUpdateHistoryHistoryWarehouseIdGet(warehouseId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiWarehouseUpdateHistoryIdDelete(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiWarehouseUpdateHistoryIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiWarehouseUpdateHistoryIdGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WarehouseUpdateHistoryDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiWarehouseUpdateHistoryIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {WarehouseUpdateHistoryUpdateDto} [warehouseUpdateHistoryUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiWarehouseUpdateHistoryIdPut(id: number, warehouseUpdateHistoryUpdateDto?: WarehouseUpdateHistoryUpdateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WarehouseUpdateHistoryDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiWarehouseUpdateHistoryIdPut(id, warehouseUpdateHistoryUpdateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {WarehouseUpdateHistoryCreateDto} [warehouseUpdateHistoryCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiWarehouseUpdateHistoryPost(warehouseUpdateHistoryCreateDto?: WarehouseUpdateHistoryCreateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WarehouseUpdateHistoryDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiWarehouseUpdateHistoryPost(warehouseUpdateHistoryCreateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * WarehouseUpdateHistoryApi - factory interface
 * @export
 */
export const WarehouseUpdateHistoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WarehouseUpdateHistoryApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWarehouseUpdateHistoryGet(options?: any): AxiosPromise<Array<WarehouseUpdateHistoryDto>> {
            return localVarFp.apiWarehouseUpdateHistoryGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} warehouseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWarehouseUpdateHistoryHistoryWarehouseIdGet(warehouseId: number, options?: any): AxiosPromise<Array<WarehouseUpdateHistoryDto>> {
            return localVarFp.apiWarehouseUpdateHistoryHistoryWarehouseIdGet(warehouseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWarehouseUpdateHistoryIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiWarehouseUpdateHistoryIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWarehouseUpdateHistoryIdGet(id: number, options?: any): AxiosPromise<WarehouseUpdateHistoryDetailsDto> {
            return localVarFp.apiWarehouseUpdateHistoryIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {WarehouseUpdateHistoryUpdateDto} [warehouseUpdateHistoryUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWarehouseUpdateHistoryIdPut(id: number, warehouseUpdateHistoryUpdateDto?: WarehouseUpdateHistoryUpdateDto, options?: any): AxiosPromise<WarehouseUpdateHistoryDetailsDto> {
            return localVarFp.apiWarehouseUpdateHistoryIdPut(id, warehouseUpdateHistoryUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WarehouseUpdateHistoryCreateDto} [warehouseUpdateHistoryCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWarehouseUpdateHistoryPost(warehouseUpdateHistoryCreateDto?: WarehouseUpdateHistoryCreateDto, options?: any): AxiosPromise<WarehouseUpdateHistoryDetailsDto> {
            return localVarFp.apiWarehouseUpdateHistoryPost(warehouseUpdateHistoryCreateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WarehouseUpdateHistoryApi - object-oriented interface
 * @export
 * @class WarehouseUpdateHistoryApi
 * @extends {BaseAPI}
 */
export class WarehouseUpdateHistoryApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WarehouseUpdateHistoryApi
     */
    public apiWarehouseUpdateHistoryGet(options?: any) {
        return WarehouseUpdateHistoryApiFp(this.configuration).apiWarehouseUpdateHistoryGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} warehouseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WarehouseUpdateHistoryApi
     */
    public apiWarehouseUpdateHistoryHistoryWarehouseIdGet(warehouseId: number, options?: any) {
        return WarehouseUpdateHistoryApiFp(this.configuration).apiWarehouseUpdateHistoryHistoryWarehouseIdGet(warehouseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WarehouseUpdateHistoryApi
     */
    public apiWarehouseUpdateHistoryIdDelete(id: number, options?: any) {
        return WarehouseUpdateHistoryApiFp(this.configuration).apiWarehouseUpdateHistoryIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WarehouseUpdateHistoryApi
     */
    public apiWarehouseUpdateHistoryIdGet(id: number, options?: any) {
        return WarehouseUpdateHistoryApiFp(this.configuration).apiWarehouseUpdateHistoryIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {WarehouseUpdateHistoryUpdateDto} [warehouseUpdateHistoryUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WarehouseUpdateHistoryApi
     */
    public apiWarehouseUpdateHistoryIdPut(id: number, warehouseUpdateHistoryUpdateDto?: WarehouseUpdateHistoryUpdateDto, options?: any) {
        return WarehouseUpdateHistoryApiFp(this.configuration).apiWarehouseUpdateHistoryIdPut(id, warehouseUpdateHistoryUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WarehouseUpdateHistoryCreateDto} [warehouseUpdateHistoryCreateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WarehouseUpdateHistoryApi
     */
    public apiWarehouseUpdateHistoryPost(warehouseUpdateHistoryCreateDto?: WarehouseUpdateHistoryCreateDto, options?: any) {
        return WarehouseUpdateHistoryApiFp(this.configuration).apiWarehouseUpdateHistoryPost(warehouseUpdateHistoryCreateDto, options).then((request) => request(this.axios, this.basePath));
    }
}


